<div class="header bg-gradient-danger pb-1 pt-5 pt-md-8">
  <div class="container-fluid">
    <div class="header-body"></div>
  </div>
</div>

<div class="container" style="margin-top: -4.1em">
  <!-- Icons is Used as Admin  -->
  <mat-tab-group dynamicHeight [preserveContent]="true" [(selectedIndex)]="demo1TabIndex" (selectedTabChange)="onTabClick($event)">
    <mat-tab label>
      <ng-template mat-tab-label> 1<br>
        Manage Book<br>
      </ng-template>
      <ng-template matTabContent>
      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important">
        <div style="margin-top: 20px">
          <div class="text-center">
            <h1 style="font-size: medium; font-weight: bold">Add New Book</h1>
          </div>

          <!-- Toggle Buttons for Book/Granth Selection -->
          <div class="form-row" style="margin-left: 30px; margin-top: 20px; margin-bottom: 10px;">
            <mat-radio-group [(ngModel)]="entryType" (change)="onEntryTypeChange()">
              <mat-radio-button value="book" style="margin-right: 30px;">Book</mat-radio-button>
              <mat-radio-button value="granth">Granth</mat-radio-button>
            </mat-radio-group>
          </div>

          <form class="form" [formGroup]="BookForm" (ngSubmit)="save()">
            <!-- Row 1 -->
            <div class="form-row">
              <!-- Show Book Name field only when Book is selected -->
              <mat-form-field *ngIf="entryType === 'book'" appearance="outline" class="example-full-width"
                style="width: 30%; margin-left: 30px; margin-top: 20px">
                <mat-label>Book Name</mat-label>
                <input matInput formControlName="bookname" [matAutocomplete]="autobooknameee" />
                <mat-autocomplete autoActiveFirstOption #autobooknameee="matAutocomplete">
                  <mat-option *ngFor="let option of filteredOptions8 | async" [value]="option.bookname"
                    (onSelectionChange)="selected_bookname(option)">
                    {{ option.bookname }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>



              <mat-form-field *ngIf="entryType === 'granth'" appearance="outline" class="example-full-width"
                style="width: 30%; margin-left: 30px; margin-top: 20px">
                <mat-label>Granth Name</mat-label>
                <input matInput formControlName="bookname" [matAutocomplete]="autobooknameee" />
                <mat-autocomplete autoActiveFirstOption #autobooknameee="matAutocomplete">
                  <mat-option *ngFor="let option of filteredOptions8 | async" [value]="option.bookname"
                    (onSelectionChange)="selected_bookname(option)">
                    {{ option.bookname }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field appearance="outline" class="example-full-width"
                style="width: 30%; margin-left: 30px; margin-top: 20px">
                <mat-label>Author Name</mat-label>
                <input matInput type="text" formControlName="authorname" />
              </mat-form-field>
            </div>

            <!-- Row 2 -->
            <div class="form-row">
              <mat-form-field appearance="outline" class="example-full-width"
                style="width: 95%; margin-left: 30px; margin-top: 20px; margin-right: 30px;">
                <mat-label>{{ entryType === 'book' ? 'Book' : 'Granth' }} Description</mat-label>
                <textarea matInput formControlName="bookdesc" rows="3"></textarea>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>Prakashan Name</mat-label>
                <input matInput type="text" formControlName="prakashanname" />
              </mat-form-field>

              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>{{ entryType === 'book' ? 'Book' : 'Granth' }} Language</mat-label>
                <input matInput type="text" formControlName="booklang" />
              </mat-form-field>

              <mat-form-field style="width: 30%; margin-left: 30px;margin-top: 05px" class="example-full-width"
                appearance="outline">
                <mat-label>{{ entryType === 'book' ? 'Book' : 'Granth' }} Publish Year</mat-label>
                <input matInput [matDatepicker]="pickerr_crdt_date" formControlName="bookyear" required />
                <mat-datepicker-toggle matSuffix [for]="pickerr_crdt_date"></mat-datepicker-toggle>
                <mat-datepicker #pickerr_crdt_date [dateFilter]="dateFilter"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>{{ entryType === 'book' ? 'Book' : 'Granth' }} Price</mat-label>
                <input matInput type="number" formControlName="price" />
              </mat-form-field>

              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>{{ entryType === 'book' ? 'Book' : 'Granth' }} Sale Price</mat-label>
                <input matInput type="number" formControlName="saleprice" (change)="getSalePrice($event)" />
              </mat-form-field>

              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>Agent price</mat-label>
                <input matInput type="text" formControlName="agentprice" />
              </mat-form-field>

              <mat-form-field *ngIf="displayDiscount" class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>Discount upto</mat-label>
                <input matInput type="date" formControlName="discountupto" />
              </mat-form-field>
            </div>

            <div class="form-row">
              <label style="margin-left: 35px; margin-top: 25px">{{ entryType === 'book' ? 'Book' : 'Granth' }} Pages
                :</label>
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 10%; margin-left: 10px; margin-top: 05px">
                <mat-label>B/w</mat-label>
                <input (change)="caltotalpages()" matInput type="number" formControlName="bookpagesbw" />
              </mat-form-field>
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 10%; margin-left: 10px; margin-top: 05px">
                <mat-label>Inside Color</mat-label>
                <input (change)="caltotalpages()" matInput type="number" formControlName="bkpinsidecolor" />
              </mat-form-field>
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 10%; margin-left: 10px; margin-top: 05px">
                <mat-label>Cover</mat-label>
                <input (change)="caltotalpages()" matInput type="number" formControlName="bkpcover" />
              </mat-form-field>
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 10%; margin-left: 15px; margin-top: 05px">
                <mat-label>Total Pages</mat-label>
                <input matInput type="number" formControlName="totalpages" readonly />
              </mat-form-field>

              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 129px; margin-top: 05px">
                <mat-label>Binding</mat-label>
                <input matInput type="text" formControlName="binding" />
              </mat-form-field>
            </div>

            <div class="form-row">
              <label style="margin-left: 35px; margin-top: 25px">Paper :</label>
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 15%; margin-left: 10px; margin-top: 05px">
                <mat-label>B/w</mat-label>
                <input matInput type="text" formControlName="paperbw" />
              </mat-form-field>
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 15%; margin-left: 10px; margin-top: 05px">
                <mat-label>Inside color</mat-label>
                <input matInput type="text" formControlName="paperinsidecolor" />
              </mat-form-field>
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 15%; margin-left: 10px; margin-top: 05px">
                <mat-label>Cover</mat-label>
                <input matInput type="text" formControlName="papercover" />
              </mat-form-field>

              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-top: 05px;margin-left: 133px;">
                <mat-label>{{ entryType === 'book' ? 'Book' : 'Granth' }} Size</mat-label>
                <input matInput formControlName="booksize" />
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>{{ entryType === 'book' ? 'Book' : 'Granth' }} Category</mat-label>
                <input matInput type="text" formControlName="bookcategory" />
              </mat-form-field>

              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>Print Copies</mat-label>
                <input matInput type="number" formControlName="bookedtncpoies" />
              </mat-form-field>
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>Opening Stock</mat-label>
                <input matInput type="number" formControlName="opening_stock" />
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="example-full-width" appearance="outline"
                style="width: 30%; margin-left: 30px; margin-top: 05px">
                <mat-label>is Delivery Charges included in Price</mat-label>
                <mat-select formControlName="isdelivery">
                  <mat-option value="Y">Yes</mat-option>
                  <mat-option value="N">No</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 30px">
                <mat-label>लेखक मानधन</mat-label>
                <input matInput type="text" formControlName="author_honorarium" />
              </mat-form-field>

              <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 30px">
                <mat-label>{{ entryType === 'book' ? 'Book' : 'Granth' }} Edition</mat-label>
                <input matInput type="text" formControlName="bookedition" />
              </mat-form-field>
            </div>

            <div class="form-row">
              <label style="margin-left: 35px">Publish Status : </label>
              <select style="margin-left: 35px; margin-bottom: 10px;width: 30%" class="form-control"
                placeholder="Select One" formControlName="isupcoming" (change)="getSearchTerm($event)" required>
                <option value="N">Publish Now</option>
                <option value="Y">Upcomming</option>
              </select>
            </div>

            <div class="form-row">
              <div class="col form-group" *ngIf="displayucoming" style="width: 30%;">
                <label style="margin-left: 30px;">Upcomming {{ entryType === 'book' ? 'Book' : 'Granth' }} Date :
                </label>
                <input style="width: 50%;margin-left: 30px" formControlName="upcomingdate" type="date"
                  class="form-control" />
              </div>

              <label style="margin-left: 35px">Upload {{ entryType === 'book' ? 'Book' : 'Granth' }} Image : </label>
              <input style="margin-left: 35px; margin-right: 35px; width: 30%" (change)="ImageUploads($event)"
                type="file" name="file" ng2FileSelect [uploader]="uploader" class="form-control" placeholder=" " />
            </div>

            <div class="form-group">
              <button [disabled]="BookForm.invalid" style="margin-right: 27%;margin-top: 20px; width: 40%" type="submit"
                class="btn btn-danger btn-block">
                Add New {{ entryType === 'book' ? 'Book' : 'Granth' }}
              </button>
            </div>
          </form>
        </div>

        <div class="row" style="margin-top: 86px; display: flex; align-items: center; justify-content: space-between;">
          <div class="col-md-6" style="display: flex; align-items: center;">
            <mat-form-field appearance="outline" style="width: 60%; margin-left: 20px;">
              <mat-label>Search by {{ entryType === 'book' ? 'book' : 'granth' }} name</mat-label>
              <input matInput [(ngModel)]="bookNameSearch1" (ngModelChange)="filterByBookName1()"
                placeholder="Enter {{ entryType === 'book' ? 'Book' : 'Granth' }} Name" />
            </mat-form-field>
          </div>

          <div class="col-md-6" style="display: flex; justify-content: flex-end; gap: 20px; padding-right: 20px;">
            <button class="noPrint" mat-raised-button color="primary" (click)="printTable()">
              Print
            </button>
            <button class="noPrint" (click)="exportExcel1('Book_Excel')" mat-raised-button color="primary">
              Export
            </button>
          </div>
        </div>

        <div class="tableFixHead">
          <table class="table table-bordered table-hover text-center" id="print-section">
            <thead>
              <th style="border-top: 1px solid black; border-bottom: 1px solid black;">Sr.No.</th>
              <th style="border-top: 1px solid black; border-bottom: 1px solid black;">{{ entryType === 'book' ? 'Book'
                : 'Granth' }} Name</th>
              <th style="border-top: 1px solid black; border-bottom: 1px solid black;">Author</th>
              <th style="border-top: 1px solid black; border-bottom: 1px solid black;">{{ entryType === 'book' ? 'Book'
                : 'Granth' }} Page</th>
              <th style="border-top: 1px solid black; border-bottom: 1px solid black;">Price</th>
              <th style="border-top: 1px solid black; border-bottom: 1px solid black;">Sale Price</th>
              <th style="border-top: 1px solid black; border-bottom: 1px solid black;" class="noPrintCol">Image</th>
              <th style="border-top: 1px solid black; border-bottom: 1px solid black;" class="noPrintCol" colspan="2">
                Action</th>
            </thead>
            <tbody>
              <tr *ngFor="let book of booknames; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ book["bookname"] }}</td>
                <td>{{ book["author"] }}</td>
                <td>{{ book["book_pages"] }}</td>
                <td>{{ book["price"] }}</td>
                <td>{{ book["saleprice"] }}</td>
                <td>
                  <img src="{{ this.bookimgpath + book['bookimg'] }}" width="40" />
                </td>
                <td>
                  <button mat-icon-button class="btn-sm btn-outline-primary"
                    matTooltip="Edit {{ entryType === 'book' ? 'Book' : 'Granth' }}"
                    style="margin-left: 2%; vertical-align: middle; margin-top: -13px;"
                    (click)="EditBooks(book['bookid'])">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
                <td>
                  <button mat-icon-button class="btn-sm btn-outline-danger"
                    matTooltip="Remove {{ entryType === 'book' ? 'Book' : 'Granth' }}"
                    style="margin-left: 2%; vertical-align: middle; margin-top: -13px;"
                    (click)="removebook(book['bookid'])">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </ng-template>
    </mat-tab>
    <mat-tab label>
      <ng-template mat-tab-label> 2<br>
        Book Seller<br>Management
      </ng-template>
      <ng-template matTabContent>
      <div style="margin-top: 20px">
        <div class="text-center">
          <h1 style="font-size: medium; font-weight: bold"></h1>
        </div>
      </div>
      <mat-radio-group [(ngModel)]="entryType" (change)="onEntryTypeChange()" style="margin-top: 20px">
        <mat-radio-button value="book" style="margin-right: 30px;">Book</mat-radio-button>
        <mat-radio-button value="granth">Granth</mat-radio-button>
      </mat-radio-group>
      <mat-card class="sub" style="margin-top: 20px">

        <!-- Inner/Nested Tabs -->
        <mat-tab-group>

          <!-- SUB TAB 1: Book Seller Entry -->
          <mat-tab label="Book Seller Entry" *ngIf="entryType === 'book'">
            <mat-card class="sub" style="margin-top: 20px">
              <form class="form" [formGroup]="subform">
                <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
                  <mat-label>Seller Name</mat-label>
                  <input matInput formControlName="subname" [matAutocomplete]="sellerAuto1" />

                  <mat-autocomplete #sellerAuto1="matAutocomplete"
                    (optionSelected)="selected_namebooking($event.option.value)">
                    <mat-option *ngFor="let option of filteredOptions1 | async" [value]="option">
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>


                <!-- ======================= -->
                <!-- Section 1: Personal Details -->
                <!-- ======================= -->
                <div class="tableFixHead1 mb-5" style="max-height: 400px; overflow-y: auto;">
                  <table class="table table-striped">
                    <thead style="position: sticky; top: 0; background-color: #fff; z-index: 2;">
                      <tr>
                        <th><span>All</span> <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
                        </th>
                        <th>Order Date</th>
                        <th>Order No.</th>
                        <th>Invoice No</th>
                        <th>Invoice Date</th>
                        <!-- <th>Book Seller Name</th> -->
                        <th>Invoice Total</th>
                        <th>Remaining Amt</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="issueBookingSellerList.length === 0">
                        <td colspan="9" class="text-center">No records found</td>
                      </tr>
                      <tr *ngFor="let book of issueBookingSellerList">
                        <td><input type="checkbox" [checked]="isSelected(book)" (change)="toggleSelection(book)"></td>
                        <td>{{ book.date | date: 'dd-MM-yyyy' }}</td>
                        <td>{{ book.orderno }}</td>
                        <td>{{ book.invoice_no }}</td>
                        <td>{{ book.invoice_date | date: 'dd-MM-yyyy' }}</td>
                        <!-- <td>{{ book.name }}</td> -->
                        <td>{{ book.invoice_total }}</td>
                        <td>{{ book.remaining_amt }}</td>
                        <td class="d-flex gap-2">
                          <button mat-icon-button matTooltip="View" (click)="showOrderEntry(book)">
                            <mat-icon>visibility</mat-icon>
                          </button>

                          <button class="btn-sm btn-outline-info" type="button" (click)="showEditBooking(book)"
                            style="margin-right: 5px;">
                            <i class="fas fa-edit"></i>
                          </button>

                          <button mat-icon-button color="warn" (click)="cancelseller(book)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <form class="form" [formGroup]="subform" (ngSubmit)="addBookSellerEntry()">
                  <div class="section" style="position: relative;">

                    <!-- Section Header with Toggle Arrow -->
                    <div class="form-row" style="
        justify-content: center;
        background-color: #8bbdbd;
        margin-bottom: 2%;
        margin-top: 2%;
        position: relative;
      ">
                      <h2 style="text-align: center; margin-top: 10px; color: black">
                        Book Seller Personal Details
                      </h2>

                      <!-- Toggle Arrow -->
                      <i class="fas fa-arrow-down" *ngIf="!showFields" style="
          font-size: 24px;
          color: black;
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
        " (click)="toggleFields()"></i>

                      <i class="fas fa-arrow-up" *ngIf="showFields" style="
          font-size: 24px;
          color: black;
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
        " (click)="toggleFields()"></i>
                    </div>

                    <!-- Personal Details Form -->
                    <div *ngIf="showFields">

                      <div class="form-row">
                        <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
                          <mat-label>Seller Name :</mat-label>
                          <input matInput formControlName="subname" [matAutocomplete]="auto1" required />
                          <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                            <mat-option (onSelectionChange)="selected_name(option)"
                              *ngFor="let option of filteredOptions1 | async" [value]="option['name']">
                              {{ option["name"] }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                        <!-- <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
                          <mat-label>E-Seller Name :</mat-label>

                          <input matInput formControlName="subname_eng" [matAutocomplete]="auto2" required />

                          <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete">

                            <mat-option *ngFor="let option of filteredOptions1 | async" [value]="option.name_eng"
                              (onSelectionChange)="selected_name({isUserInput: true}, option)">

                              {{ option.name_eng }}

                            </mat-option>

                          </mat-autocomplete>
                        </mat-form-field> -->



                        <span style="margin-top: 30px; margin-left: 1%">OR</span>

                        <mat-form-field appearance="outline" class="example-full-width"
                          style="width: 35%; margin-top: 10px; margin-left: 1%"
                          [style.color]="validmobile ? null : 'red'">
                          <mat-label>Mobile</mat-label>
                          <span matPrefix>+91 &nbsp;</span>
                          <input type="tel" #mobiles1 maxlength="10" formControlName="mobileNumber"
                            [matAutocomplete]="auto" matInput />
                          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option (onSelectionChange)="selected_name($event, option)"
                              *ngFor="let option of filteredOptions | async" [value]="option['mob_no']">
                              {{ option["mob_no"] }}
                            </mat-option>
                          </mat-autocomplete>
                          <mat-hint align="end">{{ mobiles1.value.length }} / 10</mat-hint>
                          <mat-error *ngIf="validmobile">
                            Please enter a valid mobile no.
                          </mat-error>
                          <mat-error *ngIf="validmobile">
                            Mobile no. is <strong>required</strong>
                          </mat-error>
                        </mat-form-field>

                        <!-- <mat-form-field style="width: 20%; margin-left: 5%; margin-top: 10px" appearance="outline">
                  <mat-label>Seller Type</mat-label>
                  <mat-select formControlName="sellertype">
                    <mat-option *ngFor="let type of sellerTypes" [value]="type.sellertype">
                      {{ type.sellertype }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
                      </div>

                      <div class="form-row">
                        <mat-form-field style="width: 10%; margin-left: 5%" appearance="outline">
                          <mat-label>Title</mat-label>
                          <mat-select formControlName="title">
                            <mat-option *ngFor="let c of titles" value="{{ c['title'] }}">
                              {{ c["title"] }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="example-full-width"
                          style="width: 35%; margin-left: 0.5%" [style.color]="validatefname ? null : 'red'">
                          <mat-label>Name</mat-label>
                          <input matInput (change)="validateName($event)" formControlName="name" />
                          <mat-error *ngIf="validatefname">
                            Please enter a valid name
                          </mat-error>
                          <mat-error *ngIf="validatefname">
                            Name is <strong>required</strong>
                          </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="example-full-width"
                          style="width: 35%; margin-left: 0.5%">

                          <mat-label>English Name</mat-label>

                          <input matInput formControlName="subname_eng" />

                          <mat-error *ngIf="subform.get('subname_eng')?.hasError('required')">
                            English Name is <strong>required</strong>
                          </mat-error>

                          <mat-error *ngIf="subform.get('subname_eng')?.hasError('pattern')">
                            Please enter a valid English name
                          </mat-error>

                        </mat-form-field>
                      </div>

                      <div class="form-row">
                        <mat-form-field class="example-full-width" style="width: 75%; margin-left: 5%"
                          appearance="outline">
                          <mat-label>Address</mat-label>
                          <textarea matInput placeholder="Address" formControlName="address"></textarea>
                        </mat-form-field>
                      </div>

                      <div class="form-row">
                        <mat-form-field style="margin-left: 5%; width: 23%" class="example-full-width"
                          appearance="outline">
                          <mat-label>Pincode</mat-label>
                          <input (change)="getPincode($event)" matInput #postalCode maxlength="6" placeholder=""
                            formControlName="pincode" />
                          <mat-hint align="end">{{ postalCode.value.length }} / 6</mat-hint>
                        </mat-form-field>

                        <mat-form-field style="width: 23%; margin-left: 3%" appearance="outline">
                          <mat-label>Country</mat-label>
                          <mat-select (selectionChange)="getCountry($event)" formControlName="country">
                            <mat-option *ngFor="let c of countries" value="{{ c['country_name'] }}">{{ c["country_name"]
                              }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field style="width: 23%; margin-left: 3%" appearance="outline">
                          <mat-label>State</mat-label>
                          <mat-select (selectionChange)="getState($event)" formControlName="state">
                            <mat-option *ngFor="let c of states" value="{{ c['state_name'] }}">{{ c["state_name"]
                              }}</mat-option>
                          </mat-select>
                          <span>{{ selectedState }}</span>
                        </mat-form-field>
                      </div>

                      <div class="form-row">
                        <mat-form-field style="width: 35%; margin-left: 5%" appearance="outline">
                          <mat-label>District</mat-label>
                          <mat-select (selectionChange)="getDistricts($event)" formControlName="district">
                            <mat-option *ngFor="let c of cities" value="{{ c['district_name'] }}">
                              {{ c["district_name"] }}
                            </mat-option>
                          </mat-select>
                          <span>{{ selectedCity }}</span>
                        </mat-form-field>

                        <mat-form-field style="width: 35%; margin-left: 5%" appearance="outline">
                          <mat-label>E District (English)</mat-label>
                          <input matInput formControlName="district_eng" placeholder="Enter district in English">
                        </mat-form-field>


                        <mat-form-field style="width: 35%; margin-left: 5%" appearance="outline">
                          <mat-label>Taluka</mat-label>
                          <mat-select formControlName="taluka">
                            <mat-option *ngFor="let c of talukas" value="{{ c['taluka_name'] }}">
                              {{c["taluka_name"] }}
                            </mat-option>
                          </mat-select>
                          <span>{{ selectedTaluka }}</span>
                        </mat-form-field>
                      </div>

                      <div class="form-row">
                        <mat-form-field appearance="outline" class="example-full-width"
                          style="margin-left: 5%; width: 35%" [style.color]="validmobile ? null : 'red'">
                          <mat-label>Mobile</mat-label>
                          <span matPrefix>+91 &nbsp;</span>
                          <input type="tel" #mobiles (change)="validateMobile($event)" maxlength="10"
                            formControlName="mobileNumber" matInput />
                          <mat-hint align="end">{{ mobiles.value.length }} / 10</mat-hint>
                          <mat-error *ngIf="validmobile">
                            Please enter a valid mobile no.
                          </mat-error>
                          <mat-error *ngIf="validmobile">
                            Mobile no. is <strong>required</strong>
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="example-full-width"
                          style="width: 35%; margin-left: 5%" [style.color]="validemail ? null : 'red'">
                          <mat-label>Email</mat-label>
                          <input (change)="validateEmail($event)" type="email" matInput formControlName="email"
                            placeholder="Ex. pat@example.com" />
                          <mat-error *ngIf="validemail">
                            Please enter a valid email address
                          </mat-error>
                          <mat-error *ngIf="validemail">
                            Email is <strong>required</strong>
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="form-row">
                        <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
                          <mat-label>Date of Birth</mat-label>
                          <input formControlName="dob" type="date" matInput />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
                          <mat-label>Marriage Date</mat-label>
                          <input formControlName="doa" type="date" matInput />
                        </mat-form-field>

                        <mat-form-field style="width: 30%; margin-left: 5%;" appearance="outline">
                          <mat-label>Seller Type</mat-label>
                          <mat-select formControlName="sellertype">
                            <mat-option *ngFor="let type of sellerTypes" [value]="type.sellertype">
                              {{ type.sellertype }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
                          <mat-label>GST Number</mat-label>
                          <input formControlName="gstNumber" type="text" matInput placeholder="Enter GST Number"
                            maxlength="15" />
                        </mat-form-field>
                      </div>

                      <!-- Buttons -->
                      <div class="form-row" *ngIf="!this.bookselleravailable">
                        <button style="
          margin-left: 20%;
          margin-right: 20%;
          width: 40%;
          margin-bottom: 10px;
        " type="button" (click)="saveBookSellerEntry()" mat-raised-button color="primary"
                          class="btn btn-primary btn-block">
                          Save
                        </button>
                      </div>

                      <div class="form-row" *ngIf="this.bookselleravailable"
                        style="display: flex; justify-content: center; gap: 20px; margin-bottom: 10px;">
                        <button type="button" (click)="updatebookseller()" mat-raised-button color="primary"
                          class="btn btn-primary" style="width: 30%;">
                          Update
                        </button>

                        <button type="button" (click)="deletebookseller()" mat-raised-button color="warn"
                          class="btn btn-primary" style="width: 30%;">
                          Delete
                        </button>
                      </div>

                    </div> <!-- End of *ngIf showFields -->
                  </div>


                  <!-- ======================= -->
                  <!-- Section 2: Book Booking Details -->
                  <!-- ======================= -->
                  <div class="section" style="margin-top: 30px;">



                    <div class="form-row" style="
              justify-content: center;
              background-color: #8bbdbd;
              margin-bottom: 2%;
              margin-top: 2%;
            ">
                      <h2 style="text-align: center; margin-top: 10px; color: black">
                        Books Booking Details
                      </h2>
                    </div>

                    <div class="form-row">
                      <mat-form-field *ngIf="!deleteOrd" appearance="outline" style="margin-left: 5%; width: 35%">
                        <mat-label>Order No</mat-label>
                        <input formControlName="orderno" type="text" matInput readonly />
                      </mat-form-field>

                      <mat-form-field *ngIf="deleteOrd" style="margin-left: 5%; width: 35%" class="example-full-width"
                        appearance="outline">
                        <mat-label>Order No (deleted) :</mat-label>
                        <mat-select formControlName="orderno" required>
                          <mat-option *ngFor="let order of getdeleteOrder" [value]="order.oder_no">
                            {{ order.oder_no }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>



                      <mat-form-field style=" margin-left: 5%; width: 35%" class="example-full-width"
                        appearance="outline">
                        <mat-label>Date</mat-label>
                        <input matInput [matDatepicker]="picker_booking_date" formControlName="bookdate"
                          [min]="financialYearMin" [max]="financialYearMax" (dateChange)="bookingdateChange($event)"
                          required />
                        <mat-datepicker-toggle matSuffix [for]="picker_booking_date"></mat-datepicker-toggle>
                        <mat-datepicker #picker_booking_date [dateFilter]="dateFilter"></mat-datepicker>
                      </mat-form-field>

                      <div class="form-row mb-3 ms-3" style="display: flex; align-items: center;">
                        <h3 style="padding-top: 10px; margin-right: 20px; margin-left: 40px;">Select Order is
                          New/Delete:
                        </h3>
                        <mat-button-toggle-group formControlName="newordeleted" (change)="newdelOrder($event)"
                          name="fontStyle" aria-label="Font Style" style="height: 50px;">
                          <mat-button-toggle value="new">New</mat-button-toggle>
                          <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
                        </mat-button-toggle-group>
                      </div>

                      <div class="form-row" style="margin-top: 2%">
                        <mat-form-field class="example-full-width" appearance="outline"
                          style="width: 35%; margin-left: 5%">
                          <mat-label>Current Representative Name</mat-label>
                          <input matInput formControlName="crepname" [matAutocomplete]="autorep" />
                          <mat-autocomplete autoActiveFirstOption #autorep="matAutocomplete">
                            <mat-option (onSelectionChange)="selected_rep_name($event, option)"
                              *ngFor="let option of filteredOptions4 | async" [value]="option['name']">
                              {{ option["name"] }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="example-full-width"
                          style="margin-left: 5%; width: 35%" [style.color]="validmobile ? null : 'red'">
                          <mat-label>Representative Mobile No</mat-label>
                          <span matPrefix>+91 &nbsp;</span>
                          <input type="tel" #m1 (change)="validateMobile($event)" maxlength="10"
                            formControlName="repmobno1" matInput />
                          <mat-hint align="end">{{ m1.value.length }} / 10</mat-hint>
                          <mat-error *ngIf="validmobile">
                            Please enter a valid mobile no.
                          </mat-error>
                          <mat-error *ngIf="validmobile">
                            Mobile no. is <strong>required</strong>
                          </mat-error>
                        </mat-form-field>


                        <mat-form-field appearance="outline" class="example-full-width"
                          style="margin-left: 5%; width: 35%">
                          <mat-label>Office Representative</mat-label>
                          <input type="text" matInput formControlName="officerep" />
                        </mat-form-field>
                      </div>

                    </div>

                    <div class="form-row">
                      <mat-form-field class="example-full-width" appearance="outline"
                        style="width: 24%; margin-left: 5%">
                        <mat-label>Book Name</mat-label>
                        <input matInput formControlName="bookname" [matAutocomplete]="autobkn" />
                        <mat-autocomplete autoActiveFirstOption #autobkn="matAutocomplete">
                          <mat-option (onSelectionChange)="selected_id($event, option,book)"
                            *ngFor="let option of filteredOptions2 | async" [value]="option['bookname']">
                            {{ option["bookname"] }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>



                      <mat-form-field appearance="outline" style="margin-left: 2.5%; width: 23%">
                        <mat-label>Available Stock</mat-label>
                        <input formControlName="availablestock" type="text" matInput readonly />
                      </mat-form-field>

                      <mat-form-field class="example-full-width" appearance="outline"
                        style="width: 23%; margin-left: 2.5%">
                        <mat-label>Author Name</mat-label>
                        <input matInput formControlName="authorname" [matAutocomplete]="autoathrn" />
                        <mat-autocomplete autoActiveFirstOption #autoathrn="matAutocomplete">
                          <mat-option (onSelectionChange)="selected_id($event, option)"
                            *ngFor="let option of filteredOptions3 | async" [value]="option['author']">
                            {{ option["author"] }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                      <div
                        style="display: flex; align-items: center; margin-left: 2.5%; gap: 20px; margin-top: 10px;margin-bottom: 10px;">
                        <mat-checkbox formControlName="iscomplimentary" [checked]="iscomplementary"
                          (change)="complementry($event.checked)">
                          Complemenatry
                        </mat-checkbox>


                        <mat-checkbox formControlName="isSponsor" [checked]="isSponsor"
                          (change)="sponsor($event.checked)">
                          Sponsor
                        </mat-checkbox>

                        <div *ngIf="iscomplementary">
                          <mat-form-field appearance="fill">
                            <mat-label>Select Option</mat-label>
                            <mat-select formControlName="complimentaryOption">
                              <mat-option *ngFor="let opt of compTypes" [value]="opt.comptype">
                                {{ opt.comptype }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>




                      </div>
                      <!-- <mat-checkbox style="margin-left: 02%; margin-top: 15px" formControlName="iscomplimentary"
              [checked]="iscomplementary" (change)="complementry($event.checked)">Complemenatry</mat-checkbox>
             -->

                    </div>






                    <div class="tableFixHead1">
                      <table class="table table-bordered border-primary text-center table-fixed">
                        <thead>
                          <tr>
                            <th>Sr.No.</th>
                            <th>Book Name</th>
                            <th>Author Name</th>

                            <!-- Sponsor -->
                            <ng-container *ngIf="isSponsor && !iscomplementary">
                              <th>Book Price (Sponsor)</th>
                              <th>Total After Discount</th>
                              <th>Book Copies</th>
                              <th>Total</th>
                              <th>Courier Charges</th>
                              <th>प्रतिनीधी वर्तन%</th>
                              <th>प्रतिनीधी वर्तन</th>

                            </ng-container>

                            <!-- Normal -->
                            <ng-container *ngIf="!isSponsor && !iscomplementary">
                              <th>Book Price</th>
                              <th>Book Sale Price</th>
                              <th>Discount %</th>
                              <th>Discount Amount</th>
                              <th>Total After Discount</th>
                              <th>Book Copies</th>
                              <th>Total</th>
                              <th>Shipping Charges</th>
                              <th>Rep. Commission %</th>
                              <th>Commission Amount</th>
                            </ng-container>

                            <!-- Complementary -->
                            <ng-container *ngIf="iscomplementary">
                              <th>Book Copies</th>
                            </ng-container>

                            <th>Remove</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr *ngFor="let book of book_data; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ book.bookname }}</td>
                            <td>{{ book.author }}</td>

                            <!-- Sponsor (all manual input) -->
                            <ng-container *ngIf="isSponsor && !iscomplementary">

                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <!-- Price input -->
                                  <input matInput type="number" (blur)="calculateSponsorTotal($event, 'price', i)" />
                                </mat-form-field>
                              </td>

                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <!-- TotalAd input -->
                                  <input matInput type="number" (blur)="calculateSponsorTotal($event, 'totalad', i)" />
                                </mat-form-field>
                              </td>

                              <td>
                                <mat-form-field appearance="outline" style="width: 80px;">
                                  <input matInput type="number"
                                    (blur)="calculateSponsorTotal($event, 'bookcopies', i)" />
                                </mat-form-field>
                              </td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" (blur)="calculateSponsorTotal($event, 'total', i)" />
                                </mat-form-field>
                              </td>

                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <!-- TotalAd input -->
                                  <input matInput type="number"
                                    (blur)="calculateSponsorTotal($event, 'shippingcharging', i)" />
                                </mat-form-field>
                              </td>

                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" placeholder="%"
                                    (blur)="calculateSponsorTotal($event, 'percent', i)" />
                                </mat-form-field>
                              </td>
                              <td>
                                <!-- <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" placeholder="%"
                                    (blur)="calculateSponsorTotal($event, 'reptotal', i)" />
                                </mat-form-field> -->
                                {{ inputValues[i]?.net}}

                              </td>

                            </ng-container>

                            <!-- Normal -->
                            <ng-container *ngIf="!isSponsor && !iscomplementary">
                              <td>{{ book.price }}</td>
                              <td>{{ book.saleprice }}</td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 80px;">
                                  <input matInput type="number" [value]="book.discount"
                                    (change)="bookdiscount($event, book)" />
                                </mat-form-field>
                              </td>
                              <td>{{ book.discountamt | number:'1.2-2' }}</td>
                              <td>{{ book.totalad | number:'1.2-2' }}</td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 80px;">
                                  <input matInput type="number" [value]="book.bookcopies"
                                    (change)="bookcopies1($event, book)" />
                                </mat-form-field>
                              </td>
                              <td>{{ book.total }}</td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" [value]="book.shippingcharging"
                                    (change)="bookshipping($event, book)" />
                                </mat-form-field>
                              </td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" [value]="book.repcompercent"
                                    (change)="calcommission($event, book)" />
                                  <span matSuffix>%</span>
                                </mat-form-field>
                              </td>
                              <td>{{ book.commissionamt }}</td>
                            </ng-container>

                            <!-- Complementary -->
                            <ng-container *ngIf="iscomplementary">
                              <td>
                                <mat-form-field appearance="outline" style="width: 80px;">
                                  <input matInput type="number" (input)="updateComplementaryCopies($event, book, i)" />
                                </mat-form-field>
                              </td>


                            </ng-container>

                            <!-- Remove button -->
                            <td>
                              <button type="button" class="btn btn-danger"
                                (click)="bookingId ? updateremove(book) : remove(book)">
                                <mat-icon>clear</mat-icon>
                              </button>
                            </td>

                          </tr>

                          <!-- Sponsor Totals -->
                          <tr *ngIf="isSponsor && !iscomplementary">
                            <td colspan="3" class="big">Total (Sponsor)</td>
                            <td>{{ sponsor_price_total }}</td>
                            <td>{{ sponsor_discount_total }}</td>
                            <td>{{ sponsor_copies_total }}</td>
                            <td>{{ sponsor_total }}</td>
                            <td>{{sponsor_total_shippingcharging}}</td>
                            <td>{{ sponsor_total_percent}}</td>
                            <td>{{ sponsor_total_rep }}</td>

                          </tr>
                          <tr *ngIf="isSponsor && !iscomplementary">
                            <td colspan="6" class="big">Grand Total</td>
                            <td colspan="4" class="bgcolor">
                              {{ sponsor_total + sponsor_total_shippingcharging }}
                            </td>
                          </tr>

                          <!-- Normal Totals -->
                          <tr *ngIf="!isSponsor && !iscomplementary">
                            <td colspan="9" class="big">Total (Normal)</td>
                            <td>{{ total_amt }}</td>
                            <td>{{ shipping_total }}</td>
                            <td>{{ comprecentagetotal }}</td>
                            <td>{{ commissiontotal }}</td>
                          </tr>
                          <tr *ngIf="!isSponsor && !iscomplementary">
                            <td colspan="6" class="big">Grand Total</td>
                            <td colspan="4" class="bgcolor">{{ total_amt + shipping_total }}</td>
                          </tr>

                          <!-- Complementary Totals -->
                          <tr *ngIf="iscomplementary">
                            <td colspan="3" class="big">Total (Complementary)</td>
                            <td>{{ complementary_total }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>




                    <!-- <div class="form-row" style="margin-top: 2%">
              <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
                <mat-label>Current Representative Name</mat-label>
                <input matInput formControlName="crepname" [matAutocomplete]="autorep" />
                <mat-autocomplete autoActiveFirstOption #autorep="matAutocomplete">
                  <mat-option (onSelectionChange)="selected_rep_name($event, option)"
                    *ngFor="let option of filteredOptions4 | async" [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 35%"
                [style.color]="validmobile ? null : 'red'">
                <mat-label>Representative Mobile No</mat-label>
                <span matPrefix>+91 &nbsp;</span>
                <input type="tel" #m1 (change)="validateMobile($event)" maxlength="10" formControlName="repmobno1"
                  matInput />
                <mat-hint align="end">{{ m1.value.length }} / 10</mat-hint>
                <mat-error *ngIf="validmobile">
                  Please enter a valid mobile no.
                </mat-error>
                <mat-error *ngIf="validmobile">
                  Mobile no. is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field appearance="outline" class="example-full-width" style="width: 35%; margin-left: 5%">
                <mat-label>Office Representative</mat-label>
                <input type="text" matInput formControlName="officerep" />
              </mat-form-field>
            </div> -->

                    <!-- <div class="form-row">
            <label style="margin-left: 5%; margin-top: 20px"
              >Representative Commission:</label
            >
            <mat-form-field
              appearance="outline"
              class="example-full-width"
              style="width: 25%; margin-left: 4%"
            >
              <mat-label>%</mat-label>
              <input
                type="number"
                matInput
                formControlName="repcompercent"
                (change)="calcommission($event)"
              />
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="example-full-width"
              style="width: 25%; margin-left: 4%"
            >
              <mat-label>Amt.</mat-label>
              <input type="number" matInput formControlName="repcomprice" />
            </mat-form-field>
          </div> -->

                    <mat-radio-group aria-label="Select an option" formControlName="bookSellerGstType"
                      (ngModelChange)="gstCalculation()" style="margin-left: 7%">
                      <mat-radio-button value="NO_GST">No Gst</mat-radio-button>
                      <mat-radio-button value="INCLUDING">Gst Including</mat-radio-button>
                      <mat-radio-button value="EXCLUDING">Gst Excluding</mat-radio-button>
                    </mat-radio-group>

                    <!-- Show GST fields only if NOT "NO_GST" -->
                    <div class="form-row" *ngIf="subform.get('bookSellerGstType')?.value !== 'NO_GST'">

                      <!-- GST % -->
                      <!-- GST % -->
                      <mat-form-field style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>GST (%)</mat-label>
                        <input matInput type="number" formControlName="gstPercentage" (input)="gstCalculation()" />
                      </mat-form-field>

                      <!-- GST Amount -->
                      <mat-form-field style="width: 20%; margin-left: 3%" appearance="outline">
                        <mat-label>GST ₹</mat-label>
                        <input matInput type="number" formControlName="gstAmount" readonly />
                      </mat-form-field>

                      <!-- State Selection -->
                      <!-- <mat-form-field style="width: 23%; margin-left: 3%" appearance="outline">
                  <mat-label>State</mat-label>
                  <mat-select formControlName="state" (selectionChange)="gstCalculation()">
                    <mat-option *ngFor="let s of states" [value]="s.state_name">{{ s.state_name }}</mat-option>
                  </mat-select>
                </mat-form-field> -->

                      <!-- SGST & CGST (Maharashtra only) -->
                      <mat-form-field *ngIf="subform.get('state')?.value === 'महाराष्ट्र'"
                        style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>SGST ₹</mat-label>
                        <input matInput type="number" formControlName="sgstAmount" readonly />
                      </mat-form-field>

                      <mat-form-field *ngIf="subform.get('state')?.value === 'महाराष्ट्र'"
                        style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>CGST ₹</mat-label>
                        <input matInput type="number" formControlName="cgstAmount" readonly />
                      </mat-form-field>

                      <!-- IGST (Other states) -->
                      <mat-form-field *ngIf="subform.get('state')?.value !== 'महाराष्ट्र'"
                        style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>IGST ₹</mat-label>
                        <input matInput type="number" formControlName="igstAmount" readonly />
                      </mat-form-field>

                      <!-- Total Amount -->
                      <mat-form-field style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>Total Amount ₹</mat-label>
                        <input matInput type="number" formControlName="totalAmount" readonly />
                      </mat-form-field>


                    </div>


                    <div class="form-row">

                      <h3 style="padding-top: 2px; margin-right: 15px; margin-left: 47px;">Dispatch to: </h3>

                      <!-- <mat-radio-group aria-label="Select an option" style="width: 35%; margin-left: 5%"
                        formControlName="option" (change)="select($event)">
                        <mat-radio-button value="Representative"
                          style="margin-top: 15px">Representative</mat-radio-button>
                        <mat-radio-button value="Client" style="margin-left: 20px">Client</mat-radio-button>
                      </mat-radio-group> -->

                    </div>

                    <div class="form-row">
                      <!-- <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
                        <mat-label>Delivery Mode</mat-label>
                        <mat-select (selectionChange)="durationn($event)" formControlName="deliverymode">
                          <mat-option value="By Hand">By Hand</mat-option>
                          <mat-option value="Courier">Courier</mat-option>
                          <mat-option value="Post">Post</mat-option>
                          <mat-option value="S.T.">S.T.</mat-option>
                          <mat-option value="Railway">Railway</mat-option>
                          <mat-option value="Transport">Transport</mat-option>
                        </mat-select>
                      </mat-form-field> -->

                    </div>

                    <div class="form-row">
                      <!-- (selectionChange)="SelectRepresentative($event)" -->

                      <!-- Delivery Mode -->
                      <!-- Delivery Mode -->
                      <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%; margin-top: 10px">
                        <mat-label>Delivery Mode</mat-label>
                        <mat-select formControlName="DeliveryMode"
                          (selectionChange)="onDeliveryModeChange($event.value)">
                          <mat-option *ngFor="let mode of deliveryModes" [value]="mode.delivery_mode">
                            {{ mode.delivery_mode }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <!-- Distribution Representative -->
                      <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%; margin-top: 10px">
                        <mat-label>Distribution Representative</mat-label>
                        <input matInput formControlName="DistributiveRep" [matAutocomplete]="autoRep" />
                        <mat-autocomplete #autoRep="matAutocomplete" (optionSelected)="onRepresentativeChange($event)">
                          <mat-option *ngFor="let option of filteredOptionsbook | async" [value]="option.name">
                            {{ option.name }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>

                      <!-- Distribution Mode — ✅ selectionChange added -->
                      <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%; margin-top: 10px">
                        <mat-label>Distribution Mode</mat-label>
                        <mat-select formControlName="DistributionMode"
                          (selectionChange)="onDistributionModeChange($event.value)">
                          <mat-option *ngFor="let option of filteredDistributionModes"
                            [value]="option.sub_delivery_mode">
                            {{ option.sub_delivery_mode }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <!-- Sub Distribution Mode -->
                      <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%; margin-top: 10px">
                        <mat-label>Sub Distribution Mode</mat-label>

                        <mat-select formControlName="SubDistMode" multiple>
                          <mat-option *ngFor="let option of filteredSubDistModes"
                            [value]="option.sub_distribution_mode">
                            {{ option.sub_distribution_mode }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="form-group">
                    <button style="margin-left: 5%; margin-right: 25%; width: 60%" [disabled]="subform.invalid"
                      type="button" mat-raised-button color="primary" class="btn btn-primary btn-block"
                      (click)="onSubmit()">
                      {{ bookingId ? 'Update Book Seller' : 'Add Book Seller' }}
                    </button>

                  </div>
                </form>
              </form>
            </mat-card>
          </mat-tab>

          <!-- SUB TAB 2: Book Seller Entry Packages -->
          <mat-tab label="Granth Package Entry" *ngIf="entryType === 'granth'">
            <mat-card class="sub" style="margin-top: 20px">
              <form class="form" [formGroup]="packsubform">

                <!-- Table Section -->


                <form class="form" [formGroup]="packsubform" (ngSubmit)="addBookSellerEntryPackage()">
                  <!-- Personal Details Section -->
                  <div class="section" style="position: relative;">
                    <!-- <div class="form-row"
                      style="justify-content: center; background-color: #8bbdbd; margin-bottom: 2%; margin-top: 2%; position: relative;">
                      <h2 style="text-align: center; margin-top: 10px; color: black">
                        Book Seller Personal Details Packages
                      </h2>
                      <i class="fas fa-arrow-down" *ngIf="!showFields"
                        style="font-size: 24px; color: black; position: absolute; right: 20px; top: 50%; transform: translateY(-50%); cursor: pointer;"
                        (click)="toggleFields()"></i>
                      <i class="fas fa-arrow-up" *ngIf="showFields"
                        style="font-size: 24px; color: black; position: absolute; right: 20px; top: 50%; transform: translateY(-50%); cursor: pointer;"
                        (click)="toggleFields()"></i>
                    </div> -->

                    <div *ngIf="showFields">
                      <!-- Subscribers No, Mobile, Renewal/New -->
                      <div class="form-row">
                        <!-- <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Subscribers Name</mat-label>
                          <input matInput formControlName="subscribersName" />
                        </mat-form-field> -->

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Subscribers Name</mat-label>
                          <input matInput formControlName="subscribersName" (keyup)="getSubNames($event)"
                            [matAutocomplete]="auto1" />
                          <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                            <mat-option *ngFor="let option of sub_data" [value]="option"
                              (onSelectionChange)="selected_namepack(option)">
                              {{ option.subname }}
                            </mat-option>

                          </mat-autocomplete>
                        </mat-form-field>

                        <span style="margin-top: 30px; margin-left: 1%">OR</span>

                        <!-- <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Subscribers No</mat-label>
                          <input matInput formControlName="subscribersNo" />
                        </mat-form-field> -->
                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Subscribers No</mat-label>
                          <input matInput formControlName="subscribersNo" (keyup)="getSubNo($event)"
                            [matAutocomplete]="auto2" />
                          <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete">
                            <mat-option (onSelectionChange)="selected_namepack($event, option)"
                              *ngFor="let option of sub_no" [value]="option['subno']">
                              {{ option["subno"] }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                        <span style="margin-top: 30px; margin-left: 1%">OR</span>

                        <!-- <mat-form-field appearance="outline" class="example-full-width"
                          style="width: 20%; margin-left: 1%" [style.color]="validmobile ? null : 'red'">
                          <mat-label>Mobile</mat-label>
                          <span matPrefix>+91 &nbsp;</span>
                          <input type="tel" #mobiles1 maxlength="10" formControlName="mobileNumber"
                            [matAutocomplete]="auto" matInput />
                          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option (onSelectionChange)="selected_name($event, option)"
                              *ngFor="let option of filteredOptions | async" [value]="option['mob_no']">
                              {{ option["mob_no"] }}
                            </mat-option>
                          </mat-autocomplete>
                          <mat-hint align="end">{{ mobiles1.value.length }} / 10</mat-hint>
                        </mat-form-field> -->

                        <mat-form-field appearance="outline" class="example-full-width"
                          style="width: 20%; margin-top: 10px">
                          <mat-label>Mobile</mat-label>
                          <input type="tel" #mobiles1 maxlength="11" formControlName="mobileNumber"
                            (keyup)="getSubMobileNo($event)" [matAutocomplete]="auto" matInput />
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected_namepackmob($event)">
                            <mat-option *ngFor="let option of sub_mob_no" [value]="option.mobno">
                              {{ option.mobno }}
                            </mat-option>
                          </mat-autocomplete>
                          <!-- <mat-hint align="end">{{ mobiles1.valu}} / 10</mat-hint> -->
                          <!-- <mat-error *ngIf="!validmobile">
                            Please enter a valid mobile no.
                          </mat-error> -->
                        </mat-form-field>

                        <div class="form-row">
                          <div style="margin-left: 5%; display: flex; gap: 0;">
                            <button type="button" mat-raised-button
                              style="background-color: red; color: white; border-radius: 0;">
                              Delete
                            </button>
                            <button type="button" mat-raised-button
                              style="background-color: green; color: white; border-radius: 0;">
                              New
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- Name, Sub Type, MM, YY, Subscribers No, Dispatch Date -->
                      <div class="form-row">
                        <!-- <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Name</mat-label>
                          <input matInput formControlName="name" />
                        </mat-form-field> -->

                        <!-- <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Sub Type</mat-label>
                          <mat-select formControlName="subType">
                            <mat-option value="Type1">Type 1</mat-option>
                            <mat-option value="Type2">Type 2</mat-option>
                          </mat-select>
                        </mat-form-field> -->

                        <!-- <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>MM</mat-label>
                          <input matInput type="number" formControlName="mm" min="1" max="12" />
                        </mat-form-field> -->

                        <!-- <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>YY</mat-label>
                          <input matInput type="number" formControlName="yy" />
                        </mat-form-field> -->

                        <!-- <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Subscribers No</mat-label>
                          <input matInput formControlName="subscribersNoField" />
                        </mat-form-field> -->

                        <!-- <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Dispatch Date</mat-label>
                          <input matInput [matDatepicker]="dispatchPicker" formControlName="dispatchDate" />
                          <mat-datepicker-toggle matSuffix [for]="dispatchPicker"></mat-datepicker-toggle>
                          <mat-datepicker #dispatchPicker></mat-datepicker>
                        </mat-form-field> -->
                      </div>

                      <!-- Title, Title (English), Name*, Name (English) -->
                      <div class="form-row">
                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Title</mat-label>
                          <mat-select formControlName="title">
                            <mat-option *ngFor="let c of titles" value="{{ c['title'] }}">
                              {{ c["title"] }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Title (In English)</mat-label>
                          <input matInput formControlName="titleEnglish" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Name*</mat-label>
                          <input matInput formControlName="nameRequired" required />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Name (In English)</mat-label>
                          <input matInput formControlName="nameEnglish" />
                        </mat-form-field>
                      </div>

                      <!-- Address*, Address (English), Address1 (English), Address2 (English) -->
                      <div class="form-row">
                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Address*</mat-label>
                          <textarea matInput placeholder="Address" formControlName="address" required></textarea>
                        </mat-form-field>

                        <mat-form-field class="example-full-width" style="width: 45%; margin-left: 2%"
                          appearance="outline">
                          <mat-label>Address (In English)</mat-label>
                          <textarea matInput placeholder="Address in English" formControlName="e_address"></textarea>
                        </mat-form-field>
                      </div>

                      <div class="form-row">
                        <mat-form-field class="example-full-width" style="width: 45%; margin-left: 5%"
                          appearance="outline">
                          <mat-label>Address1 (In English)</mat-label>
                          <textarea matInput formControlName="e_address1"></textarea>
                        </mat-form-field>

                        <mat-form-field class="example-full-width" style="width: 45%; margin-left: 2%"
                          appearance="outline">
                          <mat-label>Address2 (In English)</mat-label>
                          <textarea matInput formControlName="e_address2"></textarea>
                        </mat-form-field>
                      </div>

                      <!-- Pincode, Pincode (English), Country, Country (English), State, State (English) -->
                      <div class="form-row">
                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Pincode</mat-label>
                          <input (change)="getPincode($event)" matInput #postalCode maxlength="6"
                            formControlName="pincode" />
                          <mat-hint align="end">{{ postalCode.value.length }} / 6</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Pincode (In English)</mat-label>
                          <input matInput maxlength="6" formControlName="pincodeEnglish" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Country</mat-label>
                          <mat-select (selectionChange)="getCountry($event)" formControlName="country">
                            <mat-option *ngFor="let c of countries" value="{{ c['country_name'] }}">
                              {{ c["country_name"] }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Country (In English)</mat-label>
                          <input matInput formControlName="countryEnglish" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>State</mat-label>
                          <mat-select (selectionChange)="getState($event)" formControlName="state">
                            <mat-option *ngFor="let c of states" value="{{ c['state_name'] }}">
                              {{ c["state_name"] }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>State (In English)</mat-label>
                          <input matInput formControlName="stateEnglish" />
                        </mat-form-field>
                      </div>

                      <div class="form-row">


                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>District</mat-label>
                          <mat-select (selectionChange)="getDistricts($event)" formControlName="district">
                            <mat-option *ngFor="let c of cities" value="{{ c['district_name'] }}">
                              {{ c["district_name"] }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>District (In English)</mat-label>
                          <input matInput formControlName="districtEnglish" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Taluka</mat-label>
                          <mat-select formControlName="taluka">
                            <mat-option *ngFor="let c of talukas" value="{{ c['taluka_name'] }}">
                              {{ c["taluka_name"] }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Taluka (In English)</mat-label>
                          <input matInput formControlName="talukaEnglish" />
                        </mat-form-field>
                      </div>

                      <div class="form-row">


                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Mobile</mat-label>
                          <span matPrefix>+91 &nbsp;</span>
                          <input type="tel" formControlName="mobileNumberField" matInput />
                          <!-- <mat-hint align="end">{{ mobiles.value.length }} / 10</mat-hint> -->
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Telephone</mat-label>
                          <input matInput formControlName="telephone" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 23%; margin-left: 2%">
                          <mat-label>Email</mat-label>
                          <input type="email" matInput formControlName="email" placeholder="Ex. pat@example.com" />
                        </mat-form-field>
                      </div>

                      <!-- Date of Birth, Marriage Date, Representative Name, Representative Mobile, GST No, Remark -->
                      <div class="form-row">
                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Date of Birth</mat-label>
                          <input formControlName="dob" type="date" matInput />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Marriage Date</mat-label>
                          <input formControlName="doa" type="date" matInput />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Representative Name</mat-label>
                          <input matInput formControlName="representativeName" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Representative Mobile No</mat-label>
                          <span matPrefix>+91 &nbsp;</span>
                          <input type="tel" maxlength="10" formControlName="representativeMobile" matInput />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>GST No</mat-label>
                          <input formControlName="gstNumber" type="text" matInput maxlength="15" />
                        </mat-form-field>
                      </div>

                      <div class="form-row">
                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Remark</mat-label>
                          <textarea matInput formControlName="remark"></textarea>
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                          <mat-label>Seller Type</mat-label>
                          <mat-select formControlName="sellertype">
                            <mat-option *ngFor="let type of sellerTypes" [value]="type.sellertype">
                              {{ type.sellertype }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <!-- Buttons -->
                        
                        
                      </div>
<div class="form-row" *ngIf="!this.bookselleravailable">
                          <button style="
    margin-left: 20%;
    margin-right: 20%;
    width: 40%;
    margin-bottom: 10px;
  " type="button" (click)="saveBookSellerEntry1()" mat-raised-button color="primary" class="btn btn-primary btn-block">
                            Save
                          </button>
                        </div>

                      <!-- Buttons -->

                    </div>
                  </div>

                  <!-- Books Booking Details Section -->
                  <div class="section" style="margin-top: 30px;">
                    <div class="form-row"
                      style="justify-content: center; background-color: #8bbdbd; margin-bottom: 2%; margin-top: 2%;">
                      <h2 style="text-align: center; margin-top: 10px; color: black">
                        Books Booking Details Package
                      </h2>
                    </div>

                    <div class="form-row">
                      <mat-form-field *ngIf="!deleteOrd" appearance="outline" style="margin-left: 5%; width: 35%">
                        <mat-label>Order No</mat-label>
                        <input formControlName="orderno" type="text" matInput readonly />
                      </mat-form-field>

                      <mat-form-field *ngIf="deleteOrd" style="margin-left: 5%; width: 35%" class="example-full-width"
                        appearance="outline">
                        <mat-label>Order No (deleted) :</mat-label>
                        <mat-select formControlName="orderno" required>
                          <mat-option *ngFor="let order of getdeleteOrder" [value]="order.oder_no">
                            {{ order.oder_no }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <!-- <mat-form-field *ngIf="!deleterec" appearance="outline" style="margin-left: 5%; width: 35%">
                        <mat-label>Receipt No</mat-label>
                        <input formControlName="recptno" type="text" matInput readonly />
                      </mat-form-field> -->

                      <!-- <mat-form-field *ngIf="deleterec" style="margin-left: 5%; width: 35%" class="example-full-width"
                        appearance="outline">
                        <mat-label>Receipt No (deleted) :</mat-label>
                        <mat-select formControlName="recptno" required>
                          <mat-option *ngFor="let receipt of getBookdeleterecipt" [value]="receipt.rcpt_no" readonly>
                            {{ receipt.rcpt_no }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field> -->

                      <mat-form-field style=" margin-left: 5%; width: 35%" class="example-full-width"
                        appearance="outline">
                        <mat-label>Date</mat-label>
                        <input matInput [matDatepicker]="picker_booking_datepack" formControlName="bookdate"
                          [min]="financialYearMin" [max]="financialYearMax"
                          (dateChange)="bookingdateChangepackage($event)" required />
                        <mat-datepicker-toggle matSuffix [for]="picker_booking_datepack"></mat-datepicker-toggle>
                        <mat-datepicker #picker_booking_datepack [dateFilter]="dateFilter"></mat-datepicker>
                      </mat-form-field>

                      <mat-form-field *ngIf="!deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
                        <mat-label>Receipt No</mat-label>
                        <input matInput type="text" formControlName="recptno" readonly />
                      </mat-form-field>
                      <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
                        <mat-label>Receipt No (delete)</mat-label>
                        <mat-select formControlName="recptno">
                          <mat-option *ngFor="let receipt of getBookdeleterecipt" [value]="receipt.rcpt_no" readonly>
                            {{ receipt.rcpt_no }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <div class="form-row mb-3 ms-3" style="display: flex; align-items: center;">
                        <h3 style="padding-top: 10px; margin-right: 20px; margin-left: 40px;">Select Order is
                          New/Delete:
                        </h3>
                        <mat-button-toggle-group formControlName="newordeleted" (change)="newdelOrder($event)"
                          name="fontStyle" aria-label="Font Style" style="height: 50px;">
                          <mat-button-toggle value="new">New</mat-button-toggle>
                          <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
                        </mat-button-toggle-group>


                      </div>



                      <div class="form-row" style="margin-top: 2%">

                        <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
                          <mat-label>Credit Voucher No</mat-label>
                          <input matInput type="text" formControlName="crdtvno" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
                          <mat-label>Rep Name</mat-label>
                          <input matInput type="text" formControlName="rep_name" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
                          <mat-label>Select Entry Amount</mat-label>
                          <input matInput type="text" formControlName="seamt" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
                          <mat-label>Received Amount</mat-label>
                          <input matInput type="number" formControlName="receivedamt" />
                        </mat-form-field>

                        <!-- <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
                          <mat-label>Book Name</mat-label>
                          <input matInput type="text" formControlName="granthname" readonly />
                        </mat-form-field> -->


                        <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
                          <mat-label>Current Representative Name</mat-label>
                          <input matInput formControlName="crepname" [matAutocomplete]="autorepp" />
                          <mat-autocomplete autoActiveFirstOption #autorepp="matAutocomplete">
                            <mat-option (onSelectionChange)="selected_rep_namepack($event, option)"
                              *ngFor="let option of filteredOptionspack | async" [value]="option['name']">
                              {{ option["name"] }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
                          <mat-label>Representative Mobile No</mat-label>
                          <span matPrefix>+91 &nbsp;</span>
                          <input type="tel" #m1 maxlength="10" formControlName="repmobno1" matInput />
                          <mat-hint align="end">{{ m1.value.length }} / 10</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
                          <mat-label>Office Representative</mat-label>
                          <input type="text" matInput formControlName="officerep" />
                        </mat-form-field>
                      </div>
                    </div>



                    <div class="form-row">
                      <mat-form-field appearance="outline" style="width: 24%; margin-left: 5%">
                        <mat-label>Granth Name</mat-label>
                        <input matInput formControlName="bookname" [matAutocomplete]="autobknp" />
                        <mat-autocomplete autoActiveFirstOption #autobknp="matAutocomplete">
                          <mat-option (onSelectionChange)="selected_idpack($event, option,book)"
                            *ngFor="let option of filteredbookPack | async" [value]="option['bookname']">
                            {{ option["bookname"] }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>

                      <mat-form-field appearance="outline" style="margin-left: 2.5%; width: 23%">
                        <mat-label>Available Stock</mat-label>
                        <input formControlName="availablestock" type="text" matInput readonly />
                      </mat-form-field>

                      <mat-form-field appearance="outline" style="width: 23%; margin-left: 2.5%">
                        <mat-label>Author Name</mat-label>
                        <input matInput formControlName="authorname" [matAutocomplete]="autoathrnp" />
                        <mat-autocomplete autoActiveFirstOption #autoathrnp="matAutocomplete">
                          <mat-option (onSelectionChange)="selected_idpack($event, option)"
                            *ngFor="let option of filteredOptions3 | async" [value]="option['author']">
                            {{ option["author"] }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>

                      <div
                        style="display: flex; align-items: center; margin-left: 2.5%; gap: 20px; margin-top: 10px; margin-bottom: 10px;">
                        <mat-checkbox formControlName="iscomplimentary" [checked]="iscomplementary"
                          (change)="complementry($event.checked)">
                          Complemenatry
                        </mat-checkbox>

                        <mat-checkbox formControlName="isSponsor" [checked]="isSponsor"
                          (change)="sponsor($event.checked)">
                          Sponsor
                        </mat-checkbox>

                        <div *ngIf="iscomplementary">
                          <mat-form-field appearance="fill">
                            <mat-label>Select Option</mat-label>
                            <mat-select formControlName="complimentaryOption">
                              <mat-option *ngFor="let opt of compTypes" [value]="opt.comptype">
                                {{ opt.comptype }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>

                    <!-- Books Table -->
                    <div class="tableFixHead1">
                      <table class="table table-bordered border-primary text-center table-fixed">
                        <thead>
                          <tr>
                            <th>Sr.No.</th>
                            <th>Book Name</th>
                            <th>Author Name</th>

                            <ng-container *ngIf="isSponsor && !iscomplementary">
                              <th>Book Price (Sponsor)</th>
                              <th>Total After Discount</th>
                              <th>Book Copies</th>
                              <th>Total</th>
                            </ng-container>

                            <ng-container *ngIf="!isSponsor && !iscomplementary">
                              <th>Book Price</th>
                              <th>Book Sale Price</th>
                              <th>Discount %</th>
                              <th>Discount Amount</th>
                              <th>Total After Discount</th>
                              <th>Book Copies</th>
                              <th>Total</th>
                              <th>Shipping Charges</th>
                              <th>Rep. Commission %</th>
                              <th>Commission Amount</th>
                            </ng-container>

                            <ng-container *ngIf="iscomplementary">
                              <th>Book Copies</th>
                            </ng-container>

                            <th>Remove</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr *ngFor="let book of book_data; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ book.bookname }}</td>
                            <td>{{ book.author }}</td>

                            <ng-container *ngIf="isSponsor && !iscomplementary">
                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" (blur)="calculateSponsorTotal($event, 'price', i)" />
                                </mat-form-field>
                              </td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" (blur)="calculateSponsorTotal($event, 'totalad', i)" />
                                </mat-form-field>
                              </td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 80px;">
                                  <input matInput type="number"
                                    (blur)="calculateSponsorTotal($event, 'bookcopies', i)" />
                                </mat-form-field>
                              </td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" (blur)="calculateSponsorTotal($event, 'total', i)" />
                                </mat-form-field>
                              </td>
                            </ng-container>

                            <ng-container *ngIf="!isSponsor && !iscomplementary">
                              <td>{{ book.price }}</td>
                              <td>{{ book.saleprice }}</td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 80px;">
                                  <input matInput type="number" [value]="book.discount"
                                    (change)="bookdiscount($event, book)" />
                                </mat-form-field>
                              </td>
                              <td>{{ book.discountamt | number:'1.2-2' }}</td>
                              <td>{{ book.totalad }}</td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 80px;">
                                  <input matInput type="number" [value]="book.bookcopies"
                                    (change)="bookcopies1($event, book)" />
                                </mat-form-field>
                              </td>
                              <td>{{ book.total }}</td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" [value]="book.shippingcharging"
                                    (change)="bookshipping($event, book)" />
                                </mat-form-field>
                              </td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" [value]="book.shippingcharging"
                                    (change)="bookshipping($event, book)" />
                                </mat-form-field>
                              </td>
                              <td>
                                <mat-form-field appearance="outline" style="width: 100px;">
                                  <input matInput type="number" [value]="book.repcompercent"
                                    (change)="calcommission($event, book)" />
                                  <span matSuffix>%</span>
                                </mat-form-field>
                              </td>
                              <td>{{ book.commissionamt }}</td>
                            </ng-container>

                            <!-- Complementary -->
                            <ng-container *ngIf="iscomplementary">
                              <td>
                                <mat-form-field appearance="outline" style="width: 80px;">
                                  <input matInput type="number" (input)="updateComplementaryCopies($event, book, i)" />
                                </mat-form-field>
                              </td>


                            </ng-container>

                            <!-- Remove button -->
                            <td>
                              <button type="button" class="btn btn-danger"
                                (click)="bookingId ? updateremove(book) : remove(book)">
                                <mat-icon>clear</mat-icon>
                              </button>
                            </td>

                          </tr>

                          <!-- Sponsor Totals -->
                          <tr *ngIf="isSponsor && !iscomplementary">
                            <td colspan="3" class="big">Total (Sponsor)</td>
                            <td>{{ sponsor_price_total }}</td>
                            <td>{{ sponsor_discount_total }}</td>
                            <td>{{ sponsor_copies_total }}</td>
                            <td>{{ sponsor_total }}</td>
                          </tr>

                          <!-- Normal Totals -->
                          <tr *ngIf="!isSponsor && !iscomplementary">
                            <td colspan="9" class="big">Total (Normal)</td>
                            <td>{{ total_amt }}</td>
                            <td>{{ shipping_total }}</td>
                            <td>{{ comprecentagetotal }}</td>
                            <td>{{ commissiontotal }}</td>
                          </tr>
                          <tr *ngIf="!isSponsor && !iscomplementary">
                            <td colspan="6" class="big">Grand Total</td>
                            <td colspan="4" class="bgcolor">{{ total_amt + shipping_total }}</td>
                          </tr>

                          <!-- Complementary Totals -->
                          <tr *ngIf="iscomplementary">
                            <td colspan="3" class="big">Total (Complementary)</td>
                            <td>{{ complementary_total }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <mat-radio-group aria-label="Select an option" formControlName="bookSellerGstType"
                      (ngModelChange)="gstCalculationpack()" style="margin-left: 7%">
                      <mat-radio-button value="NO_GST">No Gst</mat-radio-button>
                      <mat-radio-button value="INCLUDING">Gst Including</mat-radio-button>
                      <mat-radio-button value="EXCLUDING">Gst Excluding</mat-radio-button>
                    </mat-radio-group>

                    <!-- Show GST fields only if NOT "NO_GST" -->
                    <div class="form-row" *ngIf="subform.get('bookSellerGstType')?.value !== 'NO_GST'">

                      <!-- GST % -->
                      <!-- GST % -->
                      <mat-form-field style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>GST (%)</mat-label>
                        <input matInput type="number" formControlName="gstPercentage" (input)="gstCalculation()" />
                      </mat-form-field>

                      <!-- GST Amount -->
                      <mat-form-field style="width: 20%; margin-left: 3%" appearance="outline">
                        <mat-label>GST ₹</mat-label>
                        <input matInput type="number" formControlName="gstAmount" readonly />
                      </mat-form-field>



                      <!-- SGST & CGST (Maharashtra only) -->
                      <mat-form-field *ngIf="packsubform.get('state')?.value === 'महाराष्ट्र'"
                        style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>SGST ₹</mat-label>
                        <input matInput type="number" formControlName="sgstAmount" readonly />
                      </mat-form-field>

                      <mat-form-field *ngIf="packsubform.get('state')?.value === 'महाराष्ट्र'"
                        style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>CGST ₹</mat-label>
                        <input matInput type="number" formControlName="cgstAmount" readonly />
                      </mat-form-field>

                      <!-- IGST (Other states) -->
                      <mat-form-field *ngIf="packsubform.get('state')?.value !== 'महाराष्ट्र'"
                        style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>IGST ₹</mat-label>
                        <input matInput type="number" formControlName="igstAmount" readonly />
                      </mat-form-field>

                      <!-- Total Amount -->
                      <mat-form-field style="width: 23%; margin-left: 3%" appearance="outline">
                        <mat-label>Total Amount ₹</mat-label>
                        <input matInput type="number" formControlName="totalAmount" readonly />
                      </mat-form-field>


                    </div>


                    <div class="form-row">

                      <h3 style="padding-top: 2px; margin-right: 15px; margin-left: 47px;">Dispatch to: </h3>



                    </div>




                    <div class="form-row">
                      <!-- (selectionChange)="SelectRepresentative($event)" -->


                      <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
                        <mat-label>Delivery Mode</mat-label> <mat-select #mySel13 formControlName="DeliveryMode"
                          multiple (selectionChange)="onDeliveryModeChange1($event.value)"> <!-- Select All option -->
                          <mat-option value="all" (click)="toggleAllSelectionpl()"> All </mat-option>
                          <!-- Individual delivery modes -->
                          <mat-option *ngFor="let rep of delivery_mode" [value]="rep.delivery_mode"> {{
                            rep.delivery_mode }}
                          </mat-option>
                        </mat-select> <!-- Reset button --> <button *ngIf="selectedModes?.length" matSuffix
                          mat-icon-button aria-label="Clear" (click)="resetDeliveryModes1()">
                          <mat-icon>close</mat-icon>
                        </button>
                      </mat-form-field>

                      <!-- Distribution Representative -->
                      <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
                        <mat-label>Distribution Representative</mat-label>
                        <input matInput formControlName="DistributiveRep" [matAutocomplete]="autoDistpl12" />
                        <mat-autocomplete autoActiveFirstOption #autoDistpl12="matAutocomplete">
                          <mat-option (onSelectionChange)="distribution($event, option)"
                            *ngFor="let option of filteredOptionsdist | async" [value]="option['name']">
                            {{ option["name"] }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>

                      <!-- Distribution Mode -->
                      <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
                        <mat-label>Distribution Mode</mat-label>

                        <mat-select #mySel15 formControlName="DistributionMode" multiple
                          (selectionChange)="onDeliveryModeChange3($event.value)">

                          <!-- Select All option -->
                          <mat-option value="all" (click)="toggleAllSelectiondpl($event)">All</mat-option>

                          <!-- Individual options -->
                          <mat-option *ngFor="let option of filteredOptions7 | async" [value]="option.name">
                            {{ option.name }}
                          </mat-option>
                        </mat-select>

                        <!-- Reset button -->
                        <!-- <button *ngIf="selectedModes2?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetDistributionModeModes1()">
              <mat-icon>close</mat-icon>
            </button> -->
                        <!-- <button *ngIf="packsubform.get('DistributionMode')?.value" matSuffix mat-icon-button
                          (click)="resetDistributionModeModes1()">
                          <mat-icon>close</mat-icon>
                        </button> -->
                      </mat-form-field>


                      <!-- Sub Distribution Mode -->
                      <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
                        <mat-label>Sub Distribution Mode</mat-label>
                        <mat-select #mySel16 formControlName="SubDistMode" multiple>

                          <!-- Select All option -->
                          <mat-option (click)="toggleAllSelectionspl($event)">All</mat-option>

                          <!-- Individual options -->
                          <mat-option *ngFor="let option of filteredOptions28 | async" [value]="option.name">
                            {{ option.name }}
                          </mat-option>
                        </mat-select>

                        <!-- Reset button -->
                        <button *ngIf="selectedModes?.length" matSuffix mat-icon-button aria-label="Clear"
                          (click)="resetsubDeliveryModes1()">
                          <mat-icon>close</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="form-group">
                    <button style="margin-left: 5%; margin-right: 25%; width: 60%" [disabled]="packsubform.invalid"
                      type="button" mat-raised-button color="primary" class="btn btn-primary btn-block"
                      (click)="onSubmitPackage()">
                      {{ bookingId ? 'Update Book Seller Package' : 'Add Book Seller Package' }}
                    </button>

                  </div>
                </form>
              </form>
            </mat-card>
          </mat-tab>


        </mat-tab-group>

      </mat-card>
      </ng-template>
    </mat-tab>
    <mat-tab label>
      <ng-template mat-tab-label>
        3<br>
        Book Registration<br>Ledger
      </ng-template>
      <ng-template matTabContent>

      <!-- ===== SAME entryType as Book Invoice Tab 7 (book / granth) ===== -->
      <mat-radio-group [(ngModel)]="entryType" (change)="onEntryTypeChange()"
        style="margin-top: 20px; margin-left: 16px; display: block;">
        <mat-radio-button value="book" style="margin-right: 30px;">Book</mat-radio-button>
        <mat-radio-button value="granth">Granth</mat-radio-button>
      </mat-radio-group>


      <!-- ===================== BOOK SUB-TAB (unchanged from original) ===================== -->
      <div *ngIf="entryType === 'book'" class="add-new-subscriber mat-elevation-z4 ms-3" style="margin-top: 12px;">

        <form [formGroup]="rangeRegistration">

          <!-- Date Range -->
          <mat-form-field appearance="outline" style="margin-left: 3%; width: 30%;margin-top: 3%;">
            <mat-label>Enter Date</mat-label>
            <div class="date-inline">
              <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
              <span class="dash"> - </span>
              <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                (blur)="getBookOutdtandingDateRange3()" />
            </div>
            <mat-error *ngIf="rangeRegistration.get('start')?.hasError('required')">Start date is required</mat-error>
            <mat-error *ngIf="rangeRegistration.get('end')?.hasError('required')">End date is required</mat-error>
            <mat-error *ngIf="rangeRegistration.hasError('dateRangeInvalid')">End date must be greater than start
              date</mat-error>
          </mat-form-field>

          <!-- Customer Name -->
          <mat-form-field appearance="fill" style="width: 30%;margin-left: 3%">
            <mat-label>Customer Name</mat-label>
            <input matInput type="text" placeholder="Enter Customer Name" formControlName="cust_name" />
            <button *ngIf="rangeRegistration.get('cust_name')?.value" mat-icon-button matSuffix
              aria-label="Clear Customer Name" (click)="reset_cust_name()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <!-- Representative -->
          <mat-form-field style="margin-left: 7%; width: 30%;">
            <mat-label>Representative Name : </mat-label>
            <mat-select #mySel1 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of rep_names" value="{{ item['rep_name'] }}">{{ item["rep_name"]
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Office Representative -->
          <mat-form-field style="margin-left: 3%; width: 25%;">
            <mat-label>Office Representative : </mat-label>
            <mat-select #mySel1 (selectionChange)="getofficerepname($event)" formControlName="officerepwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of office_rep_names" value="{{ item['officerep'] }}">{{ item["officerep"]
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Book Name Multi-Select -->
          <mat-form-field style="margin-left: 3%; width: 20%;">
            <mat-label>Book Name Type:</mat-label>
            <mat-select #mySel1 (selectionChange)="getbookname1($event)" formControlName="bookwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection1()">All</mat-option>
              <mat-option *ngFor="let item of Filteredbookdata2" [value]="item.bookname">{{ item.bookname
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Complimentary -->
          <mat-form-field style="margin-left: 3%; width: 25%">
            <mat-label>Select type of complementary</mat-label>
            <mat-select [(value)]="selectedComplimentaryFilter">
              <mat-option value="All">All</mat-option>
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Amount Type -->
          <mat-form-field style="margin-left: 3%; width: 25%">
            <mat-label>Select type of Amount</mat-label>
            <mat-select [(value)]="selectedCommissionFilter">
              <mat-option value="All">All</mat-option>
              <mat-option value="paidCommission">Paid Amount</mat-option>
              <mat-option value="unpaidCommission">Unpaid Amount</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Report Type -->
          <mat-form-field style="margin-left: 7%; width: 30%">
            <mat-label>Select type of report</mat-label>
            <mat-select (selectionChange)="getContractReportType($event)">
              <mat-option value="InDetail">In Detail</mat-option>
              <mat-option value="briefly1">Office Representative In Details</mat-option>
              <mat-option value="Monthwise">Office Representative Briefly</mat-option>
              <mat-option value="InDetail-Officer"> Representative Bookwise</mat-option>
              <mat-option value="VeryBriefly-Officer">Office Representative BookWise</mat-option>
              <mat-option value="Briefly-Officer">Book wise</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Buttons -->
          <div style="margin-left: 35%; margin-top: 1%; display: flex; gap: 12px;">
            <button mat-raised-button color="primary" (click)="searchBookRegistration()">Search</button>
            <button mat-raised-button class="btn btn-info" color="primary" (click)="showReceiptReports2()">Search
              Report</button>
          </div>

        </form>

        <!-- Book Registration Table (100% unchanged) -->
        <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important" id="excel-table">
          <div style="margin-top: 20px" class="tableFixHead">
            <button type="button" (click)="exportexcel()" class="btn btn-danger">Export</button>
            <table class="table table-striped text-center">
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>नोंदणी दिनांक</th>
                  <th>नोंदणी क्र.</th>
                  <th>ग्राहकाचे नाव</th>
                  <th>ठिकाण</th>
                  <th>संपर्क क्रमांक</th>
                  <th>प्रतिनिधींचे नाव</th>
                  <th>कार्यालय प्रतिनिधींचे नाव</th>
                  <th>पुस्तकाचे नाव</th>
                  <th>पुस्तकाच्या प्रति</th>
                  <th>Return प्रति</th>
                  <th>Available Stock</th>
                  <th>Is Complimentary</th>
                  <th>Comp Type</th>
                  <th>प्रकाशन</th>
                  <th>पुस्तकाचे मूल्य</th>
                  <!-- <th>प्रकाशन</th> -->
                  <th>सवलत मूल्य</th>
                  <th>निव्वळ रक्कम</th>
                  <th>कुरिअर चार्जेस</th>
                  <th>एकूण रक्कम</th>
                  <th>जमा</th>
                  <th>Credit</th>
                  <th>येणे</th>
                  <th>Invoice No</th>
                  <th>प्रतिनिधींचे वर्तन</th>
                  <th>पाठविलेले माध्यम</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of FilteredBookRegistration1; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ book["booking_date"] | date: "dd-MM-yyy" }}</td>
                  <td>{{ book["orderno"] }}</td>
                  <td>{{ book["name"] }}</td>
                  <td>{{ book["district"] }}</td>
                  <td>{{ book["mob_no"] }}</td>
                  <td>{{ book["crep_name"] }}</td>
                  <td>{{ book["office_rep_name"] }}</td>
                  <td>{{ book["bookname"] }}</td>
                  <td>{{ book["bookcopies"] }}</td>
                  <td>{{ book["return_copies"] }}</td>
                  <td>{{ book["available_stock"] }}</td>
                  <td>{{ book["iscomplimentary"] }}</td>
                  <td>{{ book["complimentaryOption"] }}</td>
                  <td>{{ book["prakashan_name"] }}</td>
                  <td>{{ book["bookprice"] }}</td>
                  <!-- <td>{{ book["prakashan_name"] }}</td> -->
                  <td>{{ book["totalafterdiscount"] }}</td>
                  <td>{{ book["total"] }}</td>
                  <td>{{ book["shipping_charges"] }}</td>
                  <td>{{ ConvertToInt(book["total"]) + ConvertToInt(book["shipping_charges"]) }}</td>
                  <td>{{ book["receivedamt"] }}</td>
                  <td>{{ book["crdtamt"] }}</td>
                  <td>{{ book["remainingamt"] }}</td>
                  <td>{{ book["invoiceno"] }}</td>
                  <td>{{ book["repcommissionamt"] }}</td>
                  <td>{{ book["delivery_mode"] }}</td>
                  <td>
                    <button *ngIf="book.iscomplimentary === 'Y'" mat-icon-button class="btn-sm btn-outline-danger"
                      matTooltip="Delete" style="margin-left: 2%; vertical-align: middle; margin-top: -13px;"
                      (click)="deleteBookregiledger(book.id)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2"><strong>Total :</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>{{ bookCopiesTotal | number:'1.0-2' }}</strong></td>
                  <td><strong>{{ bookretrunCopiesTotal | number:'1.0-2' }}</strong></td>
                  <td><strong></strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>{{ shippingCharges | number:'1.0-2' }}</strong></td>
                  <td><strong>{{ totalTotal | number:'1.0-2' }}</strong></td>
                  <td><strong>{{ recvTotal | number:'1.0-2' }}</strong></td>
                  <td><strong>{{ creditTotal | number:'1.0-2' }}</strong></td>
                  <td><strong>{{ remTotal | number:'1.0-2' }}</strong></td>
                  <td></td>
                  <td><strong>{{ repCommissionTotal | number:'1.0-2' }}</strong></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="2"><strong> Return Copies Total :</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>{{ bookCopiesTotal - bookretrunCopiesTotal | number:'1.0-2' }}</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

      </div>
      <!-- ===================== END BOOK SUB-TAB ===================== -->


      <!-- ===================== GRANTH SUB-TAB (new, mirrors Tab 7 granth) ===================== -->
      <div *ngIf="entryType === 'granth'" class="add-new-subscriber mat-elevation-z4 ms-3" style="margin-top: 12px;">
        <h2 style="margin-left: 20px; margin-top: 15px;">Granth Registration Ledger</h2>

        <form [formGroup]="rangeRegistration">

          <!-- Date Range -->
          <mat-form-field appearance="outline" style="margin-left: 3%; width: 30%; margin-top: 3%;">
            <mat-label>Enter Date</mat-label>
            <div class="date-inline">
              <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
              <span class="dash"> - </span>
              <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                (blur)="getBookOutdtandingDateRange3()" />
            </div>
            <mat-error *ngIf="rangeRegistration.get('start')?.hasError('required')">Start date is required</mat-error>
            <mat-error *ngIf="rangeRegistration.get('end')?.hasError('required')">End date is required</mat-error>
            <mat-error *ngIf="rangeRegistration.hasError('dateRangeInvalid')">End date must be greater than start
              date</mat-error>
          </mat-form-field>

          <!-- Customer Name -->
          <mat-form-field appearance="fill" style="width: 30%; margin-left: 3%;">
            <mat-label>Customer Name</mat-label>
            <input matInput type="text" placeholder="Enter Customer Name" formControlName="cust_name" />
            <button *ngIf="rangeRegistration.get('cust_name')?.value" mat-icon-button matSuffix
              aria-label="Clear Customer Name" (click)="reset_cust_name()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <!-- Representative -->
          <mat-form-field style="margin-left: 7%; width: 30%;">
            <mat-label>Representative Name : </mat-label>
            <mat-select #mySel1 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of rep_names" value="{{ item['rep_name'] }}">{{ item["rep_name"]
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Office Representative -->
          <mat-form-field style="margin-left: 3%; width: 25%;">
            <mat-label>Office Representative : </mat-label>
            <mat-select #mySel1 (selectionChange)="getofficerepname($event)" formControlName="officerepwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of office_rep_names" value="{{ item['officerep'] }}">{{ item["officerep"]
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Granth Name Multi-Select -->
          <mat-form-field style="margin-left: 3%; width: 20%;">
            <mat-label>Granth Name Type:</mat-label>
            <mat-select #mySel1 (selectionChange)="getbookname1($event)" formControlName="bookwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection1()">All</mat-option>
              <mat-option *ngFor="let item of Filteredbookdatagranth" [value]="item.bookname">{{ item.bookname
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Complimentary -->
          <mat-form-field style="margin-left: 3%; width: 25%;">
            <mat-label>Select type of complementary</mat-label>
            <mat-select [(value)]="selectedComplimentaryFilter">
              <mat-option value="All">All</mat-option>
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Amount Type -->
          <mat-form-field style="margin-left: 3%; width: 25%;">
            <mat-label>Select type of Amount</mat-label>
            <mat-select [(value)]="selectedCommissionFilter">
              <mat-option value="All">All</mat-option>
              <mat-option value="paidCommission">Paid Amount</mat-option>
              <mat-option value="unpaidCommission">Unpaid Amount</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Report Type -->
          <mat-form-field style="margin-left: 7%; width: 30%;">
            <mat-label>Select type of report</mat-label>
            <mat-select (selectionChange)="getgranthReportType($event)">
              <mat-option value="InDetail">In Detail</mat-option>
              <mat-option value="briefly1">Office Representative In Details</mat-option>
              <mat-option value="Monthwise">Office Representative Briefly</mat-option>
              <mat-option value="VeryBriefly-Officergranth">Office Representative Very Briefly</mat-option>
              <mat-option value="InDetail-Officer">Representative Granthwise</mat-option>
              <mat-option value="VeryBriefly-Officer">Office Representative GranthWise</mat-option>
              <mat-option value="Briefly-Officer">Granth wise</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Buttons -->
          <div style="margin-left: 35%; margin-top: 1%; display: flex; gap: 12px;">
            <button mat-raised-button color="primary" (click)="searchBookRegistration()">Search</button>
            <button mat-raised-button class="btn btn-info" color="primary" (click)="showgranthledgerReports2()">Search
              Report</button>
          </div>

        </form>

        <!-- Granth Registration Table -->
        <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important;" id="excel-table">
          <div style="margin-top: 20px;" class="tableFixHead">
            <button type="button" (click)="exportexcel()" class="btn btn-danger">Export</button>
            <table class="table table-striped text-center">
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>नोंदणी दिनांक</th>
                  <th>नोंदणी क्र.</th>
                  <th>Voucher No</th>
                  <th>ग्राहकाचे नाव</th>
                  <!-- <th>ठिकाण</th> -->
                  <th>संपर्क क्रमांक</th>
                  <th>प्रतिनिधींचे नाव</th>
                  <th>कार्यालय प्रतिनिधींचे नाव</th>
                  <th>ग्रंथाचे नाव</th>
                  <th>ग्रंथाच्या प्रति</th>

                  <th>Available Stock</th>
                  <!-- <th>Is Complimentary</th>
                  <th>Comp Type</th> -->
                  <th>ग्रंथाचे मूल्य</th>
                  <!-- <th>प्रकाशन</th> -->
                  <th>सवलत मूल्य</th>
                  <!-- <th>निव्वळ रक्कम</th> -->
                  <!-- <th>कुरिअर चार्जेस</th> -->
                  <!-- <th>एकूण रक्कम</th> -->
                  <th>जमा</th>
                 
                  <th>येणे</th>
                  <!-- <th>Invoice No</th>
                  <th>प्रतिनिधींचे वर्तन</th> -->
                  <!-- <th>पाठविलेले माध्यम</th> -->
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of FilteredBookRegistrationpackage; let i = index">

                  <td>{{ i + 1 }}</td>

                  <!-- Basic Details -->
                  <td>{{ book.booking_date | date:'dd-MM-yyyy' }}</td>
                  <td>{{ book.orderno }}</td>
                  <td>{{ book.voucher_no }}</td>
                  <!-- <td>{{ book.name }}</td> -->
                  <td>{{ book.subscribers_name }}</td>
                 
                  <td>{{ book.mob_no }}</td>

                 

                  <!-- Seller Details -->
                  <td>{{ book.crep_name }}</td>
                  <td>{{ book.office_rep_name }}</td>

                  <!-- Book Details -->
                  <td>{{ book.bookname }}</td>
                  <td>{{ book.bookcopies }}</td>

                  <td>{{ book.available_stock }}</td>

               

                  <!-- Price -->
                  <td>{{ book.bookprice }}</td>
                  <td>{{ book.prakashan_name }}</td>
                  <!-- <td>{{ book.totalafterdiscount }}</td> -->
                  <td>{{ book.total }}</td>
                  <!-- <td>{{ book.shipping_charges }}</td> -->

                  <!-- <td>
                    {{
                    ConvertToInt(book.total)
                    + ConvertToInt(book.shipping_charges)
                    }}
                  </td> -->

                  <td>{{ book.receivedamt }}</td>
                 
   
                  <!-- Action -->
                  <td>

                    <button matTooltip="delete" class="btn-sm btn-outline-danger"
                      (click)="deletepackagegranthId(book.id)">
                      <mat-icon class="fa-solid fa-trash"></mat-icon>
                    </button>

                    <button mat-icon-button matTooltip="View" (click)="viewReceiptPackage(book)">
                      <mat-icon>visibility</mat-icon>
                    </button>
                  </td>


                </tr>
              </tbody>
              <tfoot>
                <!-- <tr>
                  <td colspan="2"><strong>Total :</strong></td>
                 
               
                  <td colspan="2"><strong> Return Copies Total :</strong></td>
                  
                  <td><strong>{{ bookCopiesTotal - bookretrunCopiesTotal | number:'1.0-2' }}</strong></td>
                  <td></td>
                  
                </tr> -->
              </tfoot>
            </table>
          </div>
        </div>

      </div>
      <!-- ===================== END GRANTH SUB-TAB ===================== -->

      </ng-template>
    </mat-tab>


    <mat-tab label>
      <ng-template mat-tab-label>4<br>
        Pending Credit<br>Voucher
      </ng-template>
      <ng-template matTabContent>

      <!-- Nested Tabs for Book and Granth -->
      <mat-tab-group>
        <!-- Book Tab -->
        <mat-tab label="Book">
          <div class="row" [formGroup]="bookselForm" style="margin:15px 5px 5px 0px">
            <!-- First Row: 3 Fields -->
            <div class="row">
              <div class="col-md-4">
                <mat-form-field [formGroup]="bookselForm" appearance="outline" style="width: 90%; margin-left: 10%;">
                  <mat-label>Voucher date from...to</mat-label>

                  <div class="date-inline">
                    <input matInput type="date" formControlName="vstart_date" [min]="financialYearMin"
                      [max]="financialYearMax" />

                    <span class="dash"> - </span>

                    <input matInput type="date" formControlName="vend_date" [min]="financialYearMin"
                      [max]="financialYearMax" (blur)="userprofileDateRange1()" />
                  </div>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field appearance="outline" style="width: 90%; margin-left: 4%;">
                  <mat-label>Entry date from...to</mat-label>

                  <div class="date-inline">
                    <input matInput type="date" formControlName="estart_date" [min]="financialYearMin"
                      [max]="financialYearMax" />

                    <span class="dash"> - </span>

                    <input matInput type="date" formControlName="eend_date" [min]="financialYearMin"
                      [max]="financialYearMax" (blur)="entryDateRange1()" />
                  </div>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field appearance="outline" style="width: 90%;margin-left:-2%;">
                  <mat-label>Representative Name</mat-label>
                  <input matInput type="text" formControlName="rep_name" />
                </mat-form-field>
              </div>
            </div>

            <!-- Second Row: 1 Field -->
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" style="width: 95%; margin-left:11%;">
                  <mat-label>Book Seller Name</mat-label>
                  <input matInput type="text" formControlName="book_seller_name" />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" style="width: 95%; margin-left:11%;">
                  <mat-label>Book Name</mat-label>
                  <input matInput type="text" formControlName="book_names" />
                </mat-form-field>
              </div>
            </div>

            <button type="button" mat-raised-button color="primary" style="margin-left: 5%"
              (click)="searchbookselname()">
              Search
            </button>
          </div>

          <div class="add-new-subscriber1 mat-elevation-z4">
            <button class="noPrint" style=" margin-left: 1%; margin-top: 2%;" mat-raised-button color="primary"
              printSectionId="print-section-book" [useExistingCss]="true" ngxPrint>
              Print
            </button>
            <button class="noPrint" style="margin-left:1%; margin-top:2%;" mat-raised-button color="primary"
              (click)="exportExceld('Pending_credit_voucher_book')">
              Export
            </button>

            <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead" id="print-section-book">
              <table class="table table-striped text-center">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Sr.No.</th>
                    <th>Voucher No.</th>
                    <th>Voucher Date</th>
                    <th>Entry Date</th>
                    <th>Rep.Name</th>
                    <th>Book Seller Name</th>
                    <th>Book Name</th>
                    <th>Book Amount</th>
                    <th>Commission</th>
                    <th>Remaining Amount</th>
                    <th>Cheque no</th>
                    <th>Bank Name</th>
                    <th>Cheque date</th>
                    <th>Branch Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let book of FilteredVoucherData; let i = index">
                    <td>
                      <button type="button" class="btn btn-danger btn-sm" (click)="displayItemId(book, bookpymtrecpt)">
                        Mark as Completed
                      </button>
                    </td>
                    <td>{{ i + 1 }}</td>
                    <td>{{ book.voucher_no }}</td>
                    <td>{{ book.voucher_date | date:'dd-MM-yyyy' }}</td>
                    <td>{{ book.entry_date | date:'dd-MM-yyyy'}}</td>
                    <td>{{ book.rep_name }}</td>
                    <td>{{ book.book_seller_name }}</td>
                    <td>{{ book.book_names }}</td>
                    <td>{{ book.price }}</td>
                    <td>{{ book.commission }}</td>
                    <td>{{ book.remaining_amt }}</td>
                    <td>
                      <span *ngIf="book.cheque_no == 0">&#8211;</span>
                      <span *ngIf="book.cheque_no != 0">{{ book.cheque_no }}</span>
                    </td>
                    <td>{{ book.bank }}</td>
                    <td>
                      <span *ngIf="book.chequeDate === '0000-00-00'">{{ book.chequeDate }}</span>
                      <span *ngIf="book.chequeDate !== '0000-00-00'">{{ book.chequeDate | date: "yyyy-MM-dd" }}</span>
                    </td>
                    <td>{{ book.branch_name }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td></td>
                    <td>{{ getallVouchersData?.length || 0 }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><strong>{{ priceTotal | number:'1.0-2' }}</strong></td>
                    <td><strong>{{ commissionTotal | number:'1.0-2' }}</strong></td>
                    <td><strong>{{ remainingTotal | number:'1.0-2' }}</strong></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </mat-tab>

        <!-- Granth Tab -->
        <mat-tab label="Granth">
          <div class="row" [formGroup]="bookselgranthForm" style="margin:15px 5px 5px 0px">
            <!-- First Row: 3 Fields -->
            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline" style="width: 90%; margin-left: 10%;">
                  <mat-label>Voucher date from...to</mat-label>
                  <mat-date-range-input [rangePicker]="pickerrel_4" [min]="financialYearMin" [max]="financialYearMax">
                    <input matStartDate formControlName="vstart_date" placeholder="Start date" />
                    <input matEndDate formControlName="vend_date" placeholder="End date"
                      (dateChange)="userprofileDateRange3()" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="pickerrel_4"></mat-datepicker-toggle>
                  <mat-date-range-picker #pickerrel_4></mat-date-range-picker>

                  <mat-error *ngIf="bookselgranthForm.get('vstart_date')?.hasError('matStartDateInvalid')">
                    Invalid start date
                  </mat-error>
                  <mat-error *ngIf="bookselgranthForm.get('vend_date')?.hasError('matEndDateInvalid')">
                    Invalid end date
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field appearance="outline" style="width: 90%;margin-left: 4%;">
                  <mat-label>Entry date from...to</mat-label>
                  <mat-date-range-input [rangePicker]="pickerrel_5" [min]="financialYearMin" [max]="financialYearMax">
                    <input matStartDate formControlName="estart_date" placeholder="Start date" />
                    <input matEndDate formControlName="eend_date" placeholder="End date"
                      (dateChange)="entryDateRange2()" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="pickerrel_5"></mat-datepicker-toggle>
                  <mat-date-range-picker #pickerrel_5></mat-date-range-picker>

                  <mat-error *ngIf="bookselgranthForm.get('estart_date')?.hasError('matStartDateInvalid')">
                    Invalid start date
                  </mat-error>
                  <mat-error *ngIf="bookselgranthForm.get('eend_date')?.hasError('matEndDateInvalid')">
                    Invalid end date
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field appearance="outline" style="width: 90%;margin-left:-2%;">
                  <mat-label>Representative Name</mat-label>
                  <input matInput type="text" formControlName="rep_name" />
                </mat-form-field>
              </div>
            </div>

            <!-- Second Row: 1 Field -->
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" style="width: 95%; margin-left:11%;">
                  <mat-label>Book Seller Name</mat-label>
                  <input matInput type="text" formControlName="book_seller_name" />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" style="width: 95%; margin-left:11%;">
                  <mat-label>Granth Name</mat-label>
                  <input matInput type="text" formControlName="book_names" />
                </mat-form-field>
              </div>
            </div>

            <button type="button" mat-raised-button color="primary" style="margin-left: 5%"
              (click)="searchbookselnamegranth()">
              Search
            </button>
          </div>

          <div class="add-new-subscriber1 mat-elevation-z4">
            <button class="noPrint" style=" margin-left: 1%; margin-top: 2%;" mat-raised-button color="primary"
              printSectionId="print-section-granth" [useExistingCss]="true" ngxPrint>
              Print
            </button>
            <button class="noPrint" style="margin-top: 2%; margin-left: 1%"
              (click)="exportExcel('Pending_credit_voucher_granth')" mat-raised-button color="primary">
              Export
            </button>
            <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead" id="print-section-granth">
              <table class="table table-striped text-center">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Sr.No.</th>
                    <th>Voucher No.</th>
                    <th>Voucher Date</th>
                    <th>Entry Date</th>
                    <th>Rep.Name</th>
                    <th>Book Seller Name</th>
                    <th>Granth Name</th>
                    <th>Granth Amount</th>
                    <th>Commission</th>
                    <th>Remaining Amount</th>
                    <th>Cheque no</th>
                    <th>Bank Name</th>
                    <th>Cheque date</th>
                    <th>Branch Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let granth of FilteredGranthData; let i = index">
                    <td>
                      <button type="button" class="btn btn-danger btn-sm"
                        (click)="displayItemIdgranth(granth, granthpymtrecpt)">
                        Mark as Completed
                      </button>
                    </td>
                    <td>{{ i + 1 }}</td>
                    <td>{{ granth.voucher_no }}</td>
                    <td>{{ granth.voucher_date }}</td>
                    <td>{{ granth.entry_date }}</td>
                    <td>{{ granth.rep_name }}</td>
                    <td>{{ granth.book_seller_name }}</td>
                    <td>{{ granth.book_names }}</td>
                    <td>{{ granth.price }}</td>
                    <td>{{ granth.commission }}</td>
                    <td>{{ granth.remaining_amt }}</td>
                    <td>
                      <span *ngIf="granth.cheque_no == 0">&#8211;</span>
                      <span *ngIf="granth.cheque_no != 0">{{ granth.cheque_no }}</span>
                    </td>
                    <td>{{ granth.bank }}</td>
                    <td>
                      <span *ngIf="granth.chequeDate === '0000-00-00'">{{ granth.chequeDate }}</span>
                      <span *ngIf="granth.chequeDate !== '0000-00-00'">{{ granth.chequeDate | date: "yyyy-MM-dd"
                        }}</span>
                    </td>
                    <td>{{ granth.branch_name }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td></td>
                    <td>{{ getallVouchersDatagranth?.length || 0 }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><strong>{{ granthPriceTotal | number:'1.0-2' }}</strong></td>
                    <td><strong>{{ granthCommissionTotal | number:'1.0-2' }}</strong></td>
                    <td><strong>{{ granthRemainingTotal | number:'1.0-2' }}</strong></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
      </ng-template>
    </mat-tab>
    <mat-tab label>
      <ng-template mat-tab-label>5<br>
        Book Payment<br>Receipt
      </ng-template>
      <ng-template matTabContent>
      <mat-card>
        <form class="form" [formGroup]="bookpymtrecptform">
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 50%">
              <mat-label>Date</mat-label>
              <input matInput type="date" formControlName="date" [min]="financialYearMin" [max]="financialYearMax" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Voucher No</mat-label>
              <input matInput type="text" formControlName="crdtvno" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt Date</mat-label>
              <input matInput type="date" formControlName="recptdate" [min]="financialYearMin" [max]="financialYearMax"
                readonly />
            </mat-form-field>
          </div>
          <div class="form-row mb-3">
            <h3 style="padding-top: 10px;margin-left: 5%;padding-right: 20px;">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeleted" (change)="newdelRcpt($event)" name="fontStyle"
              aria-label="Font Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Representative Name</mat-label>
              <input matInput type="text" formControlName="repname" readonly />
            </mat-form-field>
            <mat-form-field *ngIf="!deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No</mat-label>
              <input matInput type="text" formControlName="recptno" readonly />
            </mat-form-field>
            <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No (delete)</mat-label>
              <mat-select formControlName="recptno">
                <mat-option *ngFor="let receipt of getBookdeleterecipt" [value]="receipt.rcpt_no" readonly>
                  {{ receipt.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 5%">
              <mat-label>Credit Voucher Amount</mat-label>
              <input matInput type="number" formControlName="crdtvamt" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Select Entry Amount</mat-label>
              <input matInput type="number" formControlName="seamt" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Balance Amount</mat-label>
              <input matInput type="number" formControlName="balamt" readonly />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Book Name</mat-label>
              <input matInput type="text" formControlName="booksellername" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Book Seller Name</mat-label>
              <input matInput type="text" formControlName="bname" readonly />
            </mat-form-field>

          </div>
          <div class="form-group">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Book Seller Name Search</mat-label>
              <input formControlName="booksellernamesearch" type="text" matInput [matAutocomplete]="autobsname"
                (keyup)="getBookSellerNames($event)" />
              <mat-autocomplete autoActiveFirstOption #autobsname="matAutocomplete">
                <mat-option (onSelectionChange)="selectedname($event, option)" *ngFor="let option of bool_seller_names"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <button type="button" mat-raised-button color="primary" style="margin-left: 5%"
              (click)="searchbooksellername()">
              Search
            </button>
          </div>
          <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead1">
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th>Order No</th>
                  <th>Invoice Date</th>
                  <th>Invoice No</th>
                  <th>Book Seller Name</th>
                  <th>Invoice Amount</th>
                  <th>Received Amount</th>
                  <!-- <th>Credited Amount</th> -->
                  <th>Remaining Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of booksellernamedata">
                  <td>{{ book["order_no"] }}</td>
                  <td>{{ book["invoice_date"] | date: "dd-MM-yyy" }}</td>
                  <td>{{ book["invoice_no"] }}</td>
                  <td>{{ book["receiver_name"] }}</td>
                  <td>{{ book["invoice_total"] }}</td>
                  <td>{{ book["received_amt"] }}</td>
                  <!-- <td>{{ book["crdtnote_total"] }}</td> -->
                  <td>{{ book["remaining_amt"] }}</td>

                  <td>
                    <button [(disabled)]="this.click" type="button" mat-raised-button color="primary"
                      (click)="selectedItem(book)">
                      Select
                    </button>
                    <button style="margin-left: 1%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updatePerBooksRate(book)">
                      Update
                    </button>
                  </td>
                </tr>
                <!-- <tr>
                  <td colspan="5">Total</td>
                </tr> -->
              </tbody>
            </table>
          </div>
          <div class="form-group">
            <button style="
                margin-left: 5%;
                margin-right: 25%;
                width: 60%;
                margin-top: 20px;
              " [disabled]="bookpymtrecptform.invalid" type="button" mat-raised-button color="primary"
              class="btn btn-primary btn-block" (click)="addbookpymtrcpt()">
              Add
            </button>
          </div>
        </form>
      </mat-card>
      </ng-template>
    </mat-tab>

    <mat-tab label>
      <ng-template mat-tab-label>6<br>
        Book Receipt<br>Register
      </ng-template>
      <ng-template matTabContent>
      <mat-card style="padding: 10px 10px">
        <form [formGroup]="bookrcptregisterform">
          <div class="form-row">
            <mat-form-field [formGroup]="bookrcptregisterform" appearance="outline" style="width: 30%;">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDatePrasiddhiPatrak()" />
              </div>
            </mat-form-field>
            <!-- Bill No Wise -->
            <mat-form-field style="margin-left: 3%; width: 25%;" appearance="outline">
              <mat-label>बिल क्रमांक :</mat-label>
              <input matInput type="text" formControlName="billnowise" (keyup)="filterByBillNo()"
                placeholder="Bill No टाइप करा" />
            </mat-form-field>


            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Book :</mat-label>
              <mat-select #mySel1 (selectionChange)="getbookname1($event)" formControlName="bookwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection1()">All</mat-option>
                <mat-option *ngFor="let item of Filteredbookdata2" [value]="item.bookname">
                  {{ item.bookname }}
                </mat-option>
              </mat-select>
            </mat-form-field>


          </div>
          <!-- </div> -->
          <div class="form-row">



            <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 30%; margin-left: 7%">
              <mat-label>प्रतिनिधी प्रमाणे</mat-label>
              <input matInput formControlName="repwise" (change)="getrepwise($event)" />
            </mat-form-field> -->



            <mat-form-field style="margin-left: 7%; width: 30%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of rep_names" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-left: 3%">
              <mat-label>Office Representative</mat-label>
              <input matInput formControlName="officerepwise" (change)="getofficerepname($event)" />
            </mat-form-field> -->


            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySel1 (selectionChange)="getofficerepname($event)" formControlName="officerepwise" multiple>
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of office_rep_names" value="{{  item['officerep'] }}">{{
                  item["officerep"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-left: 3%">
              <mat-label>Book Seller प्रमाणे</mat-label>
              <input matInput formControlName="booksellerwise" (change)="getbooksellerwise($event)" />
            </mat-form-field> -->


            <mat-form-field appearance="outline" style="width: 25%; margin-left: 5%">
              <mat-label>Book Seller Name Search</mat-label>

              <input formControlName="booksellerwise" type="text" matInput [matAutocomplete]="autobsname"
                (keyup)="getBookSellerNames($event)" />

              <mat-autocomplete autoActiveFirstOption #autobsname="matAutocomplete">
                <mat-option *ngFor="let option of bool_seller_names" [value]="option.name"
                  (onSelectionChange)="selectedname($event, option)">
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 30%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="InDetail">In Detail All
                </mat-option>
                <mat-option value="InDetailALL">In Detail
                </mat-option>
                <!-- <mat-option value="All Briefly">In DetailAll
                </mat-option> -->
                <mat-option value="All Briefly">All Briefly
                </mat-option>
                <mat-option value="Office Rep InDetails"> Rep Very Briefly
                </mat-option>

                <mat-option value="Office Rep -Briefly">Office Rep -Briefly
                </mat-option>
                <!-- <mat-option value="Office Rep InDetails">Office Rep InDetails
                </mat-option> -->
                <!-- <mat-option value="Office Rep- In Details">Office Rep- In Details
                </mat-option> -->
                <!-- <mat-option value="briefly">Briefly
                </mat-option> -->
                <mat-option value="Monthwise">Monthwise
                </mat-option>
                <!-- <mat-option value="InDetail-Officer">InDetail-Officer
                </mat-option> -->
                <!-- <mat-option value="VeryBriefly-Officer">VeryBriefly-Officer
                </mat-option> -->
                <!-- <mat-option value="Briefly-Officer">Briefly-Officer
                </mat-option> -->
              </mat-select>
            </mat-form-field>

            <div style="margin-left: 3%;">
              <!-- <button mat-raised-button type="button" class="
              btn btn-info" (click)="getBookReceiptRegister()">Search</button> -->
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="getBookReceiptDateFilter()">Search</button>



            </div>
            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showReceiptReports()">Search Report</button>
            </div>

          </div>

          <div class="form-row">
            <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 40%; margin-left: 7%">
              <mat-label>Book Seller प्रमाणे</mat-label>
              <input matInput formControlName="booksellerwise" (change)="getbooksellerwise($event)" />
            </mat-form-field> -->
          </div>
        </form>
        <div id="excel-table">
          <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead">
            <!-- <button mat-raised-button type="button" class="
              btn btn-info" style="background-color: rgb(0, 87, 137); color: white;" (click)="openBookTwoReceipt()">
              Print
            </button>
                  
            <button type="button" (click)="exportexcel()" class="btn btn-danger">
              Export
            </button> -->
            <!-- Common button style applied -->
            <button mat-raised-button type="button" class="btn btn-custom"
              style="background-color: rgb(0, 87, 137); color: white;" (click)="openBookTwoReceipt()">
              Print
            </button>

            <button type="button" (click)="exportexcel()" class="btn btn-custom"
              style="background-color: #f6325f; color: white;">
              Export
            </button>

            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th>
                    <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                      (change)="selectall($event)">
                    </mat-checkbox>
                  </th>
                  <th>Sr.No.</th>
                  <th>Receipt Date</th>
                  <th>Receipt No</th>
                  <th>Entry Date</th>
                  <th>voucher No</th>
                  <th>Book Seller Name</th>
                  <th>Representative Name</th>
                  <th>Off.Rep.Name</th>
                  <th>Order No</th>
                  <th>Order Date</th>
                  <th>Bill No</th>
                  <th>Bill Date</th>
                  <th>Bill Amount</th>
                  <th>Received Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of FilteredbookRcptRegisterdata; let i= index">
                  <td>
                    <mat-checkbox [(ngModel)]="book.is_selected" color="primary" (change)="copydata1(book, $event)">
                    </mat-checkbox>
                  </td>

                  <td>{{i + 1}}</td>
                  <td>{{ book["receipt_date"] | date: "dd-MM-yyy" }}</td>
                  <td>{{ book["receipt_no"] }}</td>
                  <td>{{ book["entry_date"] | date: "dd-MM-yyyy" }}</td>
                  <td>{{ book["voucher_no"] }}</td>
                  <td>{{ book["book_seller_name"] }}</td>
                  <td>{{ book["rep_name"] }}</td>
                  <td>{{ book["office_rep_name"] }}</td>
                  <td>{{ book["order_no"] }}</td>
                  <td>{{ book["order_date"] | date: "dd-MM-yyy" }}</td>
                  <td>{{ book["bill_no"] }}</td>
                  <td>{{ book["billdate"] | date: "dd-MM-yyy" }}</td>
                  <td>{{ book["bill_amount"] }}</td>
                  <td>{{ book["select_entry_amt"] }}</td>
                  <td>
                    <!-- <button style="margin-left: 5px" type="button" mat-icon-button class="btn btn-secondary"
                      (click)="openBookTwoReceipt();">
                      <mat-icon class="small-icon">visibility</mat-icon>
                    </button> -->
                    <!-- <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updateIssueAnk(book)">
                      Update
                    </button> -->


                    <button mat-icon-button class="btn-sm btn-outline-danger" matTooltip="Delete"
                      style="margin-left: 2%; vertical-align: middle; margin-top: -13px;"
                      (click)="deleteBookPymtreceipt(book.id)">
                      <mat-icon>delete</mat-icon>
                    </button>
                    <button style="margin-left: 1%" type="button" mat-raised-button class="btn btn-info"
                      (click)="selectedItem1(book) ">
                      Update
                    </button>

                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td><strong>Total :</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>{{ receivedAmount | number:'1.0-2' }}</strong></td>

                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </mat-card>
      </ng-template>
    </mat-tab>
    <mat-tab label>
      <ng-template mat-tab-label>7<br>
        Book Invoice<br>
      </ng-template>
      <ng-template matTabContent>
      <div style="margin-top: 20px">
        <div class="text-center">
          <h1 style="font-size: medium; font-weight: bold"></h1>
        </div>
      </div>
      <mat-radio-group [(ngModel)]="entryType" (change)="onEntryTypeChange()" style="margin-top: 20px">
        <mat-radio-button value="book" style="margin-right: 30px;">Book</mat-radio-button>
        <mat-radio-button value="granth">Granth</mat-radio-button>
      </mat-radio-group>
      <form class="form" [formGroup]="invoicegetCustBook">
        <!-- ======= BOOK INVOICE ======= -->
        <div *ngIf="entryType === 'book'" class="add-new-subscriber mat-elevation-z4 ms-3">
          <h2 style="margin-left: 50px; margin-top: 15px; color: primary;">Book Invoice</h2>

          <mat-form-field appearance="outline" style="margin-left: 3%; width: 20%;">
            <mat-label>Enter Date</mat-label>

            <div class="date-inline">
              <!-- Start Date -->
              <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />

              <span class="dash"> - </span>

              <!-- End Date -->
              <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                (blur)="getCustDateRange()" />
            </div>

            <!-- Errors -->
            <mat-error *ngIf="invoicegetCustBook.get('start')?.hasError('required')">
              Start date is required
            </mat-error>

            <mat-error *ngIf="invoicegetCustBook.get('end')?.hasError('required')">
              End date is required
            </mat-error>

            <mat-error *ngIf="invoicegetCustBook.hasError('dateRangeInvalid')">
              End date must be greater than start date
            </mat-error>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; width: 20%;">
            <mat-label>Book Customer Name</mat-label>
            <mat-select formControlName="cust_name" multiple (selectionChange)="updateAllSelectedState1()">
              <mat-option (click)="selectAllOptions1($event)">All</mat-option>
              <mat-option *ngFor="let option of uniquedata" [value]="option">{{ option.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; width: 20%;">
            <mat-label>Book Name</mat-label>
            <mat-select #mySel1 (selectionChange)="getbookname1($event)" formControlName="bookwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection1()">All</mat-option>
              <mat-option *ngFor="let item of Filteredbookdata2" [value]="item.bookname">{{ item.bookname
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button type="button" mat-raised-button color="primary" style="margin-left: 5%"
            (click)="searchbookselname2()">
            Search Book
          </button>

          <div style="display: flex; align-items: center; gap: 20px; margin-left: 20px;">
            <mat-form-field style="width: 30%" class="example-full-width" appearance="outline">
              <mat-label>Book Invoice Date</mat-label>
              <input matInput [matDatepicker]="picker_invoice_date" formControlName="date" [min]="financialYearMin"
                [max]="financialYearMax" (dateChange)="invoicedateChange($event)" required />
              <mat-datepicker-toggle matSuffix [for]="picker_invoice_date"></mat-datepicker-toggle>
              <mat-datepicker #picker_invoice_date [dateFilter]="dateFilter"></mat-datepicker>
            </mat-form-field>

            <div class="form-row mb-3 ms-3" style="display: flex; align-items: center;">
              <h3 style="padding-top: 10px; margin-right: 15px; margin-left: 20px;">Book Invoice New/Delete:</h3>
              <mat-button-toggle-group formControlName="newordeleted" (change)="newdelInvoice($event)"
                name="bookFontStyle" aria-label="Book Invoice Style" style="height: 50px;">
                <mat-button-toggle value="new">New</mat-button-toggle>
                <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>

          <mat-form-field *ngIf="!deleteInc" style="margin-left: 20px; width: 30%" class="example-full-width"
            appearance="outline">
            <mat-label>Book Bill No :</mat-label>
            <input type="text" [(ngModel)]="invoiceno" formControlName="billno" matInput required readonly />
          </mat-form-field>

          <mat-form-field *ngIf="deleteInc" style="margin-left: 20px; width: 30%" class="example-full-width"
            appearance="outline">
            <mat-label>Book Bill No (Deleted) :</mat-label>
            <mat-select formControlName="billno" required>
              <mat-option *ngFor="let bill of getdeletereciptinvoice" [value]="bill.rcpt_no">{{ bill.rcpt_no
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button style="margin-left: 20px;" (click)="openAdvtBill()" mat-raised-button color="primary">
            Generate Book Invoice
          </button>

          <div style="margin-top: 20px" class="tableFixHead">
            <button type="button" (click)="exportexcel()" class="btn btn-danger">Export Book</button>
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th><mat-checkbox [checked]="allSelectedtable1" (change)="selectAllRows($event)"
                      color="primary"></mat-checkbox></th>
                  <th>Sr.No.</th>
                  <th>Book Order No</th>
                  <th>Book Order Date</th>
                  <th>Book Seller Name</th>
                  <th>Book Seller Mobile No</th>
                  <th>Book Representative Name</th>
                  <th>Book Total Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of bookinvoicedata; let i = index">
                  <td><mat-checkbox [(ngModel)]="book.selected" [ngModelOptions]="{standalone: true}"
                      color="primary"></mat-checkbox></td>
                  <td>{{ i + 1 }}</td>
                  <td>{{ book.orderno }}</td>
                  <td>{{ book.date | date: "dd-MM-yyyy" }}</td>
                  <td>{{ book.name }}</td>
                  <td>{{ book.mob }}</td>
                  <td>{{ book.repname }}</td>
                  <td>{{ book.total }}</td>
                  <td>
                    <button mat-icon-button matTooltip="View Book Order" (click)="showOrder(book)">
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button class="btn btn-danger btn-sm" type="button" (click)="cancel(book)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ======= GRANTH INVOICE ======= -->
        <div *ngIf="entryType === 'granth'" class="add-new-subscriber mat-elevation-z4 ms-3">
          <h2 style="margin-left: 20px; margin-top: 15px; color: primary;">Granth Invoice</h2>

          <mat-form-field appearance="fill" style="margin-top: 5%; margin-left: 20px; width: 30%;">
            <mat-label>Granth Order Date</mat-label>
            <mat-date-range-input [rangePicker]="picker3">
              <input matStartDate formControlName="start" placeholder="Granth Start Date" />
              <input matEndDate formControlName="end" placeholder="Granth End Date" (dateChange)="getCustDateRange()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-date-range-picker #picker3></mat-date-range-picker>
            <mat-error *ngIf="invoicegetCustBook.controls.start.hasError('matStartDateInvalid')">Invalid Granth Start
              Date</mat-error>
            <mat-error *ngIf="invoicegetCustBook.controls.end.hasError('matEndDateInvalid')">Invalid Granth End
              Date</mat-error>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; width: 20%;">
            <mat-label>Granth Customer Name</mat-label>
            <mat-select formControlName="cust_name" multiple (selectionChange)="updateAllSelectedState1()">
              <mat-option (click)="selectAllOptionsgranth($event)">All</mat-option>
              <mat-option *ngFor="let option of granthunquiedata" [value]="option">{{ option.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; width: 20%;">
            <mat-label>Granth Name</mat-label>
            <mat-select #mySel1 (selectionChange)="getbookname1($event)" formControlName="bookwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection1()">All</mat-option>
              <mat-option *ngFor="let item of Filteredbookdatagranth" [value]="item.bookname">{{ item.bookname
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button type="button" mat-raised-button color="primary" style="margin-left: 5%"
            (click)="searchbookselname2()">
            Search Granth
          </button>

          <div style="display: flex; align-items: center; gap: 20px; margin-left: 20px;">
            <mat-form-field style="width: 30%" class="example-full-width" appearance="outline">
              <mat-label>Granth Invoice Date</mat-label>
              <input matInput [matDatepicker]="picker_invoice_date" formControlName="date" [min]="financialYearMin"
                [max]="financialYearMax" (dateChange)="invoicedateChange($event)" required />
              <mat-datepicker-toggle matSuffix [for]="picker_invoice_date"></mat-datepicker-toggle>
              <mat-datepicker #picker_invoice_date [dateFilter]="dateFilter"></mat-datepicker>
            </mat-form-field>

            <div class="form-row mb-3 ms-3" style="display: flex; align-items: center;">
              <h3 style="padding-top: 10px; margin-right: 15px; margin-left: 20px;">Granth Invoice New/Delete:</h3>
              <mat-button-toggle-group formControlName="newordeleted" (change)="newdelInvoice($event)"
                name="granthFontStyle" aria-label="Granth Invoice Style" style="height: 50px;">
                <mat-button-toggle value="new">New</mat-button-toggle>
                <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>

          <mat-form-field *ngIf="!deleteInc" style="margin-left: 20px; width: 30%" class="example-full-width"
            appearance="outline">
            <mat-label>Granth Bill No :</mat-label>
            <input type="text" [(ngModel)]="invoiceno" formControlName="billno" matInput required readonly />
          </mat-form-field>

          <mat-form-field *ngIf="deleteInc" style="margin-left: 20px; width: 30%" class="example-full-width"
            appearance="outline">
            <mat-label>Granth Bill No (Deleted) :</mat-label>
            <mat-select formControlName="billno" required>
              <mat-option *ngFor="let bill of getdeletereciptinvoice" [value]="bill.rcpt_no">{{ bill.rcpt_no
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button style="margin-left: 20px;" (click)="opengranthBill()" mat-raised-button color="primary">
            Generate Granth Invoice
          </button>

          <div style="margin-top: 20px" class="tableFixHead">
            <button type="button" (click)="exportexcel()" class="btn btn-danger">Export Granth</button>
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th><mat-checkbox [checked]="allSelectedtable1" (change)="selectAllRows($event)"
                      color="primary"></mat-checkbox></th>
                  <th>Sr.No.</th>
                  <th>Granth Order No</th>
                  <th>Granth Order Date</th>
                  <th>Granth Seller Name</th>
                  <th>Granth Seller Mobile No</th>
                  <th>Granth Representative Name</th>
                  <th>Granth Total Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of granthinvoicedata; let i = index">
                  <td><mat-checkbox [(ngModel)]="book.selected" [ngModelOptions]="{standalone: true}"
                      color="primary"></mat-checkbox></td>
                  <td>{{ i + 1 }}</td>
                  <td>{{ book.orderno }}</td>
                  <td>{{ book.date | date: "dd-MM-yyyy" }}</td>
                  <td>{{ book.name }}</td>
                  <td>{{ book.mob }}</td>
                  <td>{{ book.repname }}</td>
                  <td>{{ book.total }}</td>
                  <td>
                    <button mat-icon-button matTooltip="View Granth Order" (click)="showgranth(book)">
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button class="btn btn-danger btn-sm" type="button" (click)="cancelgranth(book)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </form>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>8<br>Book Billing<br>Register</ng-template>
      <ng-template matTabContent>
        <mat-card class="p-4">

          <!-- Radio Toggle -->
          <mat-radio-group [(ngModel)]="billingEntryType" style="margin: 16px 0; display:block;">
            <mat-radio-button value="book" style="margin-right: 30px;">Book</mat-radio-button>
            <mat-radio-button value="granth">Granth</mat-radio-button>
          </mat-radio-group>

          <!-- ===== BOOK BILLING REGISTER (ORIGINAL - UNCHANGED) ===== -->
          <div *ngIf="billingEntryType === 'book'">

            <!-- ================= Filters Section ================= -->
            <div class="flex flex-wrap items-center gap-3 mb-5" [formGroup]="BookbillingRegister">

              <!-- Date Range Picker -->
              <mat-form-field [formGroup]="BookbillingRegister" appearance="outline" class="field-25">
                <mat-label>Enter Date</mat-label>

                <div class="date-inline">
                  <input matInput type="date" formControlName="start" [min]="financialYearMin"
                    [max]="financialYearMax" />
                  <span class="dash"> - </span>
                  <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                    (blur)="getBookBillingDateRange()" />
                </div>
              </mat-form-field>

              <!-- Invoice Number -->
              <mat-form-field appearance="fill" style="width: 30%;margin-left: 3%;">
                <mat-label>Invoice No</mat-label>
                <input matInput type="text" formControlName="invoice_no" placeholder="Enter Invoice No" />
              </mat-form-field>

              <!-- Customer Name -->
              <mat-form-field appearance="fill" style="width: 30%;margin-left: 3%;">
                <mat-label>Customer Name</mat-label>
                <input matInput type="text" formControlName="cust_name" placeholder="Enter Customer Name" />
              </mat-form-field>

              <!-- Office Representative -->
              <mat-form-field appearance="fill" style="width: 30%;margin-left: 3%;">
                <mat-label>Office Representative</mat-label>
                <mat-select formControlName="officerepwise" multiple>
                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of office_rep_names" [value]="item.officerep">
                    {{ item.officerep }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Representative Name -->
              <mat-form-field appearance="fill" style="width: 30%;margin-left: 3%;">
                <mat-label>Representative Name</mat-label>
                <mat-select formControlName="repwise" multiple>
                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of rep_names" [value]="item.rep_name">
                    {{ item.rep_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 300px;margin-left: 3%;">
                <mat-label>Report Type</mat-label>
                <mat-select (selectionChange)="getAdvtInvoiceReportType($event)">
                  <mat-option value="In Detail">In Detail</mat-option>
                  <mat-option value="Briefly">Briefly</mat-option>
                  <mat-option value="office Rep In Detail">office Rep In Detail</mat-option>
                  <mat-option value="office Rep In Details">office Rep Briefly</mat-option>
                  <mat-option value="Office Rep -Briefly">Office Rep very Briefly</mat-option>
                  <mat-option value="Monthwise">Monthwise</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Search Button -->
              <button mat-raised-button color="primary" type="button" style="margin-left: 3%;"
                (click)="searchbookselname1()">
                Search
              </button>

              <!-- Search Report -->
              <button mat-raised-button color="primary" type="submit" style="margin-left: 3%;"
                (click)="openAdvtInvoiceRegister()">
                Search Report
              </button>

            </div>

            <!-- ================= Print Button ================= -->
            <div class="mb-3">
              <button mat-raised-button color="primary" type="button" (click)="opentworeceipt()">
                Print
              </button>
            </div>

            <!-- ================= Table Section ================= -->
            <div class="tableFixHead mt-4">
              <table class="table table-bordered table-hover text-center">
                <thead>
                  <tr>
                    <th>
                      <mat-checkbox [checked]="allSelectedtable2" (change)="selectAllRowsbillng4($event)">
                      </mat-checkbox>
                    </th>
                    <th>Sr. No.</th>
                    <th>Invoice Date</th>
                    <th>Invoice No</th>
                    <th>Book Seller Name</th>
                    <th>Invoice Amount</th>
                    <th>Receipt</th>
                    <th>Credit</th>
                    <th>Pending</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let book of Filteredbookbillingdata; let i = index">
                    <tr>
                      <td>
                        <mat-checkbox [(ngModel)]="book.is_selected" (change)="onCheckboxChange(book, $event)">
                        </mat-checkbox>
                      </td>
                      <td>{{ i + 1 }}</td>
                      <td>{{ book.invoice_date | date:'dd-MM-yyyy' }}</td>
                      <td>{{ book.invoice_no }}</td>
                      <td>{{ book.name }}</td>
                      <td>{{ book.invoice_total }}</td>
                      <td>
                        {{
                        toNumber(book.invoice_total)
                        - toNumber(book.remaining_amt)
                        - toNumber(book.crdtnote_total)
                        }}
                      </td>
                      <td>{{ book.crdtnote_total }}</td>
                      <td>{{ book.remaining_amt }}</td>
                      <td>
                        <button mat-icon-button matTooltip="View" (click)="show(book)">
                          <mat-icon>visibility</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="Cancel"
                          (click)="cancelBookInvoice(book.id, book.invoice_no)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <tfoot>
                  <tr style="font-weight:bold; background:#f2f2f2;">
                    <td colspan="5">TOTAL</td>
                    <td>{{ totalInvoice }}</td>
                    <td>{{ totalReceipt }}</td>
                    <td>{{ totalCredit }}</td>
                    <td>{{ totalPending }}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>

          </div>

          <!-- ===== GRANTH BILLING REGISTER (SAME AS BOOK) ===== -->
          <div *ngIf="billingEntryType === 'granth'">

            <!-- ================= Filters Section ================= -->
            <div class="flex flex-wrap items-center gap-3 mb-5" [formGroup]="BookbillingRegister">

              <!-- Date Range Picker -->
              <mat-form-field [formGroup]="BookbillingRegister" appearance="outline" class="field-25">
                <mat-label>Enter Date</mat-label>

                <div class="date-inline">
                  <input matInput type="date" formControlName="start" [min]="financialYearMin"
                    [max]="financialYearMax" />
                  <span class="dash"> - </span>
                  <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                    (blur)="getBookBillingDateRange()" />
                </div>
              </mat-form-field>

              <!-- Invoice Number -->
              <mat-form-field appearance="fill" style="width: 30%;margin-left: 3%;">
                <mat-label>Invoice No</mat-label>
                <input matInput type="text" formControlName="invoice_no" placeholder="Enter Invoice No" />
              </mat-form-field>

              <!-- Customer Name -->
              <mat-form-field appearance="fill" style="width: 30%;margin-left: 3%;">
                <mat-label>Customer Name</mat-label>
                <input matInput type="text" formControlName="cust_name" placeholder="Enter Customer Name" />
              </mat-form-field>

              <!-- Office Representative -->
              <mat-form-field appearance="fill" style="width: 30%;margin-left: 3%;">
                <mat-label>Office Representative</mat-label>
                <mat-select formControlName="officerepwise" multiple>
                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of office_rep_names" [value]="item.officerep">
                    {{ item.officerep }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Representative Name -->
              <mat-form-field appearance="fill" style="width: 30%;margin-left: 3%;">
                <mat-label>Representative Name</mat-label>
                <mat-select formControlName="repwise" multiple>
                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of rep_names" [value]="item.rep_name">
                    {{ item.rep_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 300px;margin-left: 3%;">
                <mat-label>Report Type</mat-label>
                <mat-select (selectionChange)="getgranthInvoiceReportType($event)">
                  <mat-option value="In Detail">In Detail</mat-option>
                  <mat-option value="Briefly">Briefly</mat-option>
                  <mat-option value="office Rep In Detail">office Rep In Detail</mat-option>
                  <mat-option value="office Rep In Details">office Rep Briefly</mat-option>
                  <mat-option value="Office Rep -Briefly">Office Rep very Briefly</mat-option>
                  <mat-option value="Monthwise">Monthwise</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Search Button -->
              <button mat-raised-button color="primary" type="button" style="margin-left: 3%;"
                (click)="searchbookselname1()">
                Search
              </button>

              <!-- Search Report -->
              <button mat-raised-button color="primary" type="submit" style="margin-left: 3%;"
                (click)="openAdvtInvoiceRegister()">
                Search Report
              </button>

            </div>

            <!-- ================= Print Button ================= -->
            <div class="mb-3">
              <button mat-raised-button color="primary" type="button" (click)="opentworeceipt()">
                Print
              </button>
            </div>

            <!-- ================= Table Section ================= -->
            <div class="tableFixHead mt-4">
              <table class="table table-bordered table-hover text-center">
                <thead>
                  <tr>
                    <th>
                      <mat-checkbox [checked]="allSelectedtable2" (change)="selectAllRowsbillng4($event)">
                      </mat-checkbox>
                    </th>
                    <th>Sr. No.</th>
                    <th>Invoice Date</th>
                    <th>Invoice No</th>
                    <th>Granth Seller Name</th>
                    <!-- <th>Invoice Amount</th> -->
                    <!-- <th>Receipt</th>
                    <th>Credit</th>
                    <th>Pending</th> -->
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let book of Filteredgranthbillingdata; let i = index">
                    <tr>
                      <td>
                        <mat-checkbox [(ngModel)]="book.is_selected" (change)="onCheckboxChange(book, $event)">
                        </mat-checkbox>
                      </td>
                      <td>{{ i + 1 }}</td>
                      <td>{{ book.invoice_date | date:'dd-MM-yyyy' }}</td>
                      <td>{{ book.invoice_no }}</td>
                      <td>{{ book.name }}</td>
                      <!-- <td>{{ book.invoice_total }}</td> -->
                      <!-- <td>
                        {{
                        toNumber(book.invoice_total)
                        - toNumber(book.remaining_amt)
                        - toNumber(book.crdtnote_total)
                        }}
                      </td>
                      <td>{{ book.crdtnote_total }}</td>
                      <td>{{ book.remaining_amt }}</td> -->
                      <td>
                        <button mat-icon-button matTooltip="View" (click)="show1(book)">
                          <mat-icon>visibility</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="Cancel"
                          (click)="cancelBookInvoice(book.id, book.invoice_no)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <!-- <tfoot> -->
                <!-- <tr style="font-weight:bold; background:#f2f2f2;">
                    <td colspan="5">TOTAL</td>
                    <td>{{ totalInvoice }}</td>
                    <td>{{ totalReceipt }}</td>
                    <td>{{ totalCredit }}</td>
                    <td>{{ totalPending }}</td>
                    <td></td>
                  </tr>
                </tfoot> -->
              </table>
            </div>

          </div>

        </mat-card>
      </ng-template>
    </mat-tab>





    <mat-tab label>
      <ng-template mat-tab-label>9<br>
        Book Credit<br>Note
      </ng-template>
      <ng-template matTabContent>
      <mat-card>
        <form [formGroup]="bookcrdtnoteForm">
          <div class="form-row">

            <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Today Date</mat-label>
              <input matInput type="date" formControlName="todaydate" [min]="financialYearMin"
                [max]="financialYearMax" />
            </mat-form-field>


            <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 35%; margin-left: 05%">
              <mat-label>Date</mat-label>
              <input matInput type="date" formControlName="date" />
            </mat-form-field> -->
            <mat-form-field style="width: 35%; margin-left: 05%" class="example-full-width" appearance="outline">
              <mat-label>Credit Note Date</mat-label>
              <input matInput [matDatepicker]="picker_crdt_date" formControlName="date" [min]="financialYearMin"
                [max]="financialYearMax" (dateChange)="crdtNotedateChange($event)" required />
              <mat-datepicker-toggle matSuffix [for]="picker_crdt_date"></mat-datepicker-toggle>
              <mat-datepicker #picker_crdt_date [dateFilter]="dateFilter"></mat-datepicker>
            </mat-form-field>

            <!-- <mat-form-field appearance="outline" class="example-full-width me-3" style="width: 35%; margin-left: 05%">
              <mat-label>Credit Note No</mat-label>
              <input matInput formControlName="crdtnoteno" />
            </mat-form-field> -->

            <div class="form-row mb-3 ms-3" style="display: flex; align-items: center;">
              <h3 style="padding-top: 10px; margin-right: 15px; margin-left: 50px;">Select Creditnote is New/Delete:
              </h3>
              <mat-button-toggle-group formControlName="newordeleted" (change)="newdelcrdtnote($event)" name="fontStyle"
                aria-label="Font Style" style="height: 50px;">
                <mat-button-toggle value="new">New</mat-button-toggle>
                <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
              </mat-button-toggle-group>
            </div>



          </div>

          <mat-form-field *ngIf="!deletecn" style="margin-left: 05%; width: 35%" class="example-full-width"
            appearance="outline">
            <mat-label>Credit Note No :</mat-label>
            <input type="text" [(ngModel)]="crdtnoteno" formControlName="crdtnoteno" matInput required readonly />
          </mat-form-field>
          <mat-form-field *ngIf="deletecn" style="margin-left: 05%; width: 35%" class="example-full-width"
            appearance="outline">
            <mat-label>Credit Note No (deleted) :</mat-label>
            <mat-select formControlName="crdtnoteno" required>
              <mat-option *ngFor="let bill of getdeletecn" [value]="bill.crdtnote_no">
                {{ bill.crdtnote_no }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="example-full-width" style="width: 35%; margin-left: 05%">
            <mat-label>Book Seller Name</mat-label>
            <input matInput formControlName="bsname" [matAutocomplete]="autobs" />
            <mat-autocomplete autoActiveFirstOption #autobs="matAutocomplete">
              <mat-option *ngFor="let option of filteredOptions9 | async" [value]="option['name']"
                (onSelectionChange)="selected_booksellername($event, option)">
                {{ option["name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <!-- <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Representative Name</mat-label>
              <input matInput formControlName="repname" [matAutocomplete]="autorepname" />
              <mat-autocomplete autoActiveFirstOption #autorepname="matAutocomplete">
                <mat-option (onSelectionChange)="selected_repname($event, option)"
                  *ngFor="let option of filteredOptions10 | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 35%; margin-left: 05%">
              <mat-label>Office Representative Name</mat-label>
              <input matInput type="text" formControlName="offrepname" />
            </mat-form-field>
          </div> -->
          <div class="form-row">


          </div>
        </form>
        <div>
          <div>
            <mat-progress-spinner *ngIf="showrcpt" style="margin-left: auto; margin-right: auto" color="warn"
              mode="indeterminate">
            </mat-progress-spinner>
          </div>
          <div *ngIf="!showrcpt">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Invoice No</th>
                  <th>Invoice Date</th>
                  <th>Book Seller Name</th>
                  <th>Amount</th>
                  <th>Remaining Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of this.BookBillingData; let i = index">
                  <td>{{ item["invoice_no"] }}</td>
                  <td>{{ item["invoice_date"] }}</td>
                  <td>{{ item["name"] }}</td>
                  <td>{{ item["invoice_total"]}}</td>
                  <td>
                    <span *ngIf="item['remaining_amt'] != 0">{{
                      item["remaining_amt"]
                      }}</span>
                    <span *ngIf="item['remaining_amt'] == 0">{{
                      item["invoice_total"]
                      }}</span>
                  </td>
                  <td style="display: flex; justify-items: center">
                    <button type="button" class="btn btn-primary" mat-raised-button (click)="billSelected(item)">
                      Select
                    </button>
                  </td>
                </tr>
                <tr *ngIf="showmsg">
                  <td colspan="5" style="text-align: center">
                    <h2 style="color: red">Data is not Available</h2>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


        <div *ngIf="displaybooks" style="margin-top: 5%">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Book Name</th>
                <th>Net Amount</th>
                <th>Copies</th>
                <th>Shipping Charges</th>
                <th>Total</th>
                <th>Receive Amount</th>
                <th>Pending Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.booksDataofCrdtNote; let i = index">
                <td>{{ item["book_name"] }}</td>
                <td>
                  {{
                  ConvertToInt(item["netamt"]) -
                  ConvertToInt(item["discountamt"])
                  }}
                </td>
                <td>{{ item["copies"] }}</td>
                <td>{{ item["shipping_charges"] }}</td>
                <td>
                  {{
                  ConvertToInt(item["total"]) +
                  ConvertToInt(item["shipping_charges"])
                  }}
                </td>
                <td>{{ item["received_amt"] }}</td>
                <td>{{ item["remaining_amt"] }}</td>
                <td style="display: flex; justify-items: center">
                  <button type="button" class="btn btn-primary" mat-raised-button (click)="booksSelected(item)">
                    Select
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="selectedbooks" style="margin-top: 5%" class="tableFixHead1">



          <form [formGroup]="bookselectedForm">





            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Book Name</th>
                  <th>Net Amount</th>
                  <th>Copies</th>
                  <th>Shipping Charges</th>
                  <th>Total</th>
                  <th>Receive Amount</th>
                  <th>Pending Amount</th>
                  <th>Return Book Copies</th>
                  <th>Credit Note Amount</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of this.selectedBooks; let i = index">
                  <td>{{ item["book_name"] }}</td>
                  <td>{{ item["netamt"] }}</td>
                  <td>{{ item["copies"] }}</td>
                  <td>{{ item["shipping_charges"] }}</td>
                  <td>{{ item["total"] }}</td>
                  <td>{{ item["received_amt"] }}</td>
                  <td>{{ item["remaining_amt"] }}</td>
                  <td>
                    <mat-form-field appearance="outline" class="example-full-width" style="width: 30%">
                      <mat-label></mat-label>
                      <input matInput type="number" formControlName="returncopies" (change)="copies($event, item)" />
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="example-full-width" style="width: 30%">
                      <mat-label></mat-label>
                      <input matInput type="number" formControlName="crdtnoteamt"
                        (change)="crdtNoteAmt($event, item)" />
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="example-full-width" style="width: 100%">
                      <mat-label></mat-label>
                      <textarea matInput type="text" formControlName="remark"
                        (change)="remark($event, item)"></textarea>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td colspan="8"></td>
                  <td>{{ this.crdtnotetotal }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div class="form-group">
          <button class="btn btn-primary" mat-raised-button type="submit" (click)="addbookpymtcrdt()"
            style="margin-right: 42%; width: 25%">
            Add
          </button>


        </div>
      </mat-card>
      </ng-template>
    </mat-tab>

    <!-- <mat-tab label="Book Credit Note Report">
      <mat-card style="padding: 10px 10px">
        <div class="tableFixHead" style="margin-top: 2%">
          <table class="table table-striped table-hover text-center">
            <thead>
              <tr>
                <td>Credit Note No.</td>
                <td>Date</td>
                <td>Book Seller Name</td>
                <td>Representative Name</td>
                <td>Credit Note Total</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.FilteredBookCreditNoteData">
                <td>{{ item["crdtnote_no"] }}</td>
                <td>{{ item["date"] | date: "dd-MM-yyy" }}</td>
                <td>{{ item["book_seller_name"] }}</td>
                <td>{{ item["rep_name"] }}</td>
                <td>{{ item["crdtnote_total"] }}</td>
                <td>
                  <button type="button" mat-raised-button class="btn btn-primary" (click)="showcrdtrcpt(item)">
                    Show
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>
    </mat-tab> -->


    <mat-tab label>
      <ng-template mat-tab-label>10<br>
        Book Credit<br>Note Register
      </ng-template>
      <ng-template matTabContent>
      <mat-card style="padding: 10px 10px">
        <form [formGroup]="bookrcptregisterform">

          <!-- Row 1 -->
          <div class="form-row">
            <!-- Credit Receipt Date -->
            <mat-form-field [formGroup]="bookrcptregisterform" appearance="outline"
              style="margin-left: 3%; width: 25%;">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getBookReceiptDateRange1()" />
              </div>
            </mat-form-field>

            <!-- Bill No Wise -->
            <mat-form-field style="margin-left: 3%; width: 25%;" appearance="outline">
              <mat-label>बिल क्रमांक :</mat-label>
              <input matInput type="text" formControlName="billnowise" (keyup)="filterByBillNo()"
                placeholder="Bill No टाइप करा" />
            </mat-form-field>
            <!-- Remark Wise -->
            <mat-form-field style="margin-left: 3%; width: 25%;" appearance="outline">
              <mat-label>Remark</mat-label>

              <mat-select formControlName="remarkwise">

                <!-- <mat-option value="">All</mat-option> -->

                <mat-option value="विक्री झाली नाही">
                  विक्री झाली नाही
                </mat-option>

                <mat-option value="खराब पुस्तके परत आली">
                  खराब पुस्तके परत आली
                </mat-option>

                <mat-option value="बुक सेलर पैसे भरत नाही">
                  बुक सेलर पैसे भरत नाही
                </mat-option>

                <mat-option value="TDS रक्कम">
                  TDS रक्कम
                </mat-option>

              </mat-select>
            </mat-form-field>

            <!-- Book Wise -->

            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Book Name Type:</mat-label>
              <mat-select #mySel1 (selectionChange)="getbookname1($event)" formControlName="bookwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection1()">All</mat-option>
                <mat-option *ngFor="let item of Filteredbookdata2" [value]="item.bookname">
                  {{ item.bookname }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Representative Name :</mat-label>
              <mat-select #mySel1 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractRepName" [value]="item['name']">
                  {{ item['name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Office Representative :</mat-label>
              <mat-select #mySel1 (selectionChange)="getofficerepname($event)" formControlName="officerepwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractOffRepName" [value]="item['name']">
                  {{ item['name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Row 2 -->
          <div class="form-row">
            <!-- Representative Name -->
            <!-- <mat-form-field style="margin-left: 7%; width: 30%;">
              <mat-label>Representative Name :</mat-label>
              <mat-select #mySel1 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractRepName" [value]="item['name']">
                  {{ item['name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->

            <!-- Office Representative -->
            <!-- <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Office Representative :</mat-label>
              <mat-select #mySel1 (selectionChange)="getofficerepname($event)" formControlName="officerepwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractOffRepName" [value]="item['name']">
                  {{ item['name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->

            <!-- Book Seller -->
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 5%">
              <mat-label>Book Seller Name Search</mat-label>

              <input formControlName="booksellerwise" type="text" matInput [matAutocomplete]="autobsname"
                (keyup)="getBookSellerNames($event)" />

              <mat-autocomplete autoActiveFirstOption #autobsname="matAutocomplete">
                <mat-option *ngFor="let option of bool_seller_names" [value]="option.name"
                  (onSelectionChange)="selectedname($event, option)">
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="VeryBriefly-Officer">In Detail All</mat-option>
                <mat-option value="InDetail">In Detail </mat-option>
                <!-- <mat-option value="VeryBriefly-Officer">Indetail</mat-option> -->
                <mat-option value="briefly1"> All Briefly</mat-option>
                <!-- <mat-option value="VeryBriefly-Officer">Indetail</mat-option> -->
                <!-- <mat-option value="briefly1">Briefly</mat-option> -->
                <!-- <mat-option value="Monthwise">Monthwise</mat-option> -->
                <mat-option value="InDetail-Officer">Rep Very Briefly</mat-option>
                <!-- <mat-option value="VeryBriefly-Officer">IndetailsAll</mat-option> -->
                <mat-option value="Briefly-Officer">Office Rep -Briefly</mat-option>
                <mat-option value="Monthwise">Monthwise</mat-option>
              </mat-select>
            </mat-form-field>

            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showReceiptReports1()">search report</button>
            </div>
          </div>

          <!-- Row 3 -->
          <div class="form-row">
            <!-- Report Type -->


            <!-- Buttons -->
            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="btn btn-info"
                (click)="getBookReceiptRegister1()">Search</button>
            </div>

            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="btn btn-info"
                (click)="openBookCreditReceipt()">Print</button>
            </div>
            <!-- <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showReceiptReports1()">search report</button>
            </div> -->
          </div>
        </form>

        <!-- Table -->
        <div id="excel-table">
          <div style="margin-top: 20px; margin-left: 20px;" class="tableFixHead">

            <button type="button" (click)="exportexcel()" class="btn btn-danger">Export</button>

            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th>
                    <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                      (change)="selectall($event)">
                    </mat-checkbox>
                  </th>
                  <th>Sr.No.</th>
                  <th>Creditnote Date</th>
                  <th>Creditnote No</th>
                  <th>Book Seller Name</th>
                  <th>Representative Name</th>
                  <th>Off.Rep.Name</th>
                  <th>Bill No</th>
                  <th>Bill Date</th>
                  <th>Bill Amount</th>
                  <th>Crdt Received Amount</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let book of FilteredbookCrdtdata; let i = index">
                  <td>
                    <mat-checkbox [(ngModel)]="book.is_selected" color="primary" (change)="copydata1(book, $event)">
                    </mat-checkbox>
                  </td>
                  <td>{{ i + 1 }}</td>
                  <td>{{ book['crdtnote_date'] | date: 'dd-MM-yyy' }}</td>
                  <td>{{ book['crdtnote_no'] }}</td>
                  <td>{{ book['book_seller_name'] }}</td>
                  <td>{{ book['rep_name'] }}</td>
                  <td>{{ book['office_rep_name'] }}</td>
                  <td>{{ book['bill_no'] }}</td>
                  <td>{{ book['billdate'] | date: 'dd-MM-yyy' }}</td>
                  <td>{{ book['bill_amount'] }}</td>
                  <td>{{ book['crdtnote_total'] }}</td>
                  <td>
                    <button mat-icon-button class="btn-sm btn-outline-danger" matTooltip="Delete"
                      style="margin-left: 2%; vertical-align: middle; margin-top: -13px;"
                      (click)="deleteBookPymtCrdt(book.id)">
                      <mat-icon>delete</mat-icon>
                    </button>

                    <button mat-raised-button type="button" class="btn btn-info" style="margin-left: 1%;"
                      (click)="updatePerBooksRate1(book)">
                      Update
                    </button>
                  </td>
                </tr>
              </tbody>

              <tfoot>
                <tr>
                  <td></td>
                  <td><strong>Total :</strong></td>
                  <td colspan="8"></td>
                  <td><strong>{{ receivedCrdtAmount | number: '1.0-2' }}</strong></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>

          </div>
        </div>
      </mat-card>
      </ng-template>
    </mat-tab>

    <mat-tab label>
      <ng-template mat-tab-label>11<br>
        GST Report<br>
      </ng-template>
      <ng-template matTabContent>
      <mat-card>
        <div class="form-row">
          <mat-form-field [formGroup]="gstreportForm" appearance="outline" style="width: 25%; margin-left: 5%">
            <mat-label>Enter Date</mat-label>

            <div class="date-inline">
              <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
              <span class="dash"> - </span>
              <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                (blur)="getChangedDategstreport()" />
            </div>
          </mat-form-field>
          <div style="margin-left: 5%;margin-top: 2%;">
            <button class="btn" mat-raised-button color="primary" (click)="getBookGSTReportData()">GST
              Report Print</button>
          </div>
        </div>
        <div id="excel-table">
          <div class="tableFixHead">
            <!-- <button type="button" (click)="excelToExportGSTReport('GST_Report')" class="btn btn-danger">
                      Export
                    </button>  -->

            <table class="table table-striped text-center">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Receipt Date</th>
                  <th>Book Seller Name</th>
                  <th>Address</th>
                  <th>Receipt No</th>
                  <th>GST No</th>
                  <th>HSN Code</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of bookRcptRegisterdata; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item["receipt_date"] | date:"dd-MM-yyyy" }}</td>
                  <td>{{ item["book_seller_name"] }}</td>
                  <td>{{ item["district"]}}</td>
                  <td>{{ item["receipt_no"] }}</td>
                  <td>27AAATH0433Q1ZI</td>
                  <td>4902</td>
                  <td>{{ item["select_entry_amt"] }}</td>

                  <!-- <td><input type="text" value="{{ item['rcpt_no'] }}"
                              (change)="addBillGSTHSNData($event, i, 'billno')"></td>
                          <td><input type="text" value="{{ item['gst_no'] }}" (change)="addBillGSTHSNData($event, i, 'gstno')">
                          </td>
                          <td><input type="text" value="{{ item['hsn_code'] }}"
                              (change)="addBillGSTHSNData($event, i, 'hsncode')"></td>
                          <td>{{ item["total_amt"] }}</td>
                        </tr>
                        <tr>
                          <td colspan="7"></td>
                          <td>{{ this.gstreporttotalamt }}</td>
                    </tr> -->
              </tbody>
            </table>

          </div>
        </div>
      </mat-card>
      </ng-template>
    </mat-tab>

    <mat-tab label>
      <ng-template mat-tab-label>
        12<br>
        Book Seller<br>Ledger
      </ng-template>
      <ng-template matTabContent>

      <!-- ===== SAME entryType pattern as Tab 3 (book / granth) ===== -->
      <mat-radio-group [(ngModel)]="entryType" (change)="onEntryTypeChange()"
        style="margin-top: 20px; margin-left: 16px; display: block;">
        <mat-radio-button value="book" style="margin-right: 30px;">Book</mat-radio-button>
        <mat-radio-button value="granth">Granth</mat-radio-button>
      </mat-radio-group>


      <!-- ===================== BOOK SUB-TAB ===================== -->
      <div *ngIf="entryType === 'book'" class="mat-elevation-z4 ms-3" style="margin-top: 12px;">

        <mat-card class="card">
          <form class="form" [formGroup]="BookLedgerform">
            <div class="form-row">

              <mat-form-field [formGroup]="BookLedgerform" appearance="outline" style="margin-left: 3%; width: 25%;">
                <mat-label>Enter Date</mat-label>
                <div class="date-inline">
                  <input matInput type="date" formControlName="start_date" [min]="financialYearMin"
                    [max]="financialYearMax" />
                  <span class="dash"> - </span>
                  <input matInput type="date" formControlName="end_date" [min]="financialYearMin"
                    [max]="financialYearMax" (change)="getChangedDateContractM7()" />
                </div>
              </mat-form-field>

              <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%;">
                <mat-label>Book Seller Name :</mat-label>
                <input #myInput matInput formControlName="book_seller_name" (keyup)="getBookSellerNames($event)"
                  [matAutocomplete]="advtNames" />
                <mat-autocomplete #advtNames="matAutocomplete">
                  <mat-option (selectionChange)="getContractOffRepName($event)" *ngFor="let option of bool_seller_names"
                    [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field style="margin-left: 7%; width: 35%;">
                <mat-label>Select type of report</mat-label>
                <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                  <mat-option value="InDetail-booksellerledger">In Detail</mat-option>
                  <mat-option value="briefly-booksellerledger">Briefly</mat-option>
                </mat-select>
              </mat-form-field>

              <button type="button" mat-raised-button color="primary" class="mt-2" style="margin-left: 5%"
                (click)="showBoookLedgerReport()">
                Search
              </button>

            </div>
          </form>
        </mat-card>

      </div>
      <!-- ===================== END BOOK SUB-TAB ===================== -->


      <!-- ===================== GRANTH SUB-TAB ===================== -->
      <div *ngIf="entryType === 'granth'" class="mat-elevation-z4 ms-3" style="margin-top: 12px;">
        <h2 style="margin-left: 20px; margin-top: 15px;">Granth Seller Ledger</h2>

        <mat-card class="card">
          <form class="form" [formGroup]="GranthLedgerform">
            <div class="form-row">

              <mat-form-field [formGroup]="GranthLedgerform" appearance="outline" style="margin-left: 3%; width: 25%;">
                <mat-label>Enter Date</mat-label>
                <div class="date-inline">
                  <input matInput type="date" formControlName="start_date" [min]="financialYearMin"
                    [max]="financialYearMax" />
                  <span class="dash"> - </span>
                  <input matInput type="date" formControlName="end_date" [min]="financialYearMin"
                    [max]="financialYearMax" (change)="getChangedDateContractgranth()" />
                </div>
              </mat-form-field>

              <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%;">
                <mat-label>Granth Seller Name :</mat-label>
                <input #myInputGranth matInput formControlName="book_seller_name" (keyup)="getGranthSellerNames($event)"
                  [matAutocomplete]="advtNamesGranth" />
                <mat-autocomplete #advtNamesGranth="matAutocomplete">
                  <mat-option (selectionChange)="getContractOffRepNameGranth($event)"
                    *ngFor="let option of granth_seller_names" [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field style="margin-left: 7%; width: 35%;">
                <mat-label>Select type of report</mat-label>
                <mat-select #mySel2 (selectionChange)="getContractReportType($event)">
                  <mat-option value="InDetail-granthsellerledger">In Detail</mat-option>
                  <mat-option value="briefly-granthsellerledger">Briefly</mat-option>
                </mat-select>
              </mat-form-field>

              <button type="button" mat-raised-button color="primary" class="mt-2" style="margin-left: 5%"
                (click)="showGranthLedgerReport()">
                Search
              </button>

            </div>
          </form>
        </mat-card>

      </div>
      <!-- ===================== END GRANTH SUB-TAB ===================== -->

      </ng-template>
    </mat-tab>

    <mat-tab label>
      <ng-template mat-tab-label>13<br>
        Book/Granth<br>Out Standing
      </ng-template>
      <ng-template matTabContent>

      <!-- ===== Click to switch between Book and Granth ===== -->
      <mat-radio-group [(ngModel)]="entryType" (change)="onEntryTypeChange()"
        style="margin: 20px 0 10px 16px; display: block;">
        <mat-radio-button value="book" style="margin-right: 30px;">Book</mat-radio-button>
        <mat-radio-button value="granth">Granth</mat-radio-button>
      </mat-radio-group>

      <!-- ===================== BOOK (shown when entryType === 'book') — content unchanged from original ===================== -->
      <div *ngIf="entryType === 'book'">
        <mat-card style="padding: 10px 10px">
          <form [formGroup]="bookoutstandingform">
            <div class="form-row" style="margin-top: 20px !important;">
              <mat-form-field [formGroup]="bookoutstandingform" appearance="outline"
                style="margin-left: 3%; width: 25%;">
                <mat-label>Enter Date</mat-label>

                <div class="date-inline">
                  <input matInput type="date" formControlName="start" [min]="financialYearMin"
                    [max]="financialYearMax" />
                  <span class="dash"> - </span>
                  <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                    (blur)="getBookOutdtandingDateRange()" />
                </div>
              </mat-form-field>

              <mat-form-field style="margin-left: 3%; width: 25%;">
                <mat-label>Representative Name : </mat-label>
                <mat-select #mySel1 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of rep_names" (onSelectionChange)="getContractRepNames($event) "
                    value="{{  item['rep_name'] }}">{{ item["rep_name"]
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="margin-left: 3%; width: 25%;">
                <mat-label>Office Representative : </mat-label>
                <mat-select #mySel1 (selectionChange)="getofficerepname($event)" formControlName="officerepwise"
                  multiple>
                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of office_rep_names"
                    (onSelectionChange)="getContractOfcRepNames($event) " value="{{  item['officerep'] }}">{{
                    item["officerep"]
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>


            <div class="form-row">



              <mat-form-field style="margin-left: 7%; width: 27%;">
                <mat-label>Book Seller प्रमाणे : </mat-label>
                <mat-select #mySel1 (selectionChange)="getbooksellerwise($event)" formControlName="booksellerwise"
                  multiple>

                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of  book__seller__name" (onSelectionChange)="getBookSellerName($event) "
                    value="{{  item['book__seller__name'] }}">{{
                    item["book__seller__name"]
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="margin-left: 3%; width: 35%;">
                <mat-label>Select type of report</mat-label>
                <mat-select #mySel1 (selectionChange)="getContracttReportType($event)">
                  <mat-option value="BookoutstandingInDetails">All In Detail
                  </mat-option>
                  <mat-option value="Bookoutstandingbriefly">All Briefly
                  </mat-option>
                  <mat-option value="unpaidOutstandingInDetails">Unpaid OutStanding In Detail
                  </mat-option>
                  <mat-option value="unpaidOutstandingbriefly">Unpaid OutStanding Briefly
                  </mat-option>
                  <mat-option value="OfficeRepbriefly">Office Rep Briefly
                  </mat-option>
                  <mat-option value="OfficeRepUnpaidbriefly"> Office Rep Unpaid OutStanding Briefly
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div style="margin-left: 40%;">
                <button mat-raised-button color="primary" type="button" class="
            btn btn-info" (click)="showOutstandingReports()">Search Report</button>
              </div>
            </div>
          </form>

          <mat-card style="margin-top:30px;">

            <h3 class="text-center" style="font-size:25px;color:black;margin-bottom:20px">
              Send Reminder Letter
            </h3>

            <form [formGroup]="Sendreminderform">

              <!-- ROW 1 -->
              <div class="form-row">

                <!-- Date Range -->
                <mat-form-field appearance="outline" style="margin-left:5%;width:35%">
                  <mat-label>Enter Date</mat-label>

                  <div class="date-inline">
                    <input matInput type="date" formControlName="start" [min]="financialYearMin"
                      [max]="financialYearMax" />

                    <span class="dash"> - </span>

                    <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                      (blur)="getBookOutdtandingDateRange1()" />
                  </div>
                </mat-form-field>

                <!-- Reminder Type -->
                <mat-form-field style="margin-left:10%;width:35%">
                  <mat-label>Reminder Type</mat-label>

                  <mat-select formControlName="reportType" (selectionChange)="getContractReportType($event)">

                    <mat-option value="send-reminder1">
                      To Book Seller
                    </mat-option>

                    <mat-option value="send-reminder2">
                      To Representative
                    </mat-option>

                  </mat-select>
                </mat-form-field>

              </div>

              <!-- ROW 2 -->
              <div class="form-row">

                <!-- Representative (WITH SELECT ALL) -->
                <mat-form-field style="margin-left:7%;width:30%">
                  <mat-label>Representative</mat-label>

                  <mat-select formControlName="repwise" multiple>

                    <!-- SELECT ALL -->
                    <mat-option (click)="toggleAllSelection6()">
                      <mat-pseudo-checkbox class="mat-option-pseudo-checkbox">
                      </mat-pseudo-checkbox>

                      All
                    </mat-option>

                    <!-- NORMAL OPTIONS -->
                    <mat-option *ngFor="let item of rep_names" [value]="item.rep_name">
                      {{ item.rep_name }}
                    </mat-option>

                  </mat-select>
                </mat-form-field>

                <!-- Book Seller (ONLY for reminder1) -->
                <mat-form-field style="margin-left:10%;width:35%" *ngIf="contractReportType === 'send-reminder1'">

                  <mat-label>Book Seller Name</mat-label>

                  <mat-select formControlName="booksellername" multiple>
                    <mat-option (click)="toggleAllSelection6()">
                      <mat-pseudo-checkbox class="mat-option-pseudo-checkbox">
                      </mat-pseudo-checkbox>

                      All
                    </mat-option>

                    <mat-option *ngFor="let item of book__seller__name" [value]="item.book__seller__name">
                      {{ item.book__seller__name }}
                    </mat-option>

                  </mat-select>

                </mat-form-field>

              </div>

              <!-- ROW 3 -->
              <div class="form-row">

                <button mat-raised-button color="primary" type="button" style="margin-left:5%;"
                  (click)="showContractReportReminder1()">
                  Search
                </button>

              </div>

            </form>

          </mat-card>
        </mat-card>
      </div>
      <!-- ===================== END BOOK ===================== -->


      <!-- ===================== GRANTH (shown when entryType === 'granth') — exact mirror of Book ===================== -->
      <div *ngIf="entryType === 'granth'">
        <mat-card style="padding: 10px 10px">
          <form [formGroup]="granthoutstandingform">
            <div class="form-row" style="margin-top: 20px !important;">
              <mat-form-field [formGroup]="granthoutstandingform" appearance="outline"
                style="margin-left: 3%; width: 25%;">
                <mat-label>Enter Date</mat-label>

                <div class="date-inline">
                  <input matInput type="date" formControlName="start" [min]="financialYearMin"
                    [max]="financialYearMax" />
                  <span class="dash"> - </span>
                  <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                    (blur)="getGranthOutdtandingDateRange()" />
                </div>
              </mat-form-field>

              <mat-form-field style="margin-left: 3%; width: 25%;">
                <mat-label>Representative Name : </mat-label>
                <mat-select #mySel2 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of rep_names" (onSelectionChange)="getContractRepNames($event) "
                    value="{{  item['rep_name'] }}">{{ item["rep_name"]
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="margin-left: 3%; width: 25%;">
                <mat-label>Office Representative : </mat-label>
                <mat-select #mySel2 (selectionChange)="getofficerepname($event)" formControlName="officerepwise"
                  multiple>
                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of office_rep_names"
                    (onSelectionChange)="getContractOfcRepNames($event) " value="{{  item['officerep'] }}">{{
                    item["officerep"]
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>


            <div class="form-row">



              <mat-form-field style="margin-left: 7%; width: 27%;">
                <mat-label>Granth Seller प्रमाणे : </mat-label>
                <mat-select #mySel2 (selectionChange)="getgranthsellerwise($event)" formControlName="granthsellerwise"
                  multiple>

                  <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of  granth__seller__name"
                    (onSelectionChange)="getGranthSellerName($event) " value="{{  item['granth__seller__name'] }}">{{
                    item["granth__seller__name"]
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="margin-left:3%; width:35%;">

                <mat-label>Select type of report</mat-label>

                <mat-select [(value)]="contractReportType" (selectionChange)="getGranthContracttReportType($event)">

                  <mat-option value="GranthoutstandingInDetails">
                    All In Detail
                  </mat-option>

                  <mat-option value="Bookoutstandingbriefly">
                    All Briefly
                  </mat-option>

                  <mat-option value="unpaidOutstandingInDetails">
                    Unpaid Outstanding In Detail
                  </mat-option>

                  <mat-option value="unpaidOutstandingbriefly">
                    Unpaid Outstanding Briefly
                  </mat-option>

                  <mat-option value="OfficeRepbriefly">
                    Office Rep Briefly
                  </mat-option>

                  <mat-option value="OfficeRepUnpaidbriefly">
                    Office Rep Unpaid Outstanding Briefly
                  </mat-option>

                </mat-select>

              </mat-form-field>

              <div style="margin-left: 40%;">
                <button mat-raised-button color="primary" type="button" class="
            btn btn-info" (click)="showOutstandingReportsGranth()">Search Report</button>
              </div>
            </div>
          </form>

          <mat-card style="margin-top:30px;">

            <h3 class="text-center" style="font-size:25px;color:black;margin-bottom:20px">
              Send Reminder Letter
            </h3>

            <form [formGroup]="Sendreminderformgranth">

              <!-- ROW 1 -->
              <div class="form-row">

                <!-- Date Range -->
                <mat-form-field appearance="outline" style="margin-left:5%;width:35%">
                  <mat-label>Enter Date</mat-label>

                  <div class="date-inline">
                    <input matInput type="date" formControlName="start" [min]="financialYearMin"
                      [max]="financialYearMax" />

                    <span class="dash"> - </span>

                    <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                      (blur)="getBookOutdtandingDateRange1()" />
                  </div>
                </mat-form-field>

                <!-- Reminder Type -->
                <mat-form-field style="margin-left:10%;width:35%">
                  <mat-label>Reminder Type</mat-label>

                  <mat-select formControlName="reportType" (selectionChange)="getContractReportType($event)">

                    <mat-option value="send-reminder1">
                      To Granth Seller
                    </mat-option>

                    <mat-option value="send-reminder2">
                      To Representative
                    </mat-option>

                  </mat-select>
                </mat-form-field>

              </div>

              <!-- ROW 2 -->
              <div class="form-row">

                <!-- Representative (WITH SELECT ALL) -->
                <mat-form-field style="margin-left:7%;width:30%">
                  <mat-label>Representative</mat-label>

                  <mat-select formControlName="repwise" multiple>

                    <!-- SELECT ALL -->
                    <mat-option (click)="toggleAllSelection6()">
                      <mat-pseudo-checkbox class="mat-option-pseudo-checkbox">
                      </mat-pseudo-checkbox>

                      All
                    </mat-option>

                    <!-- NORMAL OPTIONS -->
                    <mat-option *ngFor="let item of rep_names" [value]="item.rep_name">
                      {{ item.rep_name }}
                    </mat-option>

                  </mat-select>
                </mat-form-field>

                <!-- Book Seller (ONLY for reminder1) -->
                <mat-form-field style="margin-left:10%;width:35%" *ngIf="contractReportType === 'send-reminder1'">

                  <mat-label>Granth Seller Name</mat-label>

                  <mat-select formControlName="booksellername" multiple>
                    <mat-option (click)="toggleAllSelection6()">
                      <mat-pseudo-checkbox class="mat-option-pseudo-checkbox">
                      </mat-pseudo-checkbox>

                      All
                    </mat-option>

                    <mat-option *ngFor="let item of granth__seller__name" [value]="item.book__seller__name">
                      {{ item.book__seller__name }}
                    </mat-option>

                  </mat-select>

                </mat-form-field>

              </div>

              <!-- ROW 3 -->
              <div class="form-row">

                <button mat-raised-button color="primary" type="button" style="margin-left:5%;"
                  (click)="showContractReportReminderGranth()">
                  Search
                </button>

              </div>

            </form>
          </mat-card>
        </mat-card>
      </div>
      <!-- ===================== END GRANTH ===================== -->

      </ng-template>
    </mat-tab>


    <mat-tab label>
      <ng-template mat-tab-label>14<br>
        Pending Commission<br>Voucher
      </ng-template>
      <ng-template matTabContent>
      <div class="row" [formGroup]="bookcommForm" style="margin:15px 5px 5px 0px">

        <div class="row">
          <div class="col-md-4">
            <mat-form-field [formGroup]="bookcommForm" appearance="outline" style="width: 90%; margin-left: 10%;">
              <mat-label>Voucher date from...to</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />

                <span class="dash"> - </span>

                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="userprofileDateRangeComm()" />
              </div>
            </mat-form-field>
          </div>


          <div class="col-md-4">
            <mat-form-field [formGroup]="bookcommForm" appearance="outline" class="field-25">
              <mat-label>Entry date from...to</mat-label>

              <div class="date-inline">

                <!-- Start Date -->
                <input matInput type="date" formControlName="estart_date" [min]="financialYearMin"
                  [max]="financialYearMax" />

                <span class="dash"> - </span>

                <!-- End Date -->
                <input matInput type="date" formControlName="eend_date" [min]="financialYearMin"
                  [max]="financialYearMax" (blur)="entryDateRangeComm1()" />

              </div>

            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" style="width: 90%; margin-left: 4%;">
              <mat-label>Representative Name</mat-label>
              <input matInput type="text" formControlName="rep_name" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline" style="width: 90%; margin-left:-2%;">
              <mat-label>Book Seller Name</mat-label>
              <input matInput type="text" formControlName="book_seller_name" />
            </mat-form-field>
          </div>
        </div>

        <button type="button" mat-raised-button color="primary" (click)="searchrepname()">
          Search
        </button>



      </div>


      <div class="add-new-subscriber1 mat-elevation-z4">
        <button class="noPrint" style="margin-left: 1%; margin-top: 2%;" mat-raised-button color="primary"
          printSectionId="print-section-comm" [useExistingCss]="true" ngxPrint>
          Print
        </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 1%"
          (click)="exportExcel('Pending_commission_voucher')" mat-raised-button color="primary">
          Export
        </button>


        <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead" id="print-section-comm">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>Action</th>
                <th>Sr.No.</th>
                <th>Voucher No.</th>
                <th>Voucher Date</th>
                <th>Entry Date</th>
                <th>Rep.Name</th>
                <th>Book Seller Name</th>
                <th>Commission</th>
                <th>Remaining Commission</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let book of FilteredCommVouchers; let i = index">
                <td>
                  <button type="button" class="btn btn-danger btn-sm"
                    (click)="displayItemCommId(book, bookpymtcommrecpt)">
                    Mark as Completed
                  </button>
                </td>
                <td>{{ i + 1 }}</td>
                <td>{{ book.voucher_no }}</td>
                <td>{{ book.voucher_date | date: "dd-MM-yyy" }}</td>
                <td>{{ book.entry_date | date: "dd-MM-yyy" }}</td>
                <td>{{ book.rep_name }}</td>
                <td>{{ book.book_seller_name }}</td>
                <td>{{ book.commission | number:'1.0-2' }}</td>
                <td>{{ book.remaining_amt | number:'1.0-2' }}</td>
              </tr>
            </tbody>


            <tfoot>
              <tr>
                <td></td>
                <td>{{ getallCommVouchersData.length }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td><strong>{{ commission_Total | number:'1.0-2' }}</strong></td>
                <td><strong>{{ commRemainingTotal | number:'1.0-2' }}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      </ng-template>
    </mat-tab>

    <mat-tab label>
      <ng-template mat-tab-label>15<br>
        Pending Commission<br>Payment
      </ng-template>
      <ng-template matTabContent>
      <mat-card>
        <form class="form" [formGroup]="bookcommrecptform">
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 50%">
              <mat-label>Date</mat-label>
              <input matInput type="date" formControlName="date" [min]="financialYearMin" [max]="financialYearMax" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Voucher No</mat-label>
              <input matInput type="text" formControlName="crdtvno" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt Date</mat-label>
              <input matInput type="date" formControlName="recptdate" [min]="financialYearMin" [max]="financialYearMax"
                readonly />
            </mat-form-field>
          </div>
          <div class="form-row mb-3">
            <h3 style="padding-top: 10px;margin-left: 5%;padding-right: 20px;">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeletedComm" (change)="newdelCommRcpt($event)"
              name="fontStyle" aria-label="Font Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <div class="form-row">

            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Book Seller Name</mat-label>
              <input matInput type="text" formControlName="booksellername" readonly />
            </mat-form-field>
            <mat-form-field *ngIf="!deleteComm" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Commission No</mat-label>
              <input matInput type="text" formControlName="commino" readonly />
            </mat-form-field>
            <mat-form-field *ngIf="deleteComm" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Commission No (delete)</mat-label>
              <mat-select formControlName="commino">
                <mat-option *ngFor="let comm of getBookdeleterecipt" [value]="comm.rcpt_no" readonly>
                  {{ comm.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 5%">
              <mat-label>Commission Voucher Amount</mat-label>
              <input matInput type="number" formControlName="commvamt" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Select Entry Amount</mat-label>
              <input matInput type="number" formControlName="seamt" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Balance Amount</mat-label>
              <input matInput type="number" formControlName="balamt" readonly />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Representative Name</mat-label>
              <input matInput type="text" formControlName="repname" readonly />
            </mat-form-field>

          </div>
          <div class="form-group">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Representative Name Search</mat-label>
              <input formControlName="bookrepnamesearch" type="text" matInput [matAutocomplete]="autobrname"
                (keyup)="getBookRepNames($event)" />
              <mat-autocomplete autoActiveFirstOption #autobrname="matAutocomplete">
                <mat-option (onSelectionChange)="selectedrepname($event, option)" *ngFor="let option of book_rep_names"
                  [value]="option['rep_name']">
                  {{ option["rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <button type="button" mat-raised-button color="primary" style="margin-left: 5%"
              (click)="searchbookrepname()">
              Search
            </button>
          </div>

          <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead1">
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>

                  <th>Invoice Date</th>
                  <th>Invoice No</th>
                  <th>Book Seller Name</th>
                  <th>Representative Name</th>
                  <th>Invoice Amount</th>
                  <th>Received Amount</th>
                  <th>Commission Amount</th>
                  <th>Paid Commission</th>
                  <th>UnPaid Commission</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of booksellernamedata; let j = index">
                  <td>{{ book.invoice_date | date: "dd-MM-yyyy" }}</td>
                  <td>{{ book.invoice_no }}</td>
                  <td>{{ book.receiver_name }}</td>
                  <td>{{ book.rep_name }}</td>
                  <td>{{ book.invoice_total }}</td>
                  <td>{{ book.invoice_received_amt }}</td>
                  <td>{{ book.commission }}</td>

                  <!-- <td>
                    <input type="number" (change)="CalculateAmount(book, $event)" style="width: 60px; height: 30px"
                      [value]="book.commissionPercentage || book.percent" min="0" max="100" step="0.01"
                      placeholder="%" />
                  </td> -->

                  <td>{{book.received_amt }}
                  </td>
                  <td>{{book.remaining_amt }}
                  </td>

                  <td>
                    <button type="button" mat-raised-button color="primary" (click)="selectedInvItem(book)"
                      [disabled]="click">
                      Select
                    </button>
                  </td>
                </tr>


                <!-- <tr>
                  <td colspan="5">Total</td>
                </tr> -->
              </tbody>
            </table>
          </div>
          <div class="form-group">
            <button style="
                margin-left: 5%;
                margin-right: 25%;
                width: 60%;
                margin-top: 20px;
              " [disabled]="bookpymtrecptform.invalid" type="button" mat-raised-button color="primary"
              class="btn btn-primary btn-block" (click)="addbookpymtcomm()">
              Add
            </button>
          </div>
        </form>
      </mat-card>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        16<br>
        Book Commission<br>Register
      </ng-template>
      <ng-template matTabContent>

      <mat-card style="padding:10px">

        <form [formGroup]="bookcommrcptform">

          <!-- ================= Filter Row 1 ================= -->
          <div class="form-row">

            <mat-form-field [formGroup]="bookcommrcptform" appearance="outline" style="margin-left: 3%; width: 25%;">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getBookOutdtandingDateRange8()" />
              </div>
            </mat-form-field>


            <!-- Bill No -->
            <mat-form-field style="margin-left:3%; width:25%">
              <mat-label>बिल क्रं प्रमाणे :</mat-label>

              <mat-select formControlName="billnowise" (selectionChange)="getbillnowise($event)" multiple>

                <mat-option value="ALL">All</mat-option>

                <mat-option *ngFor="let item of bookRcptCommisionRegisterdata" [value]="item.bill_no">
                  {{ item.bill_no }}
                </mat-option>

              </mat-select>
            </mat-form-field>


            <!-- Book -->
            <mat-form-field style="margin-left:3%; width:25%">
              <mat-label>Book प्रमाणे :</mat-label>

              <mat-select formControlName="bookwise" (selectionChange)="getbookname($event)" multiple>

                <mat-option value="ALL">All</mat-option>

                <mat-option *ngFor="let item of bookslist" [value]="item.bookname">
                  {{ item.bookname }}
                </mat-option>

              </mat-select>

            </mat-form-field>

          </div>


          <!-- ================= Filter Row 2 ================= -->
          <div class="form-row">

            <mat-form-field style="margin-left:7%; width:30%">
              <mat-label>Representative Name</mat-label>

              <mat-select formControlName="repwise" (selectionChange)="getrepwise($event)" multiple>

                <mat-option value="ALL">All</mat-option>

                <mat-option *ngFor="let item of rep_names" [value]="item.rep_name">
                  {{ item.rep_name }}
                </mat-option>

              </mat-select>
            </mat-form-field>


            <mat-form-field style="margin-left:3%; width:25%">
              <mat-label>Office Representative</mat-label>

              <mat-select formControlName="officerepwise" (selectionChange)="getofficerepname($event)" multiple>

                <mat-option value="ALL">All</mat-option>

                <mat-option *ngFor="let item of office_rep_names" [value]="item.officerep">
                  {{ item.officerep }}
                </mat-option>

              </mat-select>
            </mat-form-field>


            <mat-form-field style="margin-left:3%; width:25%">
              <mat-label>Book Seller प्रमाणे :</mat-label>

              <mat-select formControlName="booksellerwise" (selectionChange)="getbooksellerwise($event)" multiple>

                <mat-option value="ALL">All</mat-option>

                <mat-option *ngFor="let item of book__seller__name" [value]="item.book__seller__name">
                  {{ item.book__seller__name }}
                </mat-option>

              </mat-select>
            </mat-form-field>

          </div>


          <!-- ================= Search Button ================= -->
          <div class="form-row">

            <div style="margin-left:7%">
              <button mat-raised-button color="primary" (click)="getBookCommisionReceiptDateFilter()">
                Search
              </button>
            </div>

          </div>


          <!-- ================= Print Export ================= -->
          <div style="display:flex; justify-content:flex-end; gap:10px; margin-top:10px; margin-bottom:10px;">

            <button mat-raised-button color="primary" style="width:150px" (click)="openBookCommReceipt()">
              Print
            </button>

            <button mat-raised-button color="primary" style="width:150px" (click)="exportExcelv()">
              Export
            </button>

          </div>


        </form>

      </mat-card>



      <!-- ================= Table ================= -->

      <div id="Book_Commission_Register" class="tableFixHead mt-4">

        <table class="table table-bordered text-center">

          <thead style="background:#f3f3f3">

            <tr>
              <!-- HEADER CHECKBOX -->
              <th>
                <mat-checkbox [checked]="allSelected" (change)="toggleSelectAll2($event)">
                </mat-checkbox>
              </th>

              <th>Sr No</th>
              <!-- <th>Bill Date</th>
          <th>Bill No</th> -->
              <th>Voucher No</th>
              <th>Voucher Date</th>
              <th>Commission No</th>
              <th>Commission Date</th>
              <th>Representative Name</th>
              <th>Office Representative</th>
              <th>Book Seller</th>
              <th>Bill Date</th>
              <th>Bill No</th>
              <th>Bill Amount</th>
              <!-- <th>Rep paid Amount</th> -->
              <th>Rep Commission Amount</th>
              <th>Rep paid Amount</th>
              <th>Action</th>

            </tr>

          </thead>



          <tbody>

            <tr *ngFor="let item of bookRcptCommisionRegisterdata; let i = index">
              <!-- ROW CHECKBOX -->
              <td>
                <mat-checkbox [(ngModel)]="item.selected" (change)="onRowCheckboxChange(item, $event)"
                  [ngModelOptions]="{standalone:true}">
                </mat-checkbox>
              </td>
              <td>{{ i + 1 }}</td>

              <!-- <td>{{ item.billdate | date:'dd-MM-yyyy' }}</td>

          <td>{{ item.bill_no }}</td> -->

              <td>{{ item.voucher_no }}</td>

              <td>{{ item.commission_date | date:'dd-MM-yyyy' }}</td>

              <td>{{ item.commission_no }}</td>

              <td>{{ item.commission_date | date:'dd-MM-yyyy' }}</td>

              <td>{{ item.rep_name }}</td>

              <td>{{ item.office_rep_name }}</td>

              <td>{{ item.book_seller_name }}</td>
              <td>{{ item.billdate | date:'dd-MM-yyyy' }}</td>

              <td>{{ item.bill_no }}</td>

              <td>{{ item.bill_amount }}</td>

              <td>{{ item.rep_commission_amt }}</td>

              <td>{{ item.select_entry_amt }}</td>

              <!-- <td>{{ item.rep_commission_amt }}</td> -->
              <td>
                <button mat-raised-button color="accent" (click)="updatePerBooksCommisionRate(item)">
                  Update
                </button>
                <!-- <button class="btn btn-danger btn-sm"
        (click)="deleteBookCommPymtCrdt(book.id)">
  Delete
</button> -->
                <button mat-icon-button matTooltip="Cancel" (click)="deleteBookCommPymtCrdt(item.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>

            </tr>

          </tbody>
          <!-- ================= Totals ================= -->
          <tfoot style="font-weight:bold; background:#f2f2f2">
            <tr>
              <td colspan="11">TOTAL</td>
              <td>{{ totalBillAmount | number:'1.2-2' }}</td>
              <td>{{ totalRepCommission | number:'1.2-2' }}</td>
              <td>{{ totalSelectEntry | number:'1.2-2' }}</td>
              <td></td> <!-- Empty for Action column -->
            </tr>
          </tfoot>



          <!-- ================= Totals ================= -->

          <!-- <tfoot style="font-weight:bold; background:#f2f2f2">

        <tr>

          <td colspan="10">TOTAL</td>

          <td>{{ totalBillAmount }}</td>

          <td>{{ totalSelectEntry }}</td>

          <td>{{ totalRepCommission }}</td>

        </tr>

      </tfoot> -->

        </table>

      </div>

      </ng-template>
    </mat-tab>

    <mat-tab label>
      <ng-template mat-tab-label>17<br>
        Rep Book<br>Commission
      </ng-template>
      <ng-template matTabContent>
      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important;" id="excel-table">
        <form [formGroup]="bookrepcommisionform">
          <div class="form-row" style="margin-top: 20px !important;">
            <mat-form-field appearance="outline" style="margin-left: 3%; width: 25%;">
              <mat-label>Invoice Date</mat-label>

              <div class="date-inline" style="display: flex; align-items: center; gap: 8px;">

                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />

                <span class="dash"> - </span>

                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (change)="getBookInvoiceDateRange()" />

              </div>
            </mat-form-field>



            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of rep_names" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySel1 (selectionChange)="getofficerepname($event)" formControlName="officerepwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of office_rep_names" value="{{  item['officerep'] }}">{{
                  item["officerep"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="outline" style="width: 30%; margin-left: 5%">
              <mat-label>बिल क्रं प्रमाणे Search</mat-label>
              <input formControlName="billnowise" type="text" matInput [matAutocomplete]="autobillno"
                (keyup)="getBillNos($event)" />
              <mat-autocomplete autoActiveFirstOption #autobillno="matAutocomplete">
                <mat-option (onSelectionChange)="selectedBillno($event, option)" *ngFor="let option of bill_nos_list"
                  [value]="option['invoice_no']">
                  {{ option["invoice_no"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->

          </div>

          <div class="form-row">



            <mat-form-field style="margin-left: 7%; width: 27%;">
              <mat-label>Book Seller प्रमाणे : </mat-label>
              <mat-select #mySel1 (selectionChange)="getbooksellerwise($event)" formControlName="booksellerwise"
                multiple>

                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of  book__seller__name" value="{{  item['book__seller__name'] }}">{{
                  item["book__seller__name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="All Rep Book Commission">All Rep Book Commission
                </mat-option>
                <mat-option value="Rep Commission Paid">Rep Commission Paid
                </mat-option>
                <mat-option value="Rep unpaid Commission">Rep unpaid Commission
                </mat-option>
                <!-- <mat-option value="Rep Commission Paid">Rep Commission Paid
                </mat-option> -->
                <!-- <mat-option value="Rep unpaid Commission">Rep unpaid Commission
                </mat-option> -->
                <!-- <mat-option value="InDetail-Officer">InDetail-Officer
                </mat-option>
                <mat-option value="VeryBriefly-Officer">VeryBriefly-Officer
                </mat-option>
                <mat-option value="Briefly-Officer">Briefly-Officer
                </mat-option> -->
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Select type of commission</mat-label>
              <mat-select formControlName="commissionType">
                <mat-option value="All">All</mat-option>
                <mat-option value="paidCommission">Paid Commission</mat-option>
                <mat-option value="unpaidCommission">Unpaid Commission</mat-option>
              </mat-select>
            </mat-form-field>





          </div>
          <div class="form-row">


            <div style="margin-left: 40%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="getBookCommissionDateFilter()">Search</button>
            </div>
            <!-- <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="openBookTwoReceipt()">Print</button>
            </div> -->

            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showReceiptReports3()">search report</button>
            </div>

          </div>

          <div class="form-row">
            <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 40%; margin-left: 7%">
              <mat-label>Book Seller प्रमाणे</mat-label>
              <input matInput formControlName="booksellerwise" (change)="getbooksellerwise($event)" />
            </mat-form-field> -->
          </div>
        </form>

        <div style="margin-top: 20px" class="tableFixHead">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Invoice Date</th>
                <th>Invoice no</th>
                <th>Book Seller Name</th>
                <th>Rep Name</th>
                <th>Off Rep Name</th>
                <th>Inv Amount</th>
                <th>Inv Recv Amount</th>
                <th>Inv Comm</th>
                <th>Paid Comm</th>
                <th>Unpaid Comm</th>
                <!-- <th>Sr.No</th>
                <th>प्रतिनिधींचे नाव</th>
                <th>ठिकाण</th>
                <th>बुक सेलर नाव</th>
                <th>बिल नंबर</th>
                <th>दिनांक</th>
                <th>रक्कम</th>
                <th>पुस्तकाचे नाव</th>
                <th>वर्तन %</th>
                <th>वर्तन रक्कम</th>
                <th>दिलेले कमिशन</th>
                <th>कमिशन दिलयाचा तपशील व्हाउचर दिनांक</th>
                <th>देणे बाकी</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rep of this.repcommissiondata; let i = index">
                <!-- <td>{{ i + 1 }}</td>
                <td>{{ rep["rep_name"] }}</td>
                <td>{{ rep["district"] }}</td>
                <td>{{ rep["receiver_name"] }}</td>
                <td>{{ rep["invoice_no"] }}%</td>
                <td>{{ rep["invoice_date"] }}</td>
                <td>{{ rep["invoice_total"] }}</td>
                <td>{{ rep["book_name"] }}</td>
                <td>{{ rep["percent"] }}</td>
                <td>{{ rep["amount"] }}</td>
                <td></td>
                <td></td>
                <td></td> -->
                <td>{{ i + 1 }}</td>
                <td>{{ rep["invoice_date"] | date: "dd-MM-yyy" }}</td>
                <td>{{ rep["invoice_no"] }}</td>
                <td>{{ rep["receiver_name"] }}</td>
                <td>{{ rep["rep_name"] }}</td>
                <td>{{ rep["office_rep_name"] }}</td>
                <td>{{ rep["invoice_total"] }}</td>
                <td>{{ rep["invoice_received_amt"] }}</td>
                <td>{{ rep["rep_commission_amt"] }}</td>
                <td>{{ rep["received_amt"] }}</td>
                <td>{{ rep["remaining_amt"] }}</td>


                <!-- <td>
                  <button
                    type="button"
                    (click)="GetUpdatedCommissionValue(rep['id'])"
                    class="btn btn-danger"
                  >
                    Update
                  </button>
                </td> -->
              </tr>
            </tbody>
            <tfoot>
              <tr style="font-weight: bold; background: #f3f3f3;">
                <td colspan="6" class="text-center">TOTAL</td>
                <td class="text-end">{{ totalInvoiceAmount | number:'1.2-2' }}</td>
                <td class="text-end">{{ totalInvoiceReceived | number:'1.2-2' }}</td>
                <td class="text-end">{{ totalCommission | number:'1.2-2' }}</td>
                <td class="text-end">{{ totalPaidCommission | number:'1.2-2' }}</td>
                <td class="text-end">{{ totalUnpaidCommission | number:'1.2-2' }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      </ng-template>
    </mat-tab>


    <mat-tab>
      <ng-template mat-tab-label>
        18<br>
        Business<br>Report
      </ng-template>
      <ng-template matTabContent>

      <mat-card style="padding: 10px;">

        <!-- ===== entryType toggle: Book / Granth (same pattern as Book Registration Ledger) ===== -->
        <mat-radio-group [(ngModel)]="entryType" (change)="onEntryTypeChange()"
          style="margin-top: 10px; margin-bottom: 10px; display: block;">
          <mat-radio-button value="book" style="margin-right: 30px;">Book</mat-radio-button>
          <mat-radio-button value="granth">Granth</mat-radio-button>
        </mat-radio-group>


        <!-- ===================== BOOK SUB-TAB (existing Business Report, unchanged) ===================== -->
        <div *ngIf="entryType === 'book'">

          <!-- ================= FILTER SECTION ================= -->
          <form [formGroup]="businessForm">

            <!-- ROW 1 -->
            <div style="display:flex; flex-wrap:wrap; gap:15px;">

              <!-- Date Range -->
              <mat-form-field [formGroup]="businessForm" appearance="outline" style="width: 30%; ">
                <mat-label>Enter Date</mat-label>

                <div class="date-inline">
                  <input matInput type="date" formControlName="start" [min]="financialYearMin"
                    [max]="financialYearMax" />
                  <span class="dash"> - </span>
                  <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                    (blur)="applyDateValidation()" />
                </div>
              </mat-form-field>

              <!-- Office Representative -->
              <mat-form-field appearance="outline" style="width: 30%;">
                <mat-label>Office Representative</mat-label>
                <mat-select formControlName="officerepwise" multiple>
                  <mat-option value="ALL">All</mat-option>
                  <mat-option *ngFor="let item of office_rep_names" [value]="item.officerep">
                    {{ item.officerep }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Country -->
              <mat-form-field appearance="outline" style="width: 25%;">
                <mat-label>Country</mat-label>
                <mat-select formControlName="country" (selectionChange)="getCountry1($event)">
                  <mat-option *ngFor="let c of countries" [value]="c.country_name">
                    {{ c.country_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>

            <!-- ROW 2 -->
            <div style="display:flex; flex-wrap:wrap; gap:15px; margin-top:10px;">

              <!-- State -->
              <mat-form-field appearance="outline" style="width: 25%;">
                <mat-label>State</mat-label>
                <mat-select formControlName="state" (selectionChange)="getState1($event)">
                  <mat-option *ngFor="let c of states" [value]="c.state_name">
                    {{ c.state_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- District -->
              <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
                <mat-label>District</mat-label>

                <mat-select formControlName="district" multiple (selectionChange)="getDistricts($event)">
                  <mat-option *ngFor="let c of cities" [value]="c.district_name">
                    {{ c.district_name }}
                  </mat-option>
                </mat-select>

              </mat-form-field>


              <!-- Taluka -->
              <mat-form-field appearance="outline" style="width: 25%;">
                <mat-label>Taluka</mat-label>

                <mat-select formControlName="taluka" multiple>
                  <mat-option *ngFor="let t of talukas" [value]="t.taluka_name">
                    {{ t.taluka_name }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 300px;margin-left: 3%;">
                <mat-label>Report Type</mat-label>

                <mat-select (selectionChange)="getAdvtInvoiceReportType($event)">
                  <mat-option value="In Detail">Business Report In Details </mat-option>
                  <mat-option value="Briefly">Business Report Briefly</mat-option>
                  <mat-option value="office Rep In Detail">
                    Business Report Very Briefly
                  </mat-option>
                  <mat-option value="Office Rep -Briefly">
                    Office Representative Monthwise Report
                  </mat-option>
                  <mat-option value="Monthwise">
                    Monthwise Report
                  </mat-option>
                  <mat-option value="bookwise">bookwise Report</mat-option>
                </mat-select>
              </mat-form-field>

              <button mat-raised-button color="primary" type="button" (click)="getBusinessReport1()">
                Search
              </button>

              <button mat-raised-button color="primary" type="submit" style="margin-left: 3%;"
                (click)="openAdvtInvoiceRegister1()">
                Search Report
              </button>

            </div>

          </form>

          <!-- ================= RESULT TABLE ================= -->
          <div class="tableFixHead mt-4" *ngIf="businessReportList?.length > 0">
            <table class="table table-bordered text-center">
              <thead style="background:#cfe8ef;">
                <tr>
                  <th>Sr No</th>
                  <th>Rep Name</th>
                  <th>District</th>
                  <th>Taluka</th>
                  <th>एप्रिल</th>
                  <th>मे</th>
                  <th>जून</th>
                  <th>जुलै</th>
                  <th>ऑगस्ट</th>
                  <th>सप्टेंबर</th>
                  <th>ऑक्टोबर</th>
                  <th>नोव्हेंबर</th>
                  <th>डिसेंबर</th>
                  <th>जानेवारी</th>
                  <th>फेब्रुवारी</th>
                  <th>मार्च</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of businessReportList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.rep_name || '-' }}</td>
                  <td>{{ item.district || '-' }}</td>
                  <td>{{ item.taluka || '-' }}</td>
                  <td>{{ item.Apr || 0 }}</td>
                  <td>{{ item.May || 0 }}</td>
                  <td>{{ item.Jun || 0 }}</td>
                  <td>{{ item.Jul || 0 }}</td>
                  <td>{{ item.Aug || 0 }}</td>
                  <td>{{ item.Sep || 0 }}</td>
                  <td>{{ item.Oct || 0 }}</td>
                  <td>{{ item.Nov || 0 }}</td>
                  <td>{{ item.Dec || 0 }}</td>
                  <td>{{ item.Jan || 0 }}</td>
                  <td>{{ item.Feb || 0 }}</td>
                  <td>{{ item.Mar || 0 }}</td>
                </tr>
              </tbody>

            </table>
          </div>

          <!-- NO DATA MESSAGE -->
          <div *ngIf="!businessReportList || businessReportList.length === 0"
            style="text-align:center; padding:20px; color:#888;">
            No data found. Please apply filters and click Search.
          </div>

        </div>
        <!-- ===================== END BOOK SUB-TAB ===================== -->


        <!-- ===================== GRANTH SUB-TAB (mirrors Book sub-tab above) ===================== -->
        <div *ngIf="entryType === 'granth'">

          <!-- ================= FILTER SECTION ================= -->
          <form [formGroup]="businessForm">

            <!-- ROW 1 -->
            <div style="display:flex; flex-wrap:wrap; gap:15px;">

              <!-- Date Range -->
              <mat-form-field [formGroup]="businessForm" appearance="outline" style="width: 30%; ">
                <mat-label>Enter Date</mat-label>

                <div class="date-inline">
                  <input matInput type="date" formControlName="start" [min]="financialYearMin"
                    [max]="financialYearMax" />
                  <span class="dash"> - </span>
                  <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                    (blur)="applyDateValidation()" />
                </div>
              </mat-form-field>

              <!-- Office Representative -->
              <mat-form-field appearance="outline" style="width: 30%;">
                <mat-label>Office Representative</mat-label>
                <mat-select formControlName="officerepwise" multiple>
                  <mat-option value="ALL">All</mat-option>
                  <mat-option *ngFor="let item of office_rep_names" [value]="item.officerep">
                    {{ item.officerep }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Country -->
              <mat-form-field appearance="outline" style="width: 25%;">
                <mat-label>Country</mat-label>
                <mat-select formControlName="country" (selectionChange)="getCountry1($event)">
                  <mat-option *ngFor="let c of countries" [value]="c.country_name">
                    {{ c.country_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>

            <!-- ROW 2 -->
            <div style="display:flex; flex-wrap:wrap; gap:15px; margin-top:10px;">

              <!-- State -->
              <mat-form-field appearance="outline" style="width: 25%;">
                <mat-label>State</mat-label>
                <mat-select formControlName="state" (selectionChange)="getState1($event)">
                  <mat-option *ngFor="let c of states" [value]="c.state_name">
                    {{ c.state_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- District -->
              <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
                <mat-label>District</mat-label>

                <mat-select formControlName="district" multiple (selectionChange)="getDistricts($event)">
                  <mat-option *ngFor="let c of cities" [value]="c.district_name">
                    {{ c.district_name }}
                  </mat-option>
                </mat-select>

              </mat-form-field>


              <!-- Taluka -->
              <mat-form-field appearance="outline" style="width: 25%;">
                <mat-label>Taluka</mat-label>

                <mat-select formControlName="taluka" multiple>
                  <mat-option *ngFor="let t of talukas" [value]="t.taluka_name">
                    {{ t.taluka_name }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 300px;margin-left: 3%;">
                <mat-label>Report Type</mat-label>

                <mat-select (selectionChange)="getAdvtInvoiceReportType($event)">
                  <mat-option value="In Detail">Granth Report In Details </mat-option>
                  <mat-option value="Briefly">Granth Report Briefly</mat-option>
                  <mat-option value="office Rep In Detail">
                    Representative
                  </mat-option>
                  <mat-option value="Office Rep -Briefly">
                    Office Representative
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <button mat-raised-button color="primary" type="button" (click)="getGranthBusinessReport1()">
                Search
              </button>

              <button mat-raised-button color="primary" type="submit" style="margin-left: 3%;"
                (click)="openGranthInvoiceRegister1()">
                Search Report
              </button>

            </div>

          </form>

          <!-- ================= RESULT TABLE ================= -->
          <div class="tableFixHead mt-4" *ngIf="granthBusinessReportList?.length > 0">
            <table class="table table-bordered text-center">
              <thead style="background:#cfe8ef;">
                <tr>
                  <th>Sr No</th>
                  <th>Rep Name</th>
                  <th>District</th>
                  <th>Taluka</th>
                  <th>एप्रिल</th>
                  <th>मे</th>
                  <th>जून</th>
                  <th>जुलै</th>
                  <th>ऑगस्ट</th>
                  <th>सप्टेंबर</th>
                  <th>ऑक्टोबर</th>
                  <th>नोव्हेंबर</th>
                  <th>डिसेंबर</th>
                  <th>जानेवारी</th>
                  <th>फेब्रुवारी</th>
                  <th>मार्च</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of granthBusinessReportList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.rep_name || '-' }}</td>
                  <td>{{ item.district || '-' }}</td>
                  <td>{{ item.taluka || '-' }}</td>
                  <td>{{ item.Apr || 0 }}</td>
                  <td>{{ item.May || 0 }}</td>
                  <td>{{ item.Jun || 0 }}</td>
                  <td>{{ item.Jul || 0 }}</td>
                  <td>{{ item.Aug || 0 }}</td>
                  <td>{{ item.Sep || 0 }}</td>
                  <td>{{ item.Oct || 0 }}</td>
                  <td>{{ item.Nov || 0 }}</td>
                  <td>{{ item.Dec || 0 }}</td>
                  <td>{{ item.Jan || 0 }}</td>
                  <td>{{ item.Feb || 0 }}</td>
                  <td>{{ item.Mar || 0 }}</td>
                </tr>
              </tbody>

            </table>
          </div>

          <!-- NO DATA MESSAGE -->
          <div *ngIf="!granthBusinessReportList || granthBusinessReportList.length === 0"
            style="text-align:center; padding:20px; color:#888;">
            No data found. Please apply filters and click Search.
          </div>

        </div>
        <!-- ===================== END GRANTH SUB-TAB ===================== -->

      </mat-card>

      </ng-template>
    </mat-tab>




    <mat-tab>

      <ng-template mat-tab-label>
        19<br>
        Book Expense<br>Register
      </ng-template>

      <ng-template matTabContent>

        <mat-card class="p-4">

          <!-- ================= FILTER SECTION ================= -->
          <div class="flex flex-wrap items-center gap-3 mb-5" [formGroup]="bookExpenseForm">

            <!-- ================= DATE RANGE ================= -->
            <!-- <mat-form-field appearance="outline" style="width: 30%;">
          <mat-label>Enter Date</mat-label>

          <mat-date-range-input
            [rangePicker]="searchBookDate"
            [min]="financialYearMin"
            [max]="financialYearMax">

            <input
              matStartDate
              formControlName="start"
              placeholder="Start date"
              (dateChange)="getBookStcokDateChanged()"
            >

            <input
              matEndDate
              formControlName="end"
              placeholder="End date"
              (dateChange)="getBookStcokDateChanged()"
            >

          </mat-date-range-input>

          <mat-datepicker-toggle matSuffix [for]="searchBookDate"></mat-datepicker-toggle>

          <mat-date-range-picker #searchBookDate></mat-date-range-picker>
        </mat-form-field> -->
            <mat-form-field [formGroup]="bookExpenseForm" appearance="outline"
              style="width: 30%; margin-top: 5%;margin-left: 3%;">

              <mat-label>Enter Date</mat-label>

              <div class="date-inline">

                <!-- START DATE -->
                <input matInput type="date" formControlName="start_date" [min]="financialYearMin"
                  [max]="financialYearMax" />

                <span class="dash"> - </span>

                <!-- END DATE -->
                <input matInput type="date" formControlName="end_date" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getBookStcokDateChanged()" />

              </div>

            </mat-form-field>

            <!-- ================= BOOK NAME ================= -->
            <mat-form-field appearance="outline" style="width: 25%;margin-left: 3%;">
              <mat-label>Book Name Type</mat-label>

              <mat-select formControlName="bookwise" multiple (selectionChange)="getbookname1($event)">

                <mat-option value="ALL" (click)="toggleAllSelection1()">All</mat-option>

                <mat-option *ngFor="let item of Filteredbookdata2" [value]="item.bookname">
                  {{ item.bookname }}
                </mat-option>

              </mat-select>
            </mat-form-field>

            <!-- ================= AUTHOR NAME ================= -->
            <mat-form-field appearance="outline" style="width: 25%;margin-left: 3%;">
              <mat-label>Author Name</mat-label>

              <mat-select formControlName="author_name" multiple (selectionChange)="getAuthorName($event)">

                <mat-option value="ALL" (click)="toggleAllAuthorSelection()">All</mat-option>

                <mat-option *ngFor="let item of authorList" [value]="item.author_name">
                  {{ item.author_name }}
                </mat-option>

              </mat-select>
            </mat-form-field>

            <!-- ================= SEARCH BUTTON ================= -->
            <div>
              <button mat-raised-button color="primary" (click)="searchExpense()">
                Search
              </button>
            </div>

          </div>

          <!-- ================= ACTION BUTTONS ================= -->
          <div class="mb-3 no-print">

            <button mat-raised-button color="primary" (click)="printTable1()">
              Print
            </button>

            <button mat-raised-button color="primary" (click)="export()" style="margin-left:2%;">
              Export
            </button>

          </div>

          <!-- ================= TABLE ================= -->
          <div id="printBookExpense" class="tableFixHead mt-4">

            <table class="table table-bordered text-center">

              <!-- ================= HEADER ================= -->
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Book Name</th>
                  <th>Author</th>
                  <th>Publish Year</th>
                  <th>Prakashan</th>
                  <th>Book Edition</th>
                  <th>Book Price</th>
                  <th>Print Copies</th>
                  <th>लेखक मानधन</th>
                  <th>पेपर बिल</th>
                  <th>प्रिंटिंग बिल</th>
                  <th>प्रोसेसिंग फी</th>
                  <th>कव्हर</th>
                  <th>इतर</th>
                  <th>कुरियर खर्च</th>
                  <th>एकूण खर्च</th>
                  <th>बिलिंग रक्कम</th>
                  <th>जमा</th>
                  <th>येणे बाकी</th>
                  <th class="no-print">Action</th>
                </tr>
              </thead>

              <!-- ================= BODY ================= -->
              <tbody>

                <tr *ngFor="let item of bookExpenseList; let i = index">

                  <td>{{ i + 1 }}</td>
                  <td>{{ item.book_name }}</td>
                  <td>{{ item.author_name }}</td>
                  <td>{{ item.bookyear | date:'dd-MM-yyyy' }}</td>
                  <td>{{ item.prakashan_name }}</td>
                  <td>{{ item.bookedition }}</td>
                  <td>{{ item.bookprice }}</td>
                  <td>{{ item.print_order }}</td>
                  <td>{{ item.author_honorarium }}</td>

                  <td>
                    <input type="number" class="form-control" [(ngModel)]="item.paper_bill" name="paper_bill{{i}}">
                  </td>

                  <td>
                    <input type="number" class="form-control" [(ngModel)]="item.printing_bill"
                      name="printing_bill{{i}}">
                  </td>

                  <td>
                    <input type="number" class="form-control" [(ngModel)]="item.processing" name="processing{{i}}">
                  </td>

                  <td>
                    <input type="number" class="form-control" [(ngModel)]="item.cover" name="cover{{i}}">
                  </td>

                  <td>
                    <input type="number" class="form-control" [(ngModel)]="item.other" name="other{{i}}">
                  </td>

                  <td>
                    <input type="number" class="form-control" [(ngModel)]="item.shipping_charges"
                      (ngModelChange)="updateShippingLocal(item)" name="shipping_charges{{i}}">
                  </td>

                  <td>{{ getTotalExpense(item) }}</td>
                  <td>{{ item.total_amount }}</td>
                  <td>{{ item.received_amt }}</td>
                  <td>{{ item.outstanding_amt }}</td>

                  <td class="no-print">

                    <button mat-icon-button color="primary" (click)="saveRow(item)">
                      <mat-icon>save</mat-icon>
                    </button>

                    <button mat-icon-button color="accent" (click)="openEditDialog(item,i)">
                      <mat-icon>edit</mat-icon>
                    </button>

                  </td>

                </tr>

              </tbody>

              <!-- ================= TOTAL ROW ================= -->
              <tr style="font-weight:bold; background:#f2f2f2;">

                <td colspan="6">TOTAL</td>

                <td>{{ totalBookPrice }}</td>
                <td>{{ totalPrintOrder }}</td>
                <td>{{ totalAuthorHonorarium }}</td>
                <td>{{ totalPaperBill }}</td>
                <td>{{ totalPrintingBill }}</td>
                <td>{{ totalProcessing }}</td>
                <td>{{ totalCover }}</td>
                <td>{{ totalOther }}</td>
                <td>{{ totalShipping }}</td>
                <td>{{ totalExpense }}</td>
                <td>{{ totalBilling }}</td>
                <td>{{ totalReceived }}</td>
                <td>{{ totalOutstanding }}</td>

                <td class="no-print"></td>

              </tr>

            </table>

          </div>

        </mat-card>

      </ng-template>

    </mat-tab>



    <mat-tab label>
      <ng-template mat-tab-label>20<br>
        Book Stock<br>
      </ng-template>
      <ng-template matTabContent>

      <!-- Radio Toggle - same as Book Seller Management -->
      <mat-radio-group [(ngModel)]="entryType" (change)="onEntryTypeChange()"
        style="margin-top: 20px; margin-left: 20px; display: block;">
        <mat-radio-button value="book" style="margin-right: 30px;">Book</mat-radio-button>
        <mat-radio-button value="granth">Granth</mat-radio-button>
      </mat-radio-group>


      <!-- ===================== BOOK STOCK ===================== -->
      <div *ngIf="entryType === 'book'">
        <form class="form" [formGroup]="BookStockform">
          <div class="col-md-12" style="display: flex; align-items: center; gap: 15px; margin-top: 40px;">

            <mat-form-field appearance="outline" style="width: 30%;">
              <mat-label>Search by book name</mat-label>
              <input matInput [(ngModel)]="bookNameSearch" formControlName="book_name" placeholder="Enter Book Name" />
            </mat-form-field>

            <mat-form-field [formGroup]="BookStockform" appearance="outline" style="margin-left: 3%; width: 25%;">
              <mat-label>Enter Date</mat-label>
              <div class="date-inline">
                <input matInput type="date" formControlName="start_date" [min]="financialYearMin"
                  [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end_date" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getBookStcokDateChanged()" />
              </div>
            </mat-form-field>

            <button type="button" mat-raised-button color="primary" (click)="searchBooks(bookNameSearch)">
              Search
            </button>

          </div>

          <div style="margin-left: 70%; margin-bottom: 1%">
            <button mat-raised-button color="primary" (click)="printTableTillClosingValue()">Print</button>
            <button class="noPrint" style="margin-top: 2% 2% 0 2%; margin-left: 4%"
              (click)="exportExcell('Book_Stock_Ledger')" mat-raised-button color="primary">
              Export
            </button>
          </div>

          <div class="add-new-subscriber mat-elevation-z4"
            style="overflow-x: scroll !important; border-radius:10px !important">
            <div class="tableFixHead">
              <table class="table table-bordered table-hover text-center" id="print-section">
                <thead>
                  <tr>
                    <th>Sr.No.</th>
                    <th>Book Name</th>
                    <th>Author Name</th>
                    <th>Prakashan Name</th>
                    <th>Publish Year</th>
                    <th>Book Edition</th>
                    <th>Opening Stock</th>
                    <th>Opening Value</th>
                    <th>Print Order</th>
                    <th>Book Price</th>
                    <th>Book Sale Price</th>
                    <th>Agent Price</th>
                    <th>Complemenatry</th>
                    <th>Abhiyan</th>
                    <th>Sold Copies</th>
                    <th>Total Sell</th>
                    <th>Available Stock</th>
                    <th>Closing Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let book of resultData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td class="fw-700">{{ book["book_name"] }}</td>
                    <td>{{ book["author_name"] }}</td>
                    <td>{{ book["prakashan_name"] }}</td>
                    <td>{{ book["bookyear"] | date:'dd-MM-yyyy' }}</td>
                    <td>{{ book["bookedition"] }}</td>
                    <td>{{ book["opening_stock"] }}</td>
                    <td>{{ book["opening_value_of_book"] }}</td>
                    <td>{{ book["print_order"] }}</td>
                    <td>{{ book["bookprice"] }}</td>
                    <td>{{ book["booksaleprice"] }}</td>
                    <td>{{ book["agentprice"] }}</td>
                    <td>{{ book["complementry"] }}</td>
                    <td>{{ book["abhiyan"] }}</td>
                    <td>{{ book["sold_copies"] }}</td>
                    <td>{{ book["total_sell"] }}</td>
                    <td>{{ book["balance_stock"] }}</td>
                    <td>{{ book["value_of_book"] }}</td>
                  </tr>
                </tbody>
                <tfoot class="fw-bold bg-light text-dark">
                  <tr>
                    <td colspan="6" class="text-end"><b>Total:</b></td>
                    <td><b>{{ openingstockTotal }}</b></td>
                    <td><b>{{ openingValueTotal | number: '1.2-2' }}</b></td>
                    <td><b>{{ printorderTotal }}</b></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><b>{{ complementryTotal }}</b></td>
                    <td><b>{{ abhiyanTotal }}</b></td>
                    <td><b>{{ soldCopiesTotal }}</b></td>
                    <td><b>{{ totalSellTotal }}</b></td>
                    <td><b>{{ availableTotal }}</b></td>
                    <td><b>{{ valueOfBookTotal | number: '1.2-2' }}</b></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

        </form>
      </div>


      <!-- ===================== GRANTH STOCK ===================== -->
      <div *ngIf="entryType === 'granth'">
        <form class="form" [formGroup]="BookStockform">
          <div class="col-md-12" style="display: flex; align-items: center; gap: 15px; margin-top: 40px;">

            <mat-form-field appearance="outline" style="width: 30%;">
              <mat-label>Search by book name</mat-label>
              <input matInput [(ngModel)]="bookNameSearch" formControlName="book_name" placeholder="Enter Book Name" />
            </mat-form-field>

            <mat-form-field [formGroup]="BookStockform" appearance="outline" style="margin-left: 3%; width: 25%;">
              <mat-label>Enter Date</mat-label>
              <div class="date-inline">
                <input matInput type="date" formControlName="start_date" [min]="financialYearMin"
                  [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end_date" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getBookStcokDateChanged()" />
              </div>
            </mat-form-field>

            <button type="button" mat-raised-button color="primary" (click)="searchgranth(bookNameSearch)">
              Search
            </button>

          </div>

          <div style="margin-left: 70%; margin-bottom: 1%">
            <button mat-raised-button color="primary" (click)="printTableTillClosingValue()">Print</button>
            <button class="noPrint" style="margin-top: 2% 2% 0 2%; margin-left: 4%"
              (click)="exportExcell('Book_Stock_Ledger')" mat-raised-button color="primary">
              Export
            </button>
          </div>

          <div class="add-new-subscriber mat-elevation-z4"
            style="overflow-x: scroll !important; border-radius:10px !important">
            <div class="tableFixHead">
              <table class="table table-bordered table-hover text-center" id="print-section-granth">
                <thead>
                  <tr>
                    <th>Sr.No.</th>
                    <th>Book Name</th>
                    <th>Author Name</th>
                    <th>Prakashan Name</th>
                    <th>Publish Year</th>
                    <th>Book Edition</th>
                    <th>Opening Stock</th>
                    <th>Opening Value</th>
                    <th>Print Order</th>
                    <th>Book Price</th>
                    <th>Book Sale Price</th>
                    <!-- <th>Agent Price</th> -->
                    <!-- <th>Complemenatry</th>
                    <th>Abhiyan</th> -->
                    <th>Sold Copies</th>
                    <th>Total Sell</th>
                    <th>Available Stock</th>
                    <th>Closing Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let book of resultData1; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td class="fw-700">{{ book["bookname"] }}</td>
                    <td>{{ book["author_name"] }}</td>
                    <td>{{ book["prakashan_name"] }}</td>
                    <td>{{ book["bookyear"] | date:'dd-MM-yyyy' }}</td>
                    <td>{{ book["bookedition"] }}</td>
                    <td>{{ book["opening_used"] }}</td>
                    <td>{{ book["opening_value_of_book"] }}</td>
                    <td>{{ book["bookedtncpoies"] }}</td>
                    <td>{{ book["bookprice"] }}</td>
                    <td>{{ book["booksaleprice"] }}</td>
                    <td>{{ book["used_copies"] }}</td>
                    <td>{{ book["total_sell"] }}</td>
                    <td>{{ book["balance_stock"] }}</td>
                    <td>{{ book["value_of_book"] }}</td>
                  </tr>
                </tbody>
                <!-- <tfoot class="fw-bold bg-light text-dark">
                  <tr>
                    <td colspan="6" class="text-end"><b>Total:</b></td>
                    <td><b>{{ openingstockTotal }}</b></td>
                    <td><b>{{ openingValueTotal | number: '1.2-2' }}</b></td>
                    <td><b>{{ printorderTotal }}</b></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><b>{{ complementryTotal }}</b></td>
                    <td><b>{{ abhiyanTotal }}</b></td>
                    <td><b>{{ soldCopiesTotal }}</b></td>
                    <td><b>{{ totalSellTotal }}</b></td>
                    <td><b>{{ availableTotal }}</b></td>
                    <td><b>{{ valueOfBookTotal | number: '1.2-2' }}</b></td>
                  </tr>
                </tfoot> -->
              </table>
            </div>
          </div>

        </form>
      </div>

      </ng-template>
    </mat-tab>
    <mat-tab label>
      <ng-template mat-tab-label>
        21<br>Manage<br>BookDelivery
      </ng-template>
      <ng-template matTabContent>

      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: auto; padding-bottom: 20px">

        <div style="margin-top: 20px">

          <!-- ================= FILTER FORM ================= -->
          <form [formGroup]="Managerange"
            style="display: flex; flex-wrap: wrap; gap: 20px; margin-left: 3%; margin-top: 15px">

            <!-- DATE -->
            <mat-form-field appearance="outline" class="field-25">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />

                <span class="dash"> - </span>

                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDate_managebook()" />
              </div>
            </mat-form-field>

            <!-- REP -->
            <mat-form-field appearance="fill" style="width: 30%;">
              <mat-label>Representative Name</mat-label>
              <input matInput formControlName="repname" />
            </mat-form-field>

            <!-- CUSTOMER -->
            <mat-form-field appearance="fill" style="width: 30%;">
              <mat-label>Client Name</mat-label>
              <input matInput formControlName="custname" />
            </mat-form-field>

            <!-- BOOK -->
            <mat-form-field appearance="fill" style="width: 30%;">
              <mat-label>Book Name</mat-label>
              <input matInput formControlName="book_name" />
            </mat-form-field>

            <button mat-raised-button color="primary" (click)="opentworeceipt2()">
              Search
            </button>

            <button mat-raised-button color="accent" type="button" (click)="opentworeceipt1()">
              Print Selected
            </button>

          </form>

          <!-- ================= TABLE ================= -->
          <div class="tableFixHead" style="margin-top: 2%; overflow-x: auto">

            <table class="table table-striped text-center">

              <thead>
                <tr>
                  <th>
                    <mat-checkbox color="primary" [checked]="allSelectedtable" [indeterminate]="someSelected"
                      (change)="toggleSelectAll1($event)">
                    </mat-checkbox>
                  </th>

                  <th>Action</th>
                  <th>Sr. No.</th>
                  <th>Order Date</th>
                  <th>Order No</th>
                  <th>BookSeller Name</th>
                  <th>Representative</th>
                  <th>Total Amount</th>
                  <th>Is Complimentary</th>
                  <th>Bill No</th>
                  <th>Bill Date</th>
                  <th>Receipt No</th>
                  <th>Receipt Date</th>
                  <th>Dispatch Mode</th>
                </tr>
              </thead>

              <tbody>

                <tr *ngFor="let book of FilteredDeliveryManageBooks; let i = index">

                  <!-- CHECKBOX -->
                  <td>
                    <mat-checkbox color="primary" [checked]="book.is_selected" (change)="toggleRow(book, $event)">
                    </mat-checkbox>
                  </td>

                  <!-- ACTION -->
                  <td>
                    <button mat-raised-button color="warn" (click)="markAsDelivered(book, i)">
                      Mark as Delivered
                    </button>
                  </td>

                  <td>{{ i + 1 }}</td>

                  <td>{{ book.bookingdate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ book.order_no }}</td>
                  <td>{{ book.custname }}</td>
                  <td>{{ book.rep }}</td>

                  <td>
                    {{
                    (book.total ? +book.total : 0)

                    }}
                  </td>

                  <td>{{ book.iscomplimentary }}</td>
                  <td>{{ book.invoice_no }}</td>
                  <td>{{ book.invoice_date | date:'dd-MM-yyyy' }}</td>
                  <td>{{ book.rcptno }}</td>
                  <td>{{ book.rcptdate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ book.deliverymode }}</td>

                </tr>

                <!-- NO DATA -->
                <tr *ngIf="!FilteredDeliveryManageBooks?.length">
                  <td colspan="14" style="text-align:center; padding:20px; color:gray;">
                    No records found.
                  </td>
                </tr>

              </tbody>
            </table>

          </div>

        </div>
      </div>
      </ng-template>
    </mat-tab>


    <mat-tab label>
      <ng-template mat-tab-label>22<br>
        Book Posting Label & Statement<br>
      </ng-template>
      <ng-template matTabContent>

      <form [formGroup]="generateform1">

        <!-- Row 1 -->
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Book Name</mat-label>
            <mat-select #mySel1 (selectionChange)="getbookname1($event)" formControlName="bookwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection1()">All</mat-option>
              <mat-option *ngFor="let item of Filteredbookdata2" [value]="item.bookname">{{ item.bookname
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field appearance="outline"style="width: 30%; margin-left: 2%; margin-top: 5%;">
        <mat-label>Issue Date</mat-label>
        <mat-select formControlName="issue_date" multiple></mat-select>
      </mat-form-field> -->


          <mat-form-field [formGroup]="generateform1" appearance="outline"
            style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Enter Date</mat-label>

            <div class="date-inline">

              <input matInput type="date" formControlName="start_date" [min]="financialYearMin"
                [max]="financialYearMax" />

              <span class="dash"> - </span>

              <input matInput type="date" formControlName="end_date" [min]="financialYearMin" [max]="financialYearMax"
                (blur)="getBookStcokDateChanged1()" />

            </div>

          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Book Seller प्रमाणे : </mat-label>
            <mat-select #mySel1 (selectionChange)="getbooksellerwise($event)" formControlName="booksellerwise" multiple>

              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of  book__seller__name" (onSelectionChange)="getBookSellerName($event) "
                value="{{  item['book__seller__name'] }}">{{
                item["book__seller__name"]
                }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-row">

          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Seller Type</mat-label>

            <mat-select formControlName="sellertype" multiple>

              <mat-option *ngFor="let type of sellerTypes" [value]="type.sellertype">

                {{ type.sellertype }}

              </mat-option>

            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Type</mat-label>

            <mat-select formControlName="type" multiple>

              <mat-option value="Complimentary">Complimentary</mat-option>
              <mat-option value="Sponsor">Sponsor</mat-option>
              <mat-option value="Sale">Sale</mat-option>

            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country" (selectionChange)="getCountry1($event)">
              <mat-option *ngFor="let c of countries" [value]="c.country_name">
                {{ c.country_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>State</mat-label>
            <mat-select formControlName="state" (selectionChange)="getState1($event)">
              <mat-option *ngFor="let c of states" [value]="c.state_name">
                {{ c.state_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>District</mat-label>

            <mat-select formControlName="district" multiple (selectionChange)="getDistricts($event)">
              <mat-option *ngFor="let c of cities" [value]="c.district_name">
                {{ c.district_name }}
              </mat-option>
            </mat-select>

          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Taluka</mat-label>
            <mat-select formControlName="taluka" multiple (selectionChange)="gettalukaname($event)">
              <!-- 👈 Must have this -->
              <mat-option *ngFor="let t of talukas" [value]="t.taluka_name">
                {{ t.taluka_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Row 2 -->
        <div class="form-row">
          <!-- <mat-form-field appearance="outline" style="width: 25%;">
              <mat-label>Country</mat-label>
              <mat-select formControlName="country" (selectionChange)="getCountry1($event)">
                <mat-option *ngFor="let c of countries" [value]="c.country_name">
                  {{ c.country_name }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->

          <!-- <mat-form-field appearance="outline"  style="width: 25%; margin-left: 5%">
              <mat-label>State</mat-label>
              <mat-select formControlName="state" (selectionChange)="getState1($event)">
                <mat-option *ngFor="let c of states" [value]="c.state_name">
                  {{ c.state_name }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
          <!-- 
     <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
  <mat-label>District</mat-label>

  <mat-select formControlName="district" multiple (selectionChange)="getDistricts($event)">
    <mat-option *ngFor="let c of cities" [value]="c.district_name">
      {{ c.district_name }}
    </mat-option>
  </mat-select>

</mat-form-field>
<mat-form-field appearance="outline" style="width: 25%; margin-left: 5%">
  <mat-label>Taluka</mat-label>
  <mat-select formControlName="taluka" multiple 
              (selectionChange)="gettalukaname($event)"> <!-- 👈 Must have this -->
          <!-- <mat-option *ngFor="let t of talukas" [value]="t.taluka_name">
      {{ t.taluka_name }}
    </mat-option>
  </mat-select>
</mat-form-field>  -->
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Pincode</mat-label>
            <mat-select #mySel7 formControlName="pincode" (selectionChange)="getpincode($event)" multiple>
              <mat-option *ngFor="let option of pindcodelist" [value]="option['pincode']">
                {{ option["pincode"] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Representative Name :</mat-label>
            <mat-select #mySel1 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of contractRepName" [value]="item['name']">
                {{ item['name'] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Office Representative :</mat-label>
            <mat-select #mySel1 (selectionChange)="getofficerepname($event)" formControlName="officerepwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of contractOffRepName" [value]="item['name']">
                {{ item['name'] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Row 3 -->
        <div class="form-row">
          <!-- TALUKA -->


          <!-- PINCODE -->
          <!-- <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
  <mat-label>Pincode</mat-label>
  <mat-select #mySel7 formControlName="pincode" 
              (selectionChange)="getpincode($event)" multiple>
    <mat-option *ngFor="let option of pindcodelist" [value]="option['pincode']">
      {{ option["pincode"] }}
    </mat-option>
  </mat-select>
</mat-form-field> -->
          <!-- <mat-form-field style="margin-left: 7%; width: 30%;">
              <mat-label>Representative Name :</mat-label>
              <mat-select #mySel1 (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractRepName" [value]="item['name']">
                  {{ item['name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
             <mat-form-field style="margin-left: 3%; width: 25%;">
              <mat-label>Office Representative :</mat-label>
              <mat-select #mySel1 (selectionChange)="getofficerepname($event)" formControlName="officerepwise" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractOffRepName" [value]="item['name']">
                  {{ item['name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">

            <mat-label>Delivery Mode</mat-label>

            <mat-select formControlName="DeliveryMode" multiple (selectionChange)="onDeliveryModeChange($event.value)">

              <mat-option *ngFor="let mode of deliveryModes" [value]="mode.delivery_mode">

                {{ mode.delivery_mode }}

              </mat-option>

            </mat-select>

          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Distribution Representative</mat-label>
            <input matInput formControlName="DistributiveRep" [matAutocomplete]="autoRep" />
            <mat-autocomplete #autoRep="matAutocomplete" (optionSelected)="onRepresentativeChange($event)">
              <mat-option *ngFor="let option of filteredOptionsbook | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Distribution Mode</mat-label>

            <mat-select formControlName="DistributionMode" multiple
              (selectionChange)="onDistributionModeChange($event.value)">

              <mat-option *ngFor="let option of filteredDistributionModes" [value]="option.sub_delivery_mode">

                {{ option.sub_delivery_mode }}

              </mat-option>

            </mat-select>

          </mat-form-field>
        </div>

        <!-- Row 4 -->
        <div class="form-row">


          <!-- <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%; margin-top: 10px">
  <mat-label>Delivery Mode</mat-label>
  <mat-select formControlName="DeliveryMode"
              (selectionChange)="onDeliveryModeChange($event.value)">
    <mat-option *ngFor="let mode of deliveryModes" [value]="mode.id">
      {{ mode.delivery_mode }}
    </mat-option>
  </mat-select>
</mat-form-field> -->
          <!-- <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%; margin-top: 10px">
  <mat-label>Distribution Representative</mat-label>
  <input matInput
         formControlName="DistributiveRep"
         [matAutocomplete]="autoRep" />
  <mat-autocomplete #autoRep="matAutocomplete"
                    (optionSelected)="onRepresentativeChange($event)">
    <mat-option *ngFor="let option of filteredOptionsbook | async"
                [value]="option.name">
      {{ option.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field> 
        <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%; margin-top: 10px">
  <mat-label>Distribution Mode</mat-label>
  <mat-select formControlName="DistributionMode"
              (selectionChange)="onDistributionModeChange($event.value)">
    <mat-option *ngFor="let option of filteredDistributionModes"
                [value]="option.id">
      {{ option.sub_delivery_mode }}
    </mat-option>
  </mat-select>
</mat-form-field> -->
        </div>

        <!-- Row 5 -->
        <div class="form-row">


          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Sub Distribution Mode</mat-label>

            <mat-select formControlName="SubDistMode" multiple>
              <mat-option *ngFor="let option of filteredSubDistModes" [value]="option.sub_distribution_mode">
                {{ option.sub_distribution_mode }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Show Mobile No. in Labels</mat-label>
            <mat-select (selectionChange)="getmob_no($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Show Prati in Labels</mat-label>

            <mat-select (selectionChange)="getPrati($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Show Customer No</mat-label>
            <mat-select (selectionChange)="getIsCustomer($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field> -->
        </div>
        <div style="display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; margin-left: 3%;">

          <!-- Districtwise Posting Address Label -->
          <button *ngIf="!show_mob_no_hide" mat-raised-button color="primary"
            style="padding-top: 31px; padding-bottom: 21px;" (click)="handleAddressLabelClick()">

            Districtwise Posting Address Label
          </button>

          <button *ngIf="show_mob_no_hide" mat-raised-button color="primary" (click)="handleAddressLabelClick4()">

            Districtwise Posting Address Label
          </button>

          <!-- Brief -->
          <button mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger" color="warn"
            (click)="postingLabelBriefReport()">

            Brief
          </button>

          <!-- WITHOUT PRATI -->
          <button *ngIf="!show_prati_hide" mat-raised-button color="primary" (click)="handleAddressLabelWithoutPrati()">

            Districtwise Posting Address Label Without Prati
          </button>

          <!-- WITH PRATI -->
          <button *ngIf="show_prati_hide" mat-raised-button color="accent" (click)="handleAddressLabelWithPrati()">

            Districtwise Posting Address Label With Prati
          </button>

        </div>
      </form>

      <!-- Reports -->
      <mat-card>
        <form [formGroup]="generateform1">

          <div style="text-align: center;font-size: 2rem; margin-top: 26px;font-weight: 500;">
            Reports
          </div>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">

            <mat-label>Delivery Mode</mat-label>

            <mat-select formControlName="DeliveryMode" multiple (selectionChange)="onDeliveryModeChange($event.value)">

              <mat-option *ngFor="let mode of deliveryModes" [value]="mode.delivery_mode">

                {{ mode.delivery_mode }}

              </mat-option>

            </mat-select>

          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Distribution Representative</mat-label>
            <input matInput formControlName="DistributiveRep" [matAutocomplete]="autoRep" />
            <mat-autocomplete #autoRep="matAutocomplete" (optionSelected)="onRepresentativeChange($event)">
              <mat-option *ngFor="let option of filteredOptionsbook | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Distribution Mode</mat-label>

            <mat-select formControlName="DistributionMode" multiple
              (selectionChange)="onDistributionModeChange($event.value)">

              <mat-option *ngFor="let option of filteredDistributionModes" [value]="option.sub_delivery_mode">

                {{ option.sub_delivery_mode }}

              </mat-option>

            </mat-select>

          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Sub Distribution Mode</mat-label>

            <mat-select formControlName="SubDistMode" multiple>
              <mat-option *ngFor="let option of filteredSubDistModes" [value]="option.sub_distribution_mode">
                {{ option.sub_distribution_mode }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="form-row">
            <button mat-raised-button color="primary" style="margin-left: 8%; margin-top: 2%;"
              (click)="getDispatchlisteportStatement(true)">
              Dispatch Vitaran Report
            </button>
            <button mat-raised-button color="primary" style="margin-left: 2%; margin-top: 2%;"
              (click)="getofficelisteportStatement(true)">
              Office representative Report
            </button>
          </div>
        </form>
      </mat-card>

      <form [formGroup]="generateform1">

        <mat-card class="mt-5 pb-5">

          <div style="text-align:center;
             font-size:2rem;
             margin-top:26px;
             font-weight:500;">
            Statement
          </div>

          <div class="form-row">

            <mat-form-field appearance="outline" style="margin-left:8%;width:25%;margin-top:20px;">

              <mat-label>Select Dispatch Date</mat-label>

              <input matInput [matDatepicker]="pickerdispatch" formControlName="dispatchdate">

              <mat-datepicker-toggle matSuffix [for]="pickerdispatch">
              </mat-datepicker-toggle>

              <mat-datepicker #pickerdispatch></mat-datepicker>

            </mat-form-field>

          </div>

          <div class="form-row">

            <button mat-raised-button color="primary" style="margin-left:8%;margin-top:2%;"
              (click)="getDistrictwiseStatement(true)">
              Districtwise Statement
            </button>

            <button mat-raised-button color="warn" style="margin-left:2%;margin-top:2%;"
              (click)="getDistrictwiseStatement(false)">
              View
            </button>

            <button mat-raised-button color="primary" style="margin-left:3%;margin-top:2%;"
              (click)="getStatewiseStatement(true)">
              Statewise Statement
            </button>

            <button mat-raised-button color="warn" style="margin-left:2%;margin-top:2%;"
              (click)="getStatewiseStatement(false)">
              View
            </button>

          </div>

        </mat-card>

      </form>

      <!-- Hand Delivery -->
      <mat-card>
        <form [formGroup]="generateform1">
          <div style="text-align: center;
            font-size: 2rem;
            font-weight: 500;margin-bottom: 1rem;margin-top: 25px;padding: 20px;">Hand Delivery Statement</div>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Distribution Representative</mat-label>

            <input matInput formControlName="DistributiveRep" [matAutocomplete]="autoRep" />

            <mat-autocomplete #autoRep="matAutocomplete" (optionSelected)="onRepresentativeChange($event)">

              <mat-option *ngFor="let option of filteredOptionsbook | async" [value]="option.name">

                {{ option.name }}

              </mat-option>

            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 5%">
            <mat-label>Distribution Mode</mat-label>

            <input matInput formControlName="subdismode" [matAutocomplete]="autoSub" />

            <mat-autocomplete #autoSub="matAutocomplete"
              (optionSelected)="onDistributionModeChange1($event.option.value)">
              <mat-option *ngFor="let item of filteredSubModes" [value]="item.sub_delivery_mode">
                {{ item.sub_delivery_mode }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <!-- <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 2%">
  <mat-label>Distribution Sub Mode</mat-label>

  <input matInput formControlName="dissubmode" [matAutocomplete]="autodissubmode" />

  <mat-autocomplete autoActiveFirstOption #autodissubmode="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions16 | async"
                [value]="option.subdeliverymode">
      {{ option.subdeliverymode }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field> -->
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">

            <mat-label>Sub Distribution Mode</mat-label>

            <mat-select formControlName="SubDistMode" multiple>

              <mat-option *ngFor="let option of filteredSubDistModes" [value]="option.sub_distribution_mode">

                {{ option.sub_distribution_mode }}

              </mat-option>

            </mat-select>

          </mat-form-field>


          <div style="
    display:flex;
    flex-wrap:wrap;
    gap:10px;
    align-items:center;
    margin:20px 0;
  ">

            <!-- Dispatch Address -->
            <button mat-raised-button color="primary" (click)="handleAddressLabelClick1()">
              Dispatch Address
            </button>

            <!-- Parcel Label + View -->
            <div style="
      display:flex;
      gap:8px;
      align-items:center;
    ">

              <button mat-raised-button color="primary" (click)="handleAddressLabelClick2(true)">
                Parcel Label
              </button>

              <button mat-raised-button color="warn" (click)="handleAddressLabelClick2(false)">
                View
              </button>

            </div>

            <!-- All Distributor Copies + View -->
            <div style="
      display:flex;
      gap:8px;
      align-items:center;
    ">

              <button mat-raised-button color="primary" (click)="handDelivery(true)">
                All Distributor Copies
              </button>

              <button mat-raised-button color="warn" (click)="handDelivery(false)">
                View
              </button>

            </div>

          </div>
          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;margin-bottom: 5%;"
            (click)="handDeliveryLabel(true)">Parcel
            Label</button>
          <button mat-raised-button color="warn" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%;margin-bottom: 5%;" (click)="handDeliveryLabel(false)">view</button> -->

          <!-- <mat-form-field appearance="outline"style="width: 30%; margin-left: 2%;">
        <mat-label>Weight</mat-label>
        <input matInput type="number" formControlName="vajan">
      </mat-form-field>

      <mat-form-field appearance="outline"style="width: 30%; margin-left: 2%;">
        <mat-label>Postal Rate</mat-label>
        <input matInput type="number" formControlName="tapalrate">
      </mat-form-field> -->
          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;margin-bottom: 5%;"
            (click)="handDeliveryLabel(true)">Parcel
            Label</button>
          <button mat-raised-button color="warn" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%;margin-bottom: 5%;" (click)="handDeliveryLabel(false)">view</button> -->

        </form>
      </mat-card>



      <ng-container *ngIf="showFields" style="margin-left: 2%">
        <mat-card class="p-3" style="margin-top: 10px;">
          <button mat-raised-button color="primary" style="margin-left: 2%;width:100px"
            (click)="printJavak()">जावक</button>

          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;width:100px" (click)="printchallan()">challan</button> -->

        </mat-card>


        <div class="form-row" style="
      display: flex;
      align-items: center;
      justify-content: center; /* Centers the heading text */
      position: relative;
      background-color: #8bbdbd;
      margin-bottom: 2%;
      margin-top: 2%;
        padding: 10px 20px;
      text-align: center;
        width: 100%;
        ">

          <h2 style="color: black; margin: 0;padding: 5px;">
            Print Order
          </h2>


          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;width: 150px;" (click)="printOrder()">Print
            Order</button> -->

          <!-- Font Awesome Arrow Icon -->


          <!-- <i class="fas fa-arrow-down" *ngIf="!showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i>

        <i class="fas fa-arrow-up" *ngIf="showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i> -->

        </div>

        <button mat-raised-button color="primary" style="margin-left: 2%;width: 150px;" (click)="printOrder()">Print
          Order</button>

        <div class="form-row">
          <mat-form-field [formGroup]="generateform1" appearance="outline"
            style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Book Name</mat-label>
            <mat-select #mySel1 (selectionChange)="getbookname1($event)" formControlName="bookwise" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection1()">All</mat-option>
              <mat-option *ngFor="let item of Filteredbookdata2" [value]="item.bookname">{{ item.bookname
                }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [formGroup]="generateform1" appearance="outline"
            style="width: 30%; margin-left: 2%; margin-top: 2%;">

            <mat-label>Publish Date Range</mat-label>

            <div style="display:flex; align-items:center; gap:8px; width:100%;">

              <!-- Start Date -->
              <input matInput type="date" formControlName="start_publish_date" [min]="financialYearMin"
                [max]="financialYearMax" />

              <span style="font-weight:bold;">-</span>

              <!-- End Date -->
              <input matInput type="date" formControlName="end_publish_date" [min]="financialYearMin"
                [max]="financialYearMax" />

            </div>

          </mat-form-field>
          <mat-form-field [formGroup]="generateform1" appearance="outline"
            style="width: 30%; margin-left: 2%; margin-top: 2%;">

            <mat-label>Adesh Date</mat-label>

            <div class="date-inline">

              <input matInput type="date" formControlName="adesh_from" [min]="financialYearMin"
                [max]="financialYearMax">

              <span class="dash"> - </span>

              <input matInput type="date" formControlName="adesh_to" [min]="financialYearMin" [max]="financialYearMax">

            </div>

          </mat-form-field>

          <button mat-raised-button color="primary" (click)="applyFilters1()">
            Search
          </button>

          <!-- <mat-form-field appearance="outline"style="width: 30%; margin-left: 2%; margin-top: 5%;">
        <mat-label>Issue Date</mat-label>
        <mat-select formControlName="issue_date" multiple></mat-select>
      </mat-form-field> -->


          <!-- <mat-form-field [formGroup]="generateform1" appearance="outline"
            style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Enter Date</mat-label>

            <div class="date-inline">

              <input matInput type="date" formControlName="start_date" [min]="financialYearMin"
                [max]="financialYearMax" />

              <span class="dash"> - </span>

              <input matInput type="date" formControlName="end_date" [min]="financialYearMin" [max]="financialYearMax"
                (blur)="getBookStcokDateChanged1()" />

            </div>

          </mat-form-field> -->
          <!-- <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Book Seller प्रमाणे : </mat-label>
            <mat-select #mySel1 (selectionChange)="getbooksellerwise($event)" formControlName="booksellerwise" multiple>

              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of  book__seller__name" (onSelectionChange)="getBookSellerName($event) "
                value="{{  item['book__seller__name'] }}">{{
                item["book__seller__name"]
                }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
        </div>

        <ng-container *ngIf="showFields" style="margin-left: 2%">
          <mat-card>
            <!-- <button mat-raised-button color="primary" style="margin-left: 2%;width: 150px;" (click)="printOrder()">Print
            Order</button> -->

            <div class="tableFixHead" style="margin-top: 2%;">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>आदेश क्र</th>
                    <th>पुस्तक नाव</th>
                    <th>Print Order Date</th>
                    <th>Book Publish Date</th>
                    <th>एकूण प्रती</th>
                    <th>एकूण पृष्ठ</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>

                  <tr *ngIf="printOrderData.length === 0">
                    <td colspan="7" class="text-center">
                      No Records Found
                    </td>
                  </tr>

                  <tr *ngFor="let item of printOrderData; let i = index">

                    <td>{{ item.id }}</td>

                    <td>{{ item.book_name }}</td>

                    <td>
                      {{ item.adesh_date | date:'dd-MM-yyyy' }}
                    </td>

                    <td>
                      {{ item.publish_date | date:'dd-MM-yyyy' }}
                    </td>

                    <td>
                      {{ item.total_copies }}
                    </td>

                    <td>
                      {{ item.ekun_prushth }}
                    </td>

                    <td>

                      <button mat-icon-button type="button" class="btn-sm btn-outline-primary" matTooltip="View"
                        (click)="viewPrintOrder(item)">

                        <mat-icon>visibility</mat-icon>

                      </button>

                      <button mat-icon-button type="button" class="btn-sm btn-outline-info" matTooltip="Edit"
                        (click)="updatePrintOrder(item)">

                        <mat-icon>edit</mat-icon>

                      </button>

                    </td>

                  </tr>

                </tbody>
              </table>
            </div>
          </mat-card>

          <!-- <mat-card class="p-3" style="margin-top: 10px;">
          <button mat-raised-button color="primary" style="margin-left: 2%;width:100px"
            (click)="printJavak()">जावक</button> -->

          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;width:100px" (click)="printchallan()">challan</button> -->

          <!-- </mat-card> -->
          <!-- <mat-card class="p-3" style="margin-top: 10px;">
          <div class="row">
            <div class="col-md-4 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
                (click)="distSubReport()">Districtwise
                Subscription Report</button>
            </div>
            <div class="col-md-4 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
                (click)="distVSubReport()">Districtwise
                Varganidar
                Subscription Report</button>
            </div>
            <div class="col-md-4 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
                (click)="prantwiseReport()">Prantwise
                Report</button>
            </div>
          </div>
        </mat-card> -->
        </ng-container>
      </ng-container>

      </ng-template>
    </mat-tab>




    <mat-tab label>
      <ng-template mat-tab-label>23<br>
        Add Seller<br>Type
      </ng-template>
      <ng-template matTabContent>
      <mat-card>
        <form [formGroup]="addSellerType">
          <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%" class="example-full-width">
            <mat-label>Book Seller Type</mat-label>
            <input matInput formControlName="sellertype" />
          </mat-form-field>

          <button class="btn btn-primary" *ngIf="seller_type_update_btn == false" mat-raised-button color="primary"
            (click)="addSellerTypees()" style="margin-left: 9%; margin-right: 47%; width: 10%; margin-top: -6%;">
            Save
          </button>
          <button class="btn btn-primary" *ngIf="seller_type_update_btn == true" mat-raised-button color="primary"
            (click)="update_Seller()" style="margin-left: 9%; margin-right: 47%; width: 10%; margin-top: -6%;">
            Update
          </button>


          <!-- <button *ngIf="seller_type_update_btn == true" mat-raised-button class="btn btn-primary" color="primary"
              style="margin-left: 15%; margin-right: 35%; width: 10%;  margin-top: -6%;" (click)="update_Seller()">
              Update
            </button> -->
        </form>

        <div class="tableFixHead1" style="padding: 20px 20px;">
          <table class="table table-striped" style="width: 82% !important;">
            <thead>
              <tr>
                <th style="width: 20% !important;">Sr no</th>
                <th style="width: 50% !important;">Book Seller Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of sellerTypes; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item['sellertype'] }}</td>
                <td>
                  <button style="margin-right: 2%;" matTooltip="Delete" class="btn-sm btn-outline-info"
                    (click)="delete_seller_type(item['id'])">
                    <mat-icon>close</mat-icon>
                  </button>
                  <button style="margin-right: 2%;" matTooltip="Delete" class="btn-sm btn-outline-info"
                    (click)="update_seller_type(item)">
                    <mat-icon>edit</mat-icon>
                  </button>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>



      <mat-card>
        <form [formGroup]="addComplType">
          <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%" class="example-full-width">
            <mat-label>Complimentry Type</mat-label>
            <input matInput formControlName="comptype" />
          </mat-form-field>

          <button class="btn btn-primary" *ngIf="compl_type_update_btn == false" mat-raised-button color="primary"
            (click)="addComplTypees()" style="margin-left: 9%; margin-right: 47%; width: 10%; margin-top: -6%;">
            Save
          </button>
          <button class="btn btn-primary" *ngIf="compl_type_update_btn == true" mat-raised-button color="primary"
            (click)="update_Compl()" style="margin-left: 9%; margin-right: 47%; width: 10%; margin-top: -6%;">
            Update
          </button>
        </form>

        <div class="tableFixHead1" style="padding: 20px 20px;">
          <table class="table table-striped" style="width: 82% !important;">
            <thead>
              <tr>
                <th style="width: 20% !important;">Sr no</th>
                <th style="width: 50% !important;">Complimentry Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of compTypes; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item['comptype'] }}</td>
                <td>
                  <button style="margin-right: 2%;" matTooltip="Delete" class="btn-sm btn-outline-info"
                    (click)="delete_compl_type(item['id'])">
                    <mat-icon>close</mat-icon>
                  </button>
                  <button style="margin-right: 2%;" matTooltip="Delete" class="btn-sm btn-outline-info"
                    (click)="update_compl_type(item)">
                    <mat-icon>edit</mat-icon>
                  </button>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>



      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        24<br>
        Add Delivery Mode
      </ng-template>
      <ng-template matTabContent>

      <!-- ================= DELIVERY MODE ================= -->
      <mat-card>

        <form [formGroup]="adddeliverymode" (ngSubmit)="addDelivery()">

          <div class="row">

            <mat-form-field appearance="outline" class="w-30">
              <mat-label>Delivery Mode</mat-label>
              <input matInput formControlName="deliverymode" />
            </mat-form-field>

            <button mat-raised-button color="primary" type="submit"
              style="margin-left: 15%; margin-right: 35%; width: 20%">
              Save
            </button>

            <button *ngIf="delivery_mode_update_btn == true" mat-raised-button class="btn btn-primary" color="primary"
              style="margin-left: 15%; margin-right: 35%; width: 10%;  margin-top: -6%;"
              (click)="update_delivery_modeapi()">
              Update
            </button>

          </div>

        </form>

        <table class="table table-striped">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Delivery Mode</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of distributionmodesData1; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.delivery_mode }}</td>

              <td>
                <button style="margin-right: 2%;" matTooltip="update" class="btn-sm btn-outline-info"
                  (click)="update_delivery_mode1(item)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button matTooltip="delete" class="btn-sm btn-outline-danger" (click)="delivery_mode2(item['id'])">
                  <mat-icon>close</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      </mat-card>


      <!-- ================= SUB DELIVERY MODE ================= -->
      <mat-card>

        <form [formGroup]="adddeliverymodeform" (ngSubmit)="addSubDelivery()">

          <div class="row">

            <mat-form-field appearance="outline" style="margin-left: 7%; width: 35%">
              <mat-label>Delivery Mode</mat-label>
              <mat-select formControlName="deliverymode">
                <mat-option *ngFor="let mode of delivery_mode" [value]="mode.id">
                  {{ mode.delivery_mode }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
              <mat-label>Distribution Mode</mat-label>
              <input matInput formControlName="subdeliverymode" />
            </mat-form-field>

          </div>

          <button *ngIf="!dis_mode_show1" mat-raised-button color="primary" type="submit"
            style="margin-left: 15%; margin-right: 35%; width: 40%">
            Save
          </button>

          <button *ngIf="dis_mode_show1" mat-raised-button color="accent" type="button"
            (click)="updateaddSubDelivery()">
            Update
          </button>

        </form>

        <table class="table table-striped">
          <thead>
            <tr>
              <th>Delivery Mode</th>
              <th>Distribution Mode</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of distributionmodesData">
              <td>{{ item.delivery_mode }}</td>
              <td>{{ item.sub_delivery_mode }}</td>

              <td>
                <button mat-icon-button color="primary" (click)="updatedismode(item.id)">
                  <mat-icon>edit</mat-icon>
                </button>

                <button mat-icon-button color="warn" (click)="removedismode(item.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      </mat-card>


      <!-- ================= SUB SUB DELIVERY MODE ================= -->
      <mat-card>

        <h2 class="center">Add Distribution Mode</h2>

        <form [formGroup]="addsubdeliverymodeform" (ngSubmit)="addSubDeliveryofSub()">

          <div class="row">

            <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
              <mat-label>Distribution Mode</mat-label>
              <mat-select formControlName="deliverymode">
                <mat-option *ngFor="let mode of subDeliveryModeData" [value]="mode.id">
                  {{ mode.sub_delivery_mode }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-left: 5%; width: 35%">
              <mat-label>Sub Distribution Mode</mat-label>
              <input matInput formControlName="subdeliverymode" />
            </mat-form-field>

          </div>

          <button *ngIf="!sub_dis_mode_show" mat-raised-button color="primary" type="submit"
            style="margin-left: 15%; margin-right: 35%; width: 40%">
            Save
          </button>

          <button *ngIf="sub_dis_mode_show" mat-raised-button color="accent" type="button"
            (click)="updateaddSubDeliveryofSub()">
            Update
          </button>

        </form>

        <table class="table table-striped">
          <thead>
            <tr>
              <th>Distribution Mode</th>
              <th>Sub Distribution Mode</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of subdistributionmodesData">
              <td>{{ item.sub_delivery_mode }}</td>
              <td>{{ item.subdeliverymode }}</td>

              <td>
                <button mat-icon-button color="primary" (click)="updatesubdismode(item.id)">
                  <mat-icon>edit</mat-icon>
                </button>

                <button mat-icon-button color="warn" (click)="removesubdismode(item.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      </mat-card>

      <mat-card>
        <h1 style="text-align: center">Assign Distribution Representative</h1>
        <form [formGroup]="AssignDisRepForm">
          <div class="form-row">
            <!-- <mat-form-field appearance="outline"
                style="width: 25%; margin-left: 7%; margin-top: 10px">

  <mat-label>Distribution Representative</mat-label>

  <input matInput
         formControlName="DistributiveRep"
         [matAutocomplete]="autoRep">

  <mat-autocomplete
    #autoRep="matAutocomplete"
    (optionSelected)="onRepresentativeChange($event)">

    <mat-option *ngFor="let option of filteredOptions14 | async"
                [value]="option.name">
      {{ option.name }}
    </mat-option>

  </mat-autocomplete>

</mat-form-field> -->

            <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 5%">
              <mat-label>Distribution Representative</mat-label>
              <input matInput formControlName="disrep1" [matAutocomplete]="autodisrep" />
              <mat-autocomplete autoActiveFirstOption #autodisrep="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions14 | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 5%">
              <mat-label>Distribution Mode</mat-label>
              <input matInput formControlName="dismode" [matAutocomplete]="autodismode" />
              <mat-autocomplete autoActiveFirstOption #autodismode="matAutocomplete">
                <mat-option (onSelectionChange)="distributionMode($event, option)"
                  *ngFor="let option of filteredOptions15 | async" [value]="option['sub_delivery_mode']">
                  {{ option["sub_delivery_mode"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 2%">
              <mat-label>Distribution Sub Mode</mat-label>

              <input matInput formControlName="dissubmode" [matAutocomplete]="autodissubmode" />

              <mat-autocomplete autoActiveFirstOption #autodissubmode="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions16 | async" [value]="option.subdeliverymode">
                  {{ option.subdeliverymode }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>






          </div>
          <div class="form-group">
            <button mat-raised-button class="btn btn-primary" type="button" mat-raised-button color="primary"
              style="margin-left: 15%; margin-right: 35%; width: 40%" (click)="assignDistributionMode()">
              Save
            </button>
            <button *ngIf="dis_mode_show" mat-raised-button class="btn btn-info" type="button"
              style="margin-left: 15%; margin-right: 35%; width: 40%" (click)="updateassignDistributionMode()">
              Update
            </button>
          </div>
        </form>
      </mat-card>
      <mat-card>
        <div class="tableFixHead" style="padding: 20px 20px;" id="repListSection1">
          <!-- <div style="width: 100%; text-align: right; padding: 10px 5% 10px 0;">
            <button type="button" class="btn btn-danger" style="width: 10%;" (click)="printSection('repListSection1')">
              Print
            </button>
          </div> -->

          <table class="table table-striped text-center">
            <thead>
              <tr>
                <td>Distribution Representative</td>
                <td>Distribution Mode</td>
                <td>Distribution Sub Mode</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of distributionmoderepData">
                <td>{{ item['dis_rep'] }}</td>
                <td>{{ item['dis_mode'] }}</td>
                <td>{{ item['dis_sub_mode'] }}</td>
                <td>
                  <button style="margin-right: 2%;" matTooltip="Update" class="btn-sm btn-outline-info"
                    (click)="updateDisMode(item['id'])">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button matTooltip="Remove" class="btn-sm btn-outline-danger"
                    (click)="removeassigndismode(item['id'])">
                    <mat-icon>close</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>


      </ng-template>
    </mat-tab>
    <mat-tab>
      <!-- ===== TAB LABEL ===== -->
      <ng-template mat-tab-label>
        25<br />
        Book-store<br />
        Representative
      </ng-template>
      <ng-template matTabContent>

      <!-- ================= FILTER FORM ================= -->
      <form [formGroup]="bookrepcommision1form">

        <div class="search-row">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Representative Name</mat-label>
            <mat-select formControlName="repwise" multiple>
              <mat-option *ngFor="let item of rep_names" [value]="item.rep_name">
                {{ item.rep_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Office Representative</mat-label>
            <mat-select formControlName="officerepwise" multiple>
              <mat-option *ngFor="let item of office_rep_names" [value]="item.officerep">
                {{ item.officerep }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-raised-button color="primary" class="search-btn" type="button"
            (click)="getBookCommissionDateFilter1()">
            Search
          </button>
        </div>

      </form>

      <!-- ================= TABLE CARD ================= -->
      <mat-card>

        <!-- ===== ACTION BAR ===== -->
        <div class="action-bar noPrint">
          <button mat-raised-button color="primary" ngxPrint printSectionId="print-section-comm"
            [useExistingCss]="true">
            Print
          </button>

          <button mat-raised-button color="primary" style="margin-left: 10px"
            (click)="exportExcel3('Book-store Representative')">
            Export
          </button>
        </div>

        <!-- ===== PRINT SECTION ===== -->
        <div id="print-section-comm">
          <table class="table table-striped print-table">

            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Representative Name</th>
                <th>Representative Mobile No</th>
                <th>Representative District</th>
                <th>Office Representative</th>
                <th class="noPrint">Action</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of bookwisereplist; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.rep_name }}</td>
                <td>{{ item.rep_mob_no }}</td>
                <td>{{ item.district }}</td>
                <td>{{ item.off_rep_name }}</td>
                <td class="noPrint">
                  <button type="button" class="btn btn-info" (click)="update(item)">
                    Update
                  </button>
                </td>
              </tr>
            </tbody>

          </table>
        </div>

      </mat-card>

      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        26<br />
        Dengi Report
      </ng-template>
      <ng-template matTabContent>
      <mat-card class="expense">
        <form [formGroup]="expense">
          <h3 class="text-center" style="font-size: 25px;">DENGI REPORT</h3>
          <div class="form-row" style="margin-top: 10px;">
            <mat-form-field appearance="outline" style="margin-left: 2%; width: 15%">
              <mat-label>Start Date</mat-label>
              <input matInput type="date" formControlName="start" />
            </mat-form-field>

            <span class="date-separator" style="margin-left: 1%;margin-top: 15px;">-</span>

            <mat-form-field appearance="outline" style="margin-left: 1%;width: 15%">
              <mat-label>End Date</mat-label>
              <input matInput type="date" formControlName="end" (blur)="expenseledgerDateRange()" />
            </mat-form-field>
            <mat-form-field style="margin-left: 2%; width: 30%" class="example-full-width" appearance="outline">
              <mat-label>Select Main Expense</mat-label>
              <mat-select formControlName="expnameother" (selectionChange)="getSubExpByMainExp($event)">
                <mat-option *ngFor="let exp of mainExpData" [value]="{ id: exp['id'], source: exp['source'] }">
                  {{ exp["exp_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="subexpense" style="margin-left: 2%; width: 30%" class="example-full-width"
              appearance="outline">
              <mat-label>Select Sub Expense</mat-label>
              <mat-select formControlName="subexpnameother" (selectionChange)="getSubExpName1($event)">
                <mat-option *ngFor="let exp of subExpData" value="{{ exp['sub_id'] }}">{{ exp["sub_exp_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <button style="margin-left: 30%; width: 30%;margin-top: 20px;margin-bottom: 20px;" type="button"
              [disabled]="expense.invalid" mat-raised-button color="primary" (click)="expense_report_new()">
              Get Report
            </button>
          </div>
        </form>
      </mat-card>

      </ng-template>
    </mat-tab>




    <!-- <mat-tab label="Delivered Books">
      <mat-form-field appearance="fill" style="margin-top: 5%; margin-left: 3%">
        <mat-label>Enter a Delivery date range</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="financialYearMin"
          [max]="financialYearMax">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getChangedDate()" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
      </mat-form-field>

      <mat-form-field class="example-form-field" appearance="fill" style="margin-left: 3%">
        <mat-label>Customer Name</mat-label>
        <input matInput type="text" [(ngModel)]="cust_name_delivery"
          (ngModelChange)="getcust_name_deliveredBook($event)" />
        <button *ngIf="cust_name_delivery" matSuffix mat-icon-button aria-label="Clear"
          (click)="reset_custname_deliveredBook($event)">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      

      <table mat-table [dataSource]="FilteredDeliveryBooks" class="mat-elevation-z8">
       
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="Mobile">
          <th mat-header-cell *matHeaderCellDef>Mobile</th>
          <td mat-cell *matCellDef="let element">{{ element.mobile }}</td>
        </ng-container>

       
        <ng-container matColumnDef="Book Name">
          <th mat-header-cell *matHeaderCellDef>Book Name</th>
          <td mat-cell *matCellDef="let element">{{ element.book_name }}</td>
        </ng-container>

       
        <ng-container matColumnDef="Received Date">
          <th mat-header-cell *matHeaderCellDef>Received Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.received_date | date: "dd-MM-yyyy" }}
          </td>
        </ng-container>

        
        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">Delivered</td>
        </ng-container>

        
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element">
            <button mat-raised-button color="warn" (click)="EditDeliveredBook(element.id)">
              View
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
      </table>
    </mat-tab> -->

    <!-- <mat-tab label="Master Book Size">
      <mat-card style="margin-left: 20px; margin-right: 20px">
        <form [formGroup]="booksizeform" (ngSubmit)="addbooksize()">
          <div class="form-group">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Book Size</mat-label>
              <input matInput formControlName="booksize" />
            </mat-form-field>
            <button type="submit" mat-raised-button color="primary" style="margin-left: 5%">
              Add Book Size
            </button>
          </div>
        </form>
      </mat-card>
    </mat-tab> -->



    <!-- <mat-tab label="Master Author">
      <mat-card>
        <form [formGroup]="authorForm" (ngSubmit)="saveauthor()">
          <div class="form-row">
            <button style="margin-left: 58%; width: 25%; margin-bottom: 1%" type="button" mat-raised-button
              class="btn btn-info" (click)="getAuthorAddress()">
              Author Address
            </button>
          </div>
          <div class="form-row">
          
            <mat-form-field class="example-full-width" appearance="outline" style="width: 75%; margin-left: 8%">
              <mat-label>Author Name</mat-label>
              <input matInput formControlName="authorname" [matAutocomplete]="autoauthor" />
              <mat-autocomplete autoActiveFirstOption #autoauthor="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions11 | async" [value]="option['name']"
                  (onSelectionChange)="selected_authorname($event, option)">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 75%; margin-left: 8%">
              <mat-label>Address</mat-label>
              <textarea matInput formControlName="address"></textarea>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 8%">
              <mat-label>Pincode</mat-label>
              <input matInput formControlName="pincode" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Country</mat-label>
              <input matInput formControlName="country" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 23%; margin-left: 8%">
              <mat-label>State</mat-label>
              <input matInput formControlName="state" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 23%; margin-left: 2.7%">
              <mat-label>District</mat-label>
              <input matInput formControlName="district" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 23%; margin-left: 3%">
              <mat-label>Taluka</mat-label>
              <input matInput formControlName="taluka" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 8%">
              <mat-label>Mobile No</mat-label>
              <input matInput formControlName="mob_no" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 8%">
              <mat-label>PAN No</mat-label>
              <input matInput formControlName="pan_no" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Aadhar No</mat-label>
              <input matInput formControlName="aadhar_no" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 8%">
              <mat-label>Bank Name</mat-label>
              <input matInput formControlName="bank_name" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Branch</mat-label>
              <input matInput formControlName="branch" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 8%">
              <mat-label>Account No</mat-label>
              <input matInput type="number" formControlName="acc_no" />
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>IFSC Code</mat-label>
              <input matInput formControlName="ifsc_code" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <button *ngIf="!this.isauthor" type="submit" mat-raised-button [disabled]="authorForm.invalid"
              class="btn btn-primary" style="margin-left: 15%; margin-right: 30%; width: 50%">
              Save
            </button>
            <button *ngIf="this.isauthor" type="button" mat-raised-button [disabled]="authorForm.invalid"
              class="btn btn-info" style="margin-left: 15%; margin-right: 5%; width: 25%" (click)="updateAuthor()">
              Update
            </button>
            <button *ngIf="this.isauthor" mat-raised-button class="btn btn-danger" type="button"
              style="margin-right: 15%; width: 25%" (click)="deleteAuthorData()">
              Delete
            </button>
          </div>
        </form>
      </mat-card>
    
    </mat-tab> -->

    <!-- <mat-tab label="Book Seller Address">
      <mat-card>
        <form [formGroup]="bookselleraddressForm">
          <div class="form-row">
            <mat-form-field appearance="outline" class="example-full-width" style="width: 50%; margin-left: 5%">
              <mat-label>Book Seller Name</mat-label>
              <input matInput formControlName="bsname" [matAutocomplete]="autobsname1" />
              <mat-autocomplete autoActiveFirstOption #autobsname1="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions12 | async" [value]="option['name']"
                  (onSelectionChange)="selected_book_name($event, option)">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 50%; margin-left: 5%">
              <mat-label>Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerdate" [min]="financialYearMin" [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getAuthorDate()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerdate"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerdate></mat-date-range-picker>

              <mat-error *ngIf="
                  bookselleraddressForm.controls.start.hasError(
                    'matStartDateInvalid'
                  )
                ">Invalid start date</mat-error>
              <mat-error *ngIf="
                  bookselleraddressForm.controls.end.hasError(
                    'matEndDateInvalid'
                  )
                ">Invalid end date</mat-error>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width noPrint" appearance="outline" style="width: 50%; margin-left: 5%">
              <mat-label>Country</mat-label>
              <input matInput formControlName="country" (change)="country($event)" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width noPrint" appearance="outline" style="width: 50%; margin-left: 5%">
              <mat-label>State</mat-label>
              <input matInput formControlName="state" (change)="state($event)" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width noPrint" appearance="outline" style="width: 50%; margin-left: 5%">
              <mat-label>District</mat-label>
              <input matInput formControlName="district" (change)="district($event)" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width noPrint" appearance="outline" style="width: 50%; margin-left: 5%">
              <mat-label>Taluka</mat-label>
              <input matInput formControlName="taluka" (change)="taluka($event)" />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="width: 50%; margin-left: 5%" appearance="outline">
              <mat-label>Select Complimentary</mat-label>
              <mat-select formControlName="complimentary" (selectionChange)="isComplementaryAddress($event)">
                <mat-option value="Y">Yes</mat-option>
                <mat-option value="N">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        
          <div class="form-row">
            <button mat-raised-button class="btn btn-primary" style="margin-left: 8%; width: 15%"
              (click)="showfulladdress()">
              Full Address
            </button>
            <button mat-raised-button class="btn btn-info" style="margin-left: 5%; width: 15%"
              (click)="showlistaddress()">
              List Address
            </button>
          </div>
        </form>
      </mat-card>
      <mat-card>
        <table class="table table-striped text-center">
          <thead>
            <tr>
              <th>Book Seller Name</th>
              <th>Place</th>
              <th>Mobile No.</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of showFilteredBookSellerAddress">
              <td>{{ item["name"] }}</td>
              <td>{{ item["district"] }}</td>
              <td>{{ item["mobile_no"] }}</td>
            </tr>
          </tbody>
        </table>
      </mat-card>
    </mat-tab> -->
    <!-- 
    <mat-tab label="Dengi Report">
      <mat-card class="expense">
        <form [formGroup]="expense">
          <h3 class="text-center" style="font-size: 25px;">DENGI REPORT</h3>
          <div class="form-row" style="margin-top: 10px;">
            <mat-form-field appearance="outline" style="margin-left: 2%; width: 15%">
              <mat-label>Start Date</mat-label>
              <input matInput type="date" formControlName="start" />
            </mat-form-field>

            <span class="date-separator" style="margin-left: 1%;margin-top: 15px;">-</span>

            <mat-form-field appearance="outline" style="margin-left: 1%;width: 15%">
              <mat-label>End Date</mat-label>
              <input matInput type="date" formControlName="end" (blur)="expenseledgerDateRange()" />
            </mat-form-field>
            <mat-form-field style="margin-left: 2%; width: 30%" class="example-full-width" appearance="outline">
              <mat-label>Select Main Expense</mat-label>
              <mat-select formControlName="expnameother" (selectionChange)="getSubExpByMainExp($event)">
                <mat-option *ngFor="let exp of mainExpData" [value]="{ id: exp['id'], source: exp['source'] }">
                  {{ exp["exp_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="subexpense" style="margin-left: 2%; width: 30%" class="example-full-width"
              appearance="outline">
              <mat-label>Select Sub Expense</mat-label>
              <mat-select formControlName="subexpnameother" (selectionChange)="getSubExpName1($event)">
                <mat-option *ngFor="let exp of subExpData" value="{{ exp['sub_id'] }}">{{ exp["sub_exp_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <button style="margin-left: 30%; width: 30%;margin-top: 20px;margin-bottom: 20px;" type="button"
              [disabled]="expense.invalid" mat-raised-button color="primary" (click)="expense_report_new()">
              Get Report
            </button>
          </div>
        </form>
      </mat-card>

    </mat-tab> -->

    <mat-tab label=" Granth Posting Label & Statement">
      <ng-template matTabContent>

      <form [formGroup]="generateform">

        <!-- Row 1 -->
        <div class="form-row">
          <mat-form-field style="margin-left: 2%; margin-top: 5%; width: 30%" appearance="outline">
            <mat-label>Issue/grantha : </mat-label>
            <mat-select (selectionChange)="getIssues($event)" required formControlName="issueCatregoryId">
              <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                {{ item.category }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 5%;">
            <mat-label>Issue Date</mat-label>
            <mat-select formControlName="issue_date" multiple>
              <mat-option *ngFor="let item of filteredIssueDates" [value]="item.id">
                {{ item.issueName }} - {{ item.issueDate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%;margin-top: 5%;">
            <mat-label>Date Range</mat-label>
            <mat-date-range-input>
              <input matStartDate formControlName="start">
              <input matEndDate formControlName="end">
            </mat-date-range-input>
          </mat-form-field>
        </div>

        <!-- Row 2 -->
        <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
          <mat-label>Country</mat-label>
          <mat-select formControlName="country" (selectionChange)="getCountry1($event)">
            <mat-option *ngFor="let c of countries" [value]="c.country_name">
              {{ c.country_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
          <mat-label>State</mat-label>
          <mat-select formControlName="state" (selectionChange)="getState1($event)">
            <mat-option *ngFor="let c of states" [value]="c.state_name">
              {{ c.state_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field" style="width: 30%; margin-left: 2%; margin-top: 2%;">
          <mat-label>District</mat-label>
          <mat-select formControlName="district" multiple (selectionChange)="getDistricts($event)">
            <mat-option *ngFor="let c of cities" [value]="c.district_name">
              {{ c.district_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
          <mat-label>Taluka</mat-label>
          <mat-select formControlName="taluka" multiple (selectionChange)="gettalukaname($event)">
            <mat-option *ngFor="let t of talukas" [value]="t.taluka_name">
              {{ t.taluka_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
          <mat-label>Pincode</mat-label>
          <mat-select #granthPincodeSel formControlName="pincode" (selectionChange)="getpincode($event)" multiple>
            <mat-option *ngFor="let option of pindcodelist" [value]="option['pincode']">
              {{ option["pincode"] }}
            </mat-option>
          </mat-select>
          <button *ngIf="pincodes" matSuffix mat-icon-button aria-label="Clear" (click)="reset_pincodes()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
          <mat-label>Representative Name : </mat-label>
          <mat-select #granthRepSel (selectionChange)="getrepwise($event)" formControlName="repwise" multiple>
            <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
            <mat-option *ngFor="let item of rep_names" value="{{ item['rep_name'] }}">{{ item["rep_name"]
              }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Office Representative -->
        <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
          <mat-label>Office Representative : </mat-label>
          <mat-select #granthOfficeRepSel (selectionChange)="getofficerepname($event)" formControlName="officerepwise"
            multiple>
            <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
            <mat-option *ngFor="let item of office_rep_names" value="{{ item['officerep'] }}">{{ item["officerep"]
              }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Row 4 -->
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
            <mat-label>Delivery Mode</mat-label>
            <mat-select #granthDeliveryModeSel formControlName="DeliveryMode" multiple
              (selectionChange)="onDeliveryModeChange1($event.value)">
              <mat-option value="all" (click)="toggleAllSelectionpl()"> All </mat-option>
              <mat-option *ngFor="let rep of delivery_mode" [value]="rep.delivery_mode"> {{ rep.delivery_mode }}
              </mat-option>
            </mat-select>
            <button *ngIf="selectedModes?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetDeliveryModes1()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <!-- Distribution Representative -->
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
            <mat-label>Distribution Representative</mat-label>
            <input matInput formControlName="DistributiveRep" [matAutocomplete]="granthAutoDist" />
            <mat-autocomplete autoActiveFirstOption #granthAutoDist="matAutocomplete">
              <mat-option (onSelectionChange)="distribution($event, option)"
                *ngFor="let option of filteredOptionsdist | async" [value]="option['name']">
                {{ option["name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <!-- Distribution Mode -->
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
            <mat-label>Distribution Mode</mat-label>
            <mat-select #granthDistModeSel formControlName="DistributionMode" multiple
              (selectionChange)="onDeliveryModeChange3($event.value)">
              <mat-option value="all" (click)="toggleAllSelectiondpl($event)">All</mat-option>
              <mat-option *ngFor="let option of filteredOptions7 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Sub Distribution Mode -->
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
            <mat-label>Sub Distribution Mode</mat-label>
            <mat-select #granthSubDistModeSel formControlName="SubDistMode" multiple>
              <mat-option (click)="toggleAllSelectionspl($event)">All</mat-option>
              <mat-option *ngFor="let option of filteredOptions28 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>
            <button *ngIf="selectedModes?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetsubDeliveryModes1()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Show Mobile No. in Labels</mat-label>
            <mat-select (selectionChange)="getmob_no($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Show Prati in Labels</mat-label>
            <mat-select (selectionChange)="getPrati($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field>

          <div style="display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; margin-left: 3%;">
            <!-- Districtwise Posting Address Label -->
            <button *ngIf="!show_mob_no_hide" mat-raised-button color="primary"
              style="padding-top: 31px; padding-bottom: 21px;" (click)="handleAddressLabelClickgranth()">
              Districtwise Posting Address Label
            </button>

            <button *ngIf="show_mob_no_hide" mat-raised-button color="primary"
              (click)="handleAddressLabelClickgranth1()">
              Districtwise Posting Address Label
            </button>

            <!-- Brief -->
            <button mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger" color="warn"
              (click)="postingLabelBriefReportgranth()">
              Brief
            </button>

            <!-- WITHOUT PRATI -->
            <button *ngIf="!show_prati_hide" mat-raised-button color="primary"
              (click)="handleAddressLabelWithoutPratigranth()">
              Districtwise Posting Address Label Without Prati
            </button>

            <!-- WITH PRATI -->
            <button *ngIf="show_prati_hide" mat-raised-button color="accent"
              (click)="handleAddressLabelWithPratigranth()">
              Districtwise Posting Address Label With Prati
            </button>
          </div>
        </div>
      </form>

      <!-- Reports -->
      <mat-card>
        <form [formGroup]="dispatchissueForm">
          <div style="text-align: center;font-size: 2rem; margin-top: 26px;font-weight: 500;">
            Reports
          </div>

          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
            <mat-label>Delivery Mode</mat-label>
            <mat-select #granthReportDeliveryModeSel formControlName="DeliveryMode" multiple
              (selectionChange)="onDeliveryModeChange1($event.value)">
              <mat-option value="all" (click)="toggleAllSelectionpl()"> All </mat-option>
              <mat-option *ngFor="let rep of delivery_mode" [value]="rep.delivery_mode"> {{ rep.delivery_mode }}
              </mat-option>
            </mat-select>
            <button *ngIf="selectedModes?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetDeliveryModes1()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <!-- Distribution Representative -->
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
            <mat-label>Distribution Representative</mat-label>
            <input matInput formControlName="DistributiveRep" [matAutocomplete]="granthReportAutoDist" />
            <mat-autocomplete autoActiveFirstOption #granthReportAutoDist="matAutocomplete">
              <mat-option (onSelectionChange)="distribution($event, option)"
                *ngFor="let option of filteredOptionsdist | async" [value]="option['name']">
                {{ option["name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <!-- Distribution Mode -->
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
            <mat-label>Distribution Mode</mat-label>
            <mat-select #granthReportDistModeSel formControlName="DistributionMode" multiple
              (selectionChange)="onDeliveryModeChange3($event.value)">
              <mat-option value="all" (click)="toggleAllSelectiondpl($event)">All</mat-option>
              <mat-option *ngFor="let option of filteredOptions7 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Sub Distribution Mode -->
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
            <mat-label>Sub Distribution Mode</mat-label>
            <mat-select #granthReportSubDistModeSel formControlName="SubDistMode" multiple>
              <mat-option (click)="toggleAllSelectionspl($event)">All</mat-option>
              <mat-option *ngFor="let option of filteredOptions28 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>
            <button *ngIf="selectedModes?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetsubDeliveryModes1()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <div class="form-row">
            <button mat-raised-button color="primary" style="margin-left: 8%; margin-top: 2%;"
              (click)="getDispatchlisteportStatementgranth(true)">
              Dispatch Vitaran Report
            </button>
            <button mat-raised-button color="primary" style="margin-left: 2%; margin-top: 2%;"
              (click)="getofficelisteportStatementgranth(true)">
              Office representative Report
            </button>
          </div>
        </form>
      </mat-card>

      <!-- Hand Delivery -->
      <mat-card>
        <form [formGroup]="generateform">
          <div style="text-align: center;
            font-size: 2rem;
            font-weight: 500;margin-bottom: 1rem;margin-top: 25px;padding: 20px;">Hand Delivery Statement</div>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">
            <mat-label>Distribution Representative</mat-label>

            <input matInput formControlName="DistributiveRep" [matAutocomplete]="autoRep" />

            <mat-autocomplete #autoRep="matAutocomplete" (optionSelected)="onRepresentativeChange($event)">

              <mat-option *ngFor="let option of filteredOptionsbook | async" [value]="option.name">

                {{ option.name }}

              </mat-option>

            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 5%">
            <mat-label>Distribution Mode</mat-label>

            <input matInput formControlName="subdismode" [matAutocomplete]="autoSub" />

            <mat-autocomplete #autoSub="matAutocomplete"
              (optionSelected)="onDistributionModeChange1($event.option.value)">
              <mat-option *ngFor="let item of filteredSubModes" [value]="item.sub_delivery_mode">
                {{ item.sub_delivery_mode }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <!-- <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 2%">
  <mat-label>Distribution Sub Mode</mat-label>

  <input matInput formControlName="dissubmode" [matAutocomplete]="autodissubmode" />

  <mat-autocomplete autoActiveFirstOption #autodissubmode="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions16 | async"
                [value]="option.subdeliverymode">
      {{ option.subdeliverymode }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field> -->
          <mat-form-field appearance="outline" style="width: 30%; margin-left: 2%; margin-top: 2%;">

            <mat-label>Sub Distribution Mode</mat-label>

            <mat-select formControlName="SubDistMode" multiple>

              <mat-option *ngFor="let option of filteredSubDistModes" [value]="option.sub_distribution_mode">

                {{ option.sub_distribution_mode }}

              </mat-option>

            </mat-select>

          </mat-form-field>


          <div style="
    display:flex;
    flex-wrap:wrap;
    gap:10px;
    align-items:center;
    margin:20px 0;
  ">

            <!-- Dispatch Address -->
            <button mat-raised-button color="primary" (click)="handleAddressLabelClickgranthdis()">
              Dispatch Address
            </button>



          </div>
          <div style="
      display:flex;
      gap:8px;
      align-items:center;
    ">

            <button mat-raised-button color="primary" (click)="handleAddressLabelClickgranthparcel(true)">
              Parcel Label
            </button>

            <button mat-raised-button color="warn" (click)="handleAddressLabelClickgranthparcel(false)">
              View
            </button>

          </div>


          <!-- All Distributor Copies + View -->
          <div style="
      display:flex;
      gap:8px;
      align-items:center;
    ">

            <button mat-raised-button color="primary" (click)="handDeliverygranth(true)">
              All Distributor Copies
            </button>

            <button mat-raised-button color="warn" (click)="handDeliverygranth(false)">
              View
            </button>

          </div>
          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;margin-bottom: 5%;"
            (click)="handDeliveryLabel(true)">Parcel
            Label</button>
          <button mat-raised-button color="warn" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%;margin-bottom: 5%;" (click)="handDeliveryLabel(false)">view</button> -->

          <!-- <mat-form-field appearance="outline"style="width: 30%; margin-left: 2%;">
        <mat-label>Weight</mat-label>
        <input matInput type="number" formControlName="vajan">
      </mat-form-field>

      <mat-form-field appearance="outline"style="width: 30%; margin-left: 2%;">
        <mat-label>Postal Rate</mat-label>
        <input matInput type="number" formControlName="tapalrate">
      </mat-form-field> -->
          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;margin-bottom: 5%;"
            (click)="handDeliveryLabel(true)">Parcel
            Label</button>
          <button mat-raised-button color="warn" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%;margin-bottom: 5%;" (click)="handDeliveryLabel(false)">view</button> -->

        </form>
      </mat-card>

      <ng-container *ngIf="showFields" style="margin-left: 2%">



        <div class="form-row" style="
      display: flex;
      align-items: center;
      justify-content: center; /* Centers the heading text */
      position: relative;
      background-color: #8bbdbd;
      margin-bottom: 2%;
      margin-top: 2%;
        padding: 10px 20px;
      text-align: center;
        width: 100%;
        ">

          <h2 style="color: black; margin: 0;padding: 5px;">
            Print Order
          </h2>


          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;width: 150px;" (click)="printOrder()">Print
            Order</button> -->

          <!-- Font Awesome Arrow Icon -->


          <!-- <i class="fas fa-arrow-down" *ngIf="!showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i>

        <i class="fas fa-arrow-up" *ngIf="showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i> -->

        </div>

        <button mat-raised-button color="primary" style="margin-left: 2%;width: 150px;"
          (click)="printOrdergranth()">Print
          Order</button>

        <div class="form-row">

        </div>

        <ng-container *ngIf="showFields" style="margin-left: 2%">
          <mat-card>
            <!-- <button mat-raised-button color="primary" style="margin-left: 2%;width: 150px;" (click)="printOrder()">Print
            Order</button> -->

            <div class="tableFixHead" style="margin-top: 2%;">
              <table class="table table-bordered">

                <thead>
                  <tr>
                    <th>अ.क्र.</th>
                    <th>आदेश क्र</th>
                    <th>पुस्तक नाव</th>
                    <th>Print Order Date</th>
                    <th>Book Publish Date</th>
                    <th>एकूण प्रती</th>
                    <th>एकूण पृष्ठ</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>



                  <tr *ngFor="let item of printOrderDatagranth; let i=index">

                    <td>
                      {{ i + 1 }}
                    </td>

                    <td>
                      {{item.id}}
                    </td>

                    <td>
                      {{item.book_name}}
                    </td>

                    <td>
                      {{item.adesh_date | date:'dd-MM-yyyy'}}
                    </td>

                    <td>
                      {{item.publish_date | date:'dd-MM-yyyy'}}
                    </td>

                    <td>
                      {{item.total_copies}}
                    </td>

                    <td>
                      {{item.ekun_prushth}}
                    </td>

                    <td>

                      <button mat-icon-button color="primary" matTooltip="View" (click)="viewPrintOrdergranth(item)">
                        <mat-icon>visibility</mat-icon>
                      </button>

                      <button mat-icon-button color="accent" matTooltip="Edit">
                        <mat-icon>edit</mat-icon>
                      </button>

                    </td>

                  </tr>

                </tbody>

              </table>
            </div>
          </mat-card>

          <!-- <mat-card class="p-3" style="margin-top: 10px;">
          <button mat-raised-button color="primary" style="margin-left: 2%;width:100px"
            (click)="printJavak()">जावक</button> -->

          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;width:100px" (click)="printchallan()">challan</button> -->

          <!-- </mat-card> -->
          <!-- <mat-card class="p-3" style="margin-top: 10px;">
          <div class="row">
            <div class="col-md-4 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
                (click)="distSubReport()">Districtwise
                Subscription Report</button>
            </div>
            <div class="col-md-4 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
                (click)="distVSubReport()">Districtwise
                Varganidar
                Subscription Report</button>
            </div>
            <div class="col-md-4 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
                (click)="prantwiseReport()">Prantwise
                Report</button>
            </div>
          </div>
        </mat-card> -->
        </ng-container>
      </ng-container>

      </ng-template>
    </mat-tab>



  </mat-tab-group>
</div>